<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
        {
          "num_cand": "U2FsdGVkX18iSDYcAbIF+Knmn2G8fvl4j7/KFckBFDQ=",
          "cpf": "U2FsdGVkX1/Us7TPJa78KaYwmJd6p9DLiPbWTtbEnig="
        }, {
          "num_cand": "U2FsdGVkX1+XZlSb34CRyQwh2Omy/02mZqkz5v39q+Y=",
          "cpf": "U2FsdGVkX18fPdu7FsSBo3TD4DBLVdqzRWfNOyZOvc0="
        }, {
          "num_cand": "U2FsdGVkX1+6i6b1gfOFNjdab2gNAxUPi9TvZWF7wRs=",
          "cpf": "U2FsdGVkX18X6U5BIjAeyCI11/fSFlDEHAMs5K59Gg4="
        }, {
          "num_cand": "U2FsdGVkX18RN6hv/i5WbAJJByKF4xVWDHJGxglw1lA=",
          "cpf": "U2FsdGVkX1+OtwtM9zs+dSIOCDD+XAKaiusffRktS7I="
        }, {
          "num_cand": "U2FsdGVkX1+/v+xmjW8uq8m9j5U0nwRrFKZQM1JjEXQ=",
          "cpf": "U2FsdGVkX1/XizQNTigebVN3bX0ZvwcBUnBzARB5a8o="
        }, {
          "num_cand": "U2FsdGVkX198kU6xvd608t+UloZ1svHaIirXy024nvw=",
          "cpf": "U2FsdGVkX1/oyP0Pj7K4yC0eLVAlS8g3eI3F4Ae1YHI="
        }, {
          "num_cand": "U2FsdGVkX19XNlSXdnqClO4CM2xvRYe8Bku4dQ2y0l8=",
          "cpf": "U2FsdGVkX1+yOGsYZ/nq6sCKfSV2YfpbtQrdkyWVXCI="
        }, {
          "num_cand": "U2FsdGVkX1+1kyUl/8MRvT1613z9XRKcOioPkISLTBY=",
          "cpf": "U2FsdGVkX18fQBSh6dZm7mUxtZkHTOcyIOwyJaKOvsM="
        }, {
          "num_cand": "U2FsdGVkX1/IxlzA9klyQ1f5dws2Sepl8B7Jtrgcizo=",
          "cpf": "U2FsdGVkX18wfXfbnJ7U9Wbj6cJbk/JM58daRRkewUY="
        }, {
          "num_cand": "U2FsdGVkX1+UopuSTYx3o5fLAWq1X/wNjxsTSWThq4U=",
          "cpf": "U2FsdGVkX1+aVyGbyOKUIKlwCaOAPMNBe3yASLoGmaI="
        }, {
          "num_cand": "U2FsdGVkX19tC3KQTmxrc9FszGYlkGYGhdfOZxK8S0I=",
          "cpf": "U2FsdGVkX1/aZKZowRqIVsbx5BcJR21Fym6bWzCGrbA="
        }, {
          "num_cand": "U2FsdGVkX19vNV3rwQxghpi4EjusnC2S+6u5l9+H2OQ=",
          "cpf": "U2FsdGVkX19tG/JW4J7L4uG3zZOVHH+UqiLgjg4qqf8="
        }, {
          "num_cand": "U2FsdGVkX19yTpGrmvzTH7RbY62/Zey1T8sRbuy3dOw=",
          "cpf": "U2FsdGVkX186q+ntvrZaUzKnaWSJALZFuWvFvWOWodI="
        }, {
          "num_cand": "U2FsdGVkX1+AtQynE3LOQ/HfQasgl6DPLABOrgRI/rA=",
          "cpf": "U2FsdGVkX1/sTx5msUKZcazPzknGbfRFfeX6qjtC1CY="
        }, {
          "num_cand": "U2FsdGVkX1+FVWeWK+oC53DynefNrEfrD+GXBPt4fig=",
          "cpf": "U2FsdGVkX18eok1Ih+L5JmdZkmtcYBCJH1hbdwC04rc="
        }, {
          "num_cand": "U2FsdGVkX18W1im2CwCpRQ22kTo6sCYdkGa735aghZo=",
          "cpf": "U2FsdGVkX18NG3IBdzjBD8Qa6pJzhPICzHUKfrov3ME="
        }, {
          "num_cand": "U2FsdGVkX19HBWaDwRzCKe2kB5sf+CJhTZkPzXwrumg=",
          "cpf": "U2FsdGVkX1/fXW1Rv/8/DlqqZshXvpCstlHIevfpDbk="
        }, {
          "num_cand": "U2FsdGVkX18EjwSVyD7RwnpboF2yIXIUN7bapFQWYu8=",
          "cpf": "U2FsdGVkX1/uwV/rrcAw7/Z5tBM8EgDUI4q4CrvjfGs="
        }, {
          "num_cand": "U2FsdGVkX19cUO7cNvp4mlazpKHDerIMX1p7h18B7nQ=",
          "cpf": "U2FsdGVkX1/Z2tNIcLdKM13MxOaXhpxgifF92dNuodY="
        }, {
          "num_cand": "U2FsdGVkX1/+4tGpcneEEhFFbJSr0Xzf/RJC0uhuseQ=",
          "cpf": "U2FsdGVkX1/eW2biBtigqnvwHMUeHgQsH/pkkYGUjoE="
        }, {
          "num_cand": "U2FsdGVkX19IqTMM02xXGLxCk+OqyEHh+800oN4m8sw=",
          "cpf": "U2FsdGVkX1/mRWTukroFs6aTHGxX0II73F4Io1Xd8tg="
        }, {
          "num_cand": "U2FsdGVkX1/uTopyhQO9DyAw5wVd9uUw7WUPym2L62g=",
          "cpf": "U2FsdGVkX1+hlTOoL4HwUKBBoVSPLnpSPdw5d7kAmiY="
        }, {
          "num_cand": "U2FsdGVkX18KPRhLjYn9/p5Sa8v83LqiAoUrMi5sdVQ=",
          "cpf": "U2FsdGVkX18NVazvRw4J7+JKWHRU1mGegOshiBMmXHc="
        }, {
          "num_cand": "U2FsdGVkX1/PhfmERW4qWiXbWijHAW8ZuREZZJTSZDU=",
          "cpf": "U2FsdGVkX184ZtCbhjej0eeWb2zP6/Ex7cdVUP+8uQ4="
        }, {
          "num_cand": "U2FsdGVkX19bbY/WIoqOPNley6voRYO5Ldkk2lHcJD4=",
          "cpf": "U2FsdGVkX19SZ+APBdO1zEC0CpwlKhQIgJ/OUAeksfA="
        }, {
          "num_cand": "U2FsdGVkX18nlzOXWwc0Gs6tPEDRVwxYSqK5KgjrF0o=",
          "cpf": "U2FsdGVkX182E5K2K/3XvTFzlOi/TApGwIHK7qwvxAU="
        }, {
          "num_cand": "U2FsdGVkX188+Bp4fR2YUahllXWHITrELpG4pREMEdo=",
          "cpf": "U2FsdGVkX18IIB75GRQupxUlsn8qGNY0PPLoAJQdZZU="
        }, {
          "num_cand": "U2FsdGVkX1/Jqxwwn0R+7geRFXy6LA1cqi5YhVnZitM=",
          "cpf": "U2FsdGVkX18hJd+T8SyVe4f4ZoLJP0lqjMVb8rRkq1k="
        }, {
          "num_cand": "U2FsdGVkX1/2yC9/1bqpBZuZ/eaWlEP2+tjMia3Y31A=",
          "cpf": "U2FsdGVkX1+5T46Youq7679FPaAbpJ/uf3ugTqY3Azg="
        }, {
          "num_cand": "U2FsdGVkX1+grBaoeVnkGDvdhyRcRXD1DOHFSpmmLhI=",
          "cpf": "U2FsdGVkX1/x69bxyr8XnEyEOyGzOHPnOdiDuejTEHk="
        }, {
          "num_cand": "U2FsdGVkX19Rf6g4QloJH0y6XRYlk7+uZOoQkD7d75E=",
          "cpf": "U2FsdGVkX19ZhYF7VIWXmVRjK2p46Fs3YEnb06vDzjM="
        }, {
          "num_cand": "U2FsdGVkX18nstEH70F3SeDtH9CaHd8k8r8YeTlsqSA=",
          "cpf": "U2FsdGVkX1/L5TMXaXkrp5Y0uRiHecFBccE0X8O8ut4="
        }, {
          "num_cand": "U2FsdGVkX19WC1aRZAJd8a4MZJcImnk80r3dpMtCDJo=",
          "cpf": "U2FsdGVkX1/iQwYgF8v7qBJyNePYht0wr8zNTEdeymk="
        }, {
          "num_cand": "U2FsdGVkX18UySX0nd17YSOOZGdaleKtU6Z1XDzvGYU=",
          "cpf": "U2FsdGVkX19JB1ad4RVxIuVIumNW5uoAlGDq/XDutUk="
        }, {
          "num_cand": "U2FsdGVkX19v1YTOMVnGB/Qph67CkBEpsb5FEOTgL/c=",
          "cpf": "U2FsdGVkX1/ygyqTowijbI/7cmj64HAsT3nSsxOzu3Y="
        }, {
          "num_cand": "U2FsdGVkX181pwBSpZz5z5R24B2fEpRuH5OGWAdM4ZA=",
          "cpf": "U2FsdGVkX1+aPew+ZVyLfkkLR/U35Wt6K+jyexn4IJs="
        }, {
          "num_cand": "U2FsdGVkX1+A/FFQpQh6cxgpRMffkt623ULH4ob9gu4=",
          "cpf": "U2FsdGVkX195kbBfTDZ5SjpmVUPDdYSIAlgrdu1Orbo="
        }, {
          "num_cand": "U2FsdGVkX1/wfgwEJ6YiESAexhc9dORA/TlgKvIWZ1k=",
          "cpf": "U2FsdGVkX18GenS9yVsPLp2w3pM2TRNDfWUI3PmEhvg="
        }, {
          "num_cand": "U2FsdGVkX18P87ubga6xwtvhyGjQASJZrBZlrryjCo0=",
          "cpf": "U2FsdGVkX1/9dCkTZW29iZtgmg+5GBLSaUrTKZThqVA="
        }, {
          "num_cand": "U2FsdGVkX18RU7/mQWDDqKiaK5+RrsvS2DlAE8syN9U=",
          "cpf": "U2FsdGVkX1/P8AKoBtO/9S4e+jVm3H+IYZhw4crHBT8="
        }, {
          "num_cand": "U2FsdGVkX19KrEPXWuanug7qALgh0gOBxTXal2XLDUs=",
          "cpf": "U2FsdGVkX1+zEmYdcPBu+cTrY4IrdZIsAjgKmemVWX0="
        }, {
          "num_cand": "U2FsdGVkX18Y82GjUidQFyc3z9CAZ3LB9HF/Q+V7Z9c=",
          "cpf": "U2FsdGVkX19oPlzUr3yNyGN1yYAilaaPA2+1nRXnE6w="
        }, {
          "num_cand": "U2FsdGVkX1/zSUFXSZNbjuCEy3n1TKpl3Cznidh7GRo=",
          "cpf": "U2FsdGVkX1/KX/Jp3bMFw97GIlpNpvHGcYhlG3zfr1I="
        }, {
          "num_cand": "U2FsdGVkX1/JIpeX9Amc4JjRssat9jjaWp6fVOnYKoQ=",
          "cpf": "U2FsdGVkX19y77QCBS+CKU/hmfvNQJuvgy6C//8Jars="
        }, {
          "num_cand": "U2FsdGVkX19Kr9CsKgMJQKnnsuUUI20J059vIq8neLY=",
          "cpf": "U2FsdGVkX1+ugg9zVpQTsWA/XfNuhagR031qDMlNAVE="
        }, {
          "num_cand": "U2FsdGVkX1/qUOVEd4/Qd/RXuvR0p7N8I5rDM3j7Sgo=",
          "cpf": "U2FsdGVkX19OIEeQGADKkcsPG2KYY1up4FlqqnYn/Pk="
        }, {
          "num_cand": "U2FsdGVkX1+b3/kom41+5iSGAK5CRyxU0ZvUYDZ1D2A=",
          "cpf": "U2FsdGVkX1+6YV9B3I8+EjlALiM+qFyCTfw6m82WOSM="
        }, {
          "num_cand": "U2FsdGVkX19JD6f8YJVJGdHy9H7QQgi1ia6rEGJMprA=",
          "cpf": "U2FsdGVkX1/Ef5L2kWnpA/PpLvHszomrYEi6wq2nS9M="
        }, {
          "num_cand": "U2FsdGVkX19wYqX1G5YmCi+MU+dmpyWtmuz5642pn1c=",
          "cpf": "U2FsdGVkX1/fjZjNpxfI7cPWhH4Wuz6glA+t2uDRne4="
        }, {
          "num_cand": "U2FsdGVkX18c57ymm0L3AaIs1bWQuUVDqMtxvSqM/lA=",
          "cpf": "U2FsdGVkX19aaWpfiuQLMl/3F+RwamZs/dAoBxCXE7U="
        }, {
          "num_cand": "U2FsdGVkX18kG8ikMM3FYlKzFItyLzfGHtfMRjLF5pY=",
          "cpf": "U2FsdGVkX1/I9LK+w5SdIuZ058cf673EdD61o/XYbtc="
        }, {
          "num_cand": "U2FsdGVkX1/Autw1vbPCygwnpdnnFnIxvsJRow9O/Tg=",
          "cpf": "U2FsdGVkX1+sajYxy/5ipfZfPSdhtVcxjDACpScGdkE="
        }, {
          "num_cand": "U2FsdGVkX193yXSuHB/s4VqOC+vJ/IUIXbFP6vCJFoM=",
          "cpf": "U2FsdGVkX18zO321WkC3mxodlY+lKoL/rCJw2qzJ/Wo="
        }, {
          "num_cand": "U2FsdGVkX19zN8P5vgPi6A3QscMW1U3rZRtZsUwX69U=",
          "cpf": "U2FsdGVkX18VI6u4TVK8HFqe/pNVX1umfuzyNpuLS8I="
        }, {
          "num_cand": "U2FsdGVkX19iFLxxPJ1xgas3io4+zJUhIkC06ZRk/Fg=",
          "cpf": "U2FsdGVkX1+XOaInyxTdu+q8Yrsi94p28skyXDUHT9E="
        }, {
          "num_cand": "U2FsdGVkX1/FyVdyEDQ1sIaZx17Ea1lz8+bctXz2Mng=",
          "cpf": "U2FsdGVkX18rSJL3fzL8foQWddEAJoP6xxVAs0xX24w="
        }, {
          "num_cand": "U2FsdGVkX19hWjgyVyLMGcE68hbZ6REKPS7G5ZqoLOg=",
          "cpf": "U2FsdGVkX1+Ddaa9snVpA3eraKVXI++rdXW6r/Wn1cY="
        }, {
          "num_cand": "U2FsdGVkX19E+ZEwaPbaLw+VWHih9V9kZdg3tHTRoOw=",
          "cpf": "U2FsdGVkX1/jliNvLwJrnNkqAycOpKubXizgDzYllJA="
        }, {
          "num_cand": "U2FsdGVkX1/AOqj+FLws/jvh7ltgHMwe6Cscl3VVNJY=",
          "cpf": "U2FsdGVkX19+F61wP3bYvP0NG/JKiKyPFhkgpnaRyhQ="
        }, {
          "num_cand": "U2FsdGVkX1+dIVg9cLqNrkz7UxG3CsghuBS3Si1sN4U=",
          "cpf": "U2FsdGVkX1/XC9ad/TPdf/k13b9zyvxnJt/9gWXgUMw="
        }, {
          "num_cand": "U2FsdGVkX1++0JkzU7diJj/57NLriHjIfkvhI3zH07U=",
          "cpf": "U2FsdGVkX1//3veBJ3WGfhVGsA+WcrbWx3dLQKbf3Cs="
        }, {
          "num_cand": "U2FsdGVkX18CZ9KsKR/4lhhkFbWZnGySRPTdEeo66d4=",
          "cpf": "U2FsdGVkX1/3w78RGCvUjkV3oDAuj21NPnAdvx3yxPE="
        }, {
          "num_cand": "U2FsdGVkX19Q1NuKLkBvOPY985S8B2Ar+OezuEFEnKs=",
          "cpf": "U2FsdGVkX19bwi+BZ2MJYyBMHhw0TjmuDYmLQljqOb4="
        }, {
          "num_cand": "U2FsdGVkX193wPJaETgUaSImi9YDWwK29zSm6XMqPrA=",
          "cpf": "U2FsdGVkX19iTAwj2pO4Zk86Gr9sIm1PK2W3UpSMRfI="
        }, {
          "num_cand": "U2FsdGVkX18YkKf0v1+8+1m73V5S7fMbRTXM6db3rks=",
          "cpf": "U2FsdGVkX1/BqV/4w8ycgap+dANW0eI3RPPDdN5oQJU="
        }, {
          "num_cand": "U2FsdGVkX1/WMrWoDJW2TEaAM/jBzpaZJngKFRt5XU4=",
          "cpf": "U2FsdGVkX1+3MY2yaWifFpx0FA+D65ZxbKBN3bPvHkM="
        }, {
          "num_cand": "U2FsdGVkX18BUsWQfJrHUti+1vaSEvRbEbCI1WfvBjo=",
          "cpf": "U2FsdGVkX1+19mkgWTipeMidB7R8tpfNXs40bBg9fG0="
        }, {
          "num_cand": "U2FsdGVkX19rzKmqxTbKGSW1+OGcIcfm3IvJOw5lTSA=",
          "cpf": "U2FsdGVkX1+boC2PpUrADEqWIz8Olgazo16h1nG4LIc="
        }, {
          "num_cand": "U2FsdGVkX18C1iDaNotlJYOYD8wZxmLSgpmzePn63Sw=",
          "cpf": "U2FsdGVkX1+vpOoq4/zdKzSl9etZY3k0bru6r20QYRM="
        }, {
          "num_cand": "U2FsdGVkX19WLMt+Of30wp3IqSqybjots0hug/HHkpU=",
          "cpf": "U2FsdGVkX191WpjuAyNRcc+0JXsW4RzXibwSNp+1TRs="
        }, {
          "num_cand": "U2FsdGVkX1+KX6aZ9CCwQwjQuP0ixoycH7tEj6RlE+Q=",
          "cpf": "U2FsdGVkX185bM/AUIcUk5sfv5mMi3F3poztxudyK8E="
        }, {
          "num_cand": "U2FsdGVkX19M/CnRzXwziipz3pBqqMvHw3tMYMe8cDA=",
          "cpf": "U2FsdGVkX1+ZmqTPzIQurM0ZcjTo6Utv/wIOQDHpCnQ="
        }, {
          "num_cand": "U2FsdGVkX19Wp+r9SSiTLtNY72CM7SIxTshJGNQajko=",
          "cpf": "U2FsdGVkX1/iTxsAUkty1AgQDCxL72SKEFBaA2aSDZM="
        }, {
          "num_cand": "U2FsdGVkX18iLqJsm9HEJ+hYvQSCbDMAnwZw0Hg8f0I=",
          "cpf": "U2FsdGVkX1/az3VDluDw9tN7XRYkYUhyovXRyEgXlYk="
        }, {
          "num_cand": "U2FsdGVkX1+feIgimMkDwG093f/2p2tas3P3KLEQfQQ=",
          "cpf": "U2FsdGVkX18peZ0W+qupeE6zRBNUCt+/53CoDH/J4l0="
        }, {
          "num_cand": "U2FsdGVkX18Nv/0rcs8cPKUoiTLesdgR/q+tb3Qqxds=",
          "cpf": "U2FsdGVkX1+AzvrRPX7tcw+deGMDNXIAbArmUHVYwzU="
        }, {
          "num_cand": "U2FsdGVkX18oCPd9D9jY3AbMGhNFCrOh1Wx0M+GyCxw=",
          "cpf": "U2FsdGVkX18mGr2I7Y5xziH9NRcyx2oGnq91yEu4jTk="
        }, {
          "num_cand": "U2FsdGVkX1+AZCO+2zc9tyLUrAi/2vpXdxlv2bqYCTU=",
          "cpf": "U2FsdGVkX1+3G2s+0ptOhqyTlbwF6L+zHRmGx6hZ0E0="
        }, {
          "num_cand": "U2FsdGVkX1/cupCfZ0wN17KSe0sR/e9WsmALoIritRM=",
          "cpf": "U2FsdGVkX1+lNOD9Mp4B8zX5zxEF4qpShgaAVCzmScU="
        }, {
          "num_cand": "U2FsdGVkX18HoZMy01qqEbFHCzVN0nEfuFDAnDWNT7Q=",
          "cpf": "U2FsdGVkX1921vWhoY885h7rP/Kg9XoqQg5eBYaY0oI="
        }, {
          "num_cand": "U2FsdGVkX1+0V+G06bg7Kk1tsoMJQvtLYUeF18CgABA=",
          "cpf": "U2FsdGVkX1/f3GGdEBbWVboDCehr7TgzuTRgEhct64Q="
        }, {
          "num_cand": "U2FsdGVkX1/N9cOSImpP82qvF2/O6D+/lRSWIoax8Wg=",
          "cpf": "U2FsdGVkX18qVWlrT9xwustHc6byxwqHqUBniJkmsJw="
        }, {
          "num_cand": "U2FsdGVkX1+opBVUisvA9hq5uP/5Q7seZYUjLdLNRl8=",
          "cpf": "U2FsdGVkX19qbkmlUorOtXr9LVPPAec0q8FDV9QVSPk="
        }, {
          "num_cand": "U2FsdGVkX18TFlgQCTLi51mrJpaPe2EvHE02NkDzm9k=",
          "cpf": "U2FsdGVkX19OMAay/wczXf1Llcbu484ZDqUKdSvhYWQ="
        }, {
          "num_cand": "U2FsdGVkX18CKjHkMnctReSxql+dARd9cvBYWrI4z1A=",
          "cpf": "U2FsdGVkX1+018j1J25C1BBHUdOoGSEAy2X1TSZk92w="
        }, {
          "num_cand": "U2FsdGVkX1/ddWtbqTKDajhDBahlYJmN9H3KYGcY9d8=",
          "cpf": "U2FsdGVkX1+kcxdO0zjaWhCDhE1HsYYBpI5DHO3Ul4U="
        }, {
          "num_cand": "U2FsdGVkX182bfxo1KcAjWv7J2tYOmM7okmnadscS28=",
          "cpf": "U2FsdGVkX18fnN5YX5FQjOzBsCfzmN5Gs6+u7f1/be0="
        }, {
          "num_cand": "U2FsdGVkX18qlbXLU/0JsN8EKqpx37YEssiVCiTMLcg=",
          "cpf": "U2FsdGVkX19KMrLIKFhL8Ku69snADWa3mSJZDr0n5E4="
        }, {
          "num_cand": "U2FsdGVkX183Qz2Q/j7QJ4U+86hUzyV7H0UYdYGMwXU=",
          "cpf": "U2FsdGVkX1+DMjCyu/PyKyqRx/hmjFb1Jt4e84k+Ki8="
        }, {
          "num_cand": "U2FsdGVkX1/IC/CuI7DaUI1CvalPuQr0TrgkC6/S89g=",
          "cpf": "U2FsdGVkX1+rM4g26fcczPWPgyG7ShmJQRMH8+p3RFM="
        }, {
          "num_cand": "U2FsdGVkX19YOwe9EJMvRJhy7er0yAVJAHeq2W0KfsI=",
          "cpf": "U2FsdGVkX1+TL6bazjpdEJkxGvD7D7rrO9Odg6VVhvQ="
        }, {
          "num_cand": "U2FsdGVkX19L5aZxYuWcb2SZlswzhYlzu4NVLr4kP4c=",
          "cpf": "U2FsdGVkX1/sDWfMSn974/ASUGcSkja1yDEeBV8AMtY="
        }, {
          "num_cand": "U2FsdGVkX191xnhgdMVEUdqZiz1R4NEjCg+zWpRREDM=",
          "cpf": "U2FsdGVkX1+p2hK+WM9YhTZ6XbO7xXHn6c+Zb+QW1gA="
        }, {
          "num_cand": "U2FsdGVkX19nihx7PxME8fsEUTH3HSgewmwUTZ7NyaQ=",
          "cpf": "U2FsdGVkX19KN9Q2ey1oZNgJRpQgbDDdePBm7ulerRE="
        }, {
          "num_cand": "U2FsdGVkX19SF+oMv2xx45Y7gaKjI+xQhG8reE5h1CM=",
          "cpf": "U2FsdGVkX1+WP9sNrU6FD0ZmqpCJNcqu4eC4K1k3Jm4="
        }, {
          "num_cand": "U2FsdGVkX1++93/UIRsIFHCDkHwU2GhCzNKK4Ipuf9k=",
          "cpf": "U2FsdGVkX1/Zf+2ISCy8AFzqug5a+3ErrGw2uB5bSuU="
        }, {
          "num_cand": "U2FsdGVkX1/OeMEJUX1lHoa/9I3kf/g5VsB8o1HGiNY=",
          "cpf": "U2FsdGVkX1+daPaa+vInOpnYsY9bca33Ho5Xki8CrKo="
        }, {
          "num_cand": "U2FsdGVkX1+uz3rcLOvlBpOSn0LD1dtFX/mtqbZ/xhI=",
          "cpf": "U2FsdGVkX19l6/akQpTS2GwekHbrswmbSbnTsh51yuc="
        }, {
          "num_cand": "U2FsdGVkX19/s1dSDmWYafwjIfH8uxSHlTSlGrUbbeE=",
          "cpf": "U2FsdGVkX19I4wH7pZM/q/ftAolo83Z9VQG+80Mya7g="
        }, {
          "num_cand": "U2FsdGVkX1+ThshbdI7vKMGI2x+iDQC1Yg5+lr993uU=",
          "cpf": "U2FsdGVkX197SJDN+ssYPxCYk9/gYmAXGckr+WEjmzE="
        }, {
          "num_cand": "U2FsdGVkX18EIzw7RJAASPdxtODU+PrmtGSiVRXpASM=",
          "cpf": "U2FsdGVkX18YFblSDREr5tt8AcrCJUzekfk5taFsWW4="
        }, {
          "num_cand": "U2FsdGVkX1+CRJedsNXftxbQzBPNg4N1VaoKMwgvAqQ=",
          "cpf": "U2FsdGVkX1/dCEe+Y1atSJqYEHHUJvr8gSg9ajJI3wQ="
        }, {
          "num_cand": "U2FsdGVkX1+//fc+XiTjluGJ20hwOlUr9SMHvI9/0HA=",
          "cpf": "U2FsdGVkX182IwmVwhKY2avmjIBtrYPZRaHd501kehk="
        }, {
          "num_cand": "U2FsdGVkX18pQ/0TF1Ws8okIQH40W/1K7Xcj0M+FifM=",
          "cpf": "U2FsdGVkX19X8wwrlLFbNB5hq6X/IvelDNmqXCsUTV0="
        }, {
          "num_cand": "U2FsdGVkX19fiDlUoeIERGCECYZI1mQPNMwsgBfm1E4=",
          "cpf": "U2FsdGVkX183WyUq5kC/8rV8jT5EHaPV7OlnqqSR7OM="
        }, {
          "num_cand": "U2FsdGVkX1+R42epjAplc6JSFqQFpJFkQtvHLZm81/Q=",
          "cpf": "U2FsdGVkX1+KaT5Jg2vkztD38aCmzZa3SkZmw1j90aU="
        }, {
          "num_cand": "U2FsdGVkX1+dMjfJflLonhrpvk5u5QH/NtH8XV0MkrY=",
          "cpf": "U2FsdGVkX19SQQg4hB+exmOMeCGMQ5S6CK+s+7eI1b4="
        }, {
          "num_cand": "U2FsdGVkX1+rn3beYGJk/CK5kEAPGmSlnA9qmAM86Os=",
          "cpf": "U2FsdGVkX19B9hcm6cIdLi5NabQ61vgMTQOzgauH2+M="
        }, {
          "num_cand": "U2FsdGVkX1+ch2EEIdOei9T32fvnss2O7NdfEa2+6JQ=",
          "cpf": "U2FsdGVkX1/jiqlkiC3dJNKJ5p2+RnKFe8LMmZmK6Xk="
        }, {
          "num_cand": "U2FsdGVkX19reVp92aK8nKS6BaYvshshlO09bkmUAp8=",
          "cpf": "U2FsdGVkX1/bQ6ora6dzprstmTd6WwlAo8pwUyoNh7s="
        }, {
          "num_cand": "U2FsdGVkX1+krkLWZZwzL5iF0SG7xtIof8iC6j1Prjs=",
          "cpf": "U2FsdGVkX1/Mecr43XzC9yi6sMm9fielsUajhzp6qSk="
        }, {
          "num_cand": "U2FsdGVkX19chfD/lw7HPFxW2G5nXuDNj6qZHVuP+JE=",
          "cpf": "U2FsdGVkX1/1ul7HW+QzUCgBAfmRHl1Jf/V2XED8L4E="
        }, {
          "num_cand": "U2FsdGVkX19FguvoojESb4RaBjHaR7spfDDuUjC9+Oc=",
          "cpf": "U2FsdGVkX19zW+6/7CMnQycISbri4yilHDD0N/5SafI="
        }, {
          "num_cand": "U2FsdGVkX18vH74zRGOy/Ero1bkX4G4LDvVIiy78Q0o=",
          "cpf": "U2FsdGVkX1+ikZsi5gGMwEW/ypiqqThea+LN6RDTLkk="
        }, {
          "num_cand": "U2FsdGVkX18i4LqLyx2ZDkhZuVA883pYeljlfILqbCA=",
          "cpf": "U2FsdGVkX19v+A/M8mtoxqkNkQ0sKn7MdfCS6TdbgGs="
        }, {
          "num_cand": "U2FsdGVkX19iHgP9+wszNXUe1sW4Az1nzwqDhNRIJGc=",
          "cpf": "U2FsdGVkX1/0rDYFJhJRQp/W58Gobs72KThEmwtLYOo="
        }, {
          "num_cand": "U2FsdGVkX18o94EneG+T+PlQEO/fVxHUhsNK1IK39pM=",
          "cpf": "U2FsdGVkX1/Y7iylonb7N9iV8dJjNRpa9XmYpV/6StM="
        }, {
          "num_cand": "U2FsdGVkX1+NIRaQjoSQkksbkYyLp2lbluxM8vvEH4M=",
          "cpf": "U2FsdGVkX19eU5Gm1eUMObjaXENhQLnxyTE+tDoJRL8="
        }, {
          "num_cand": "U2FsdGVkX1/pWSaM+W5dyoP31780Ugkd3pR1nGvpkFI=",
          "cpf": "U2FsdGVkX190YECss7CRsr40IQjGalh+Rc8qVpbN3Tk="
        }, {
          "num_cand": "U2FsdGVkX19JdmzzYsjANdADALw39VXMe7UXe3eA+to=",
          "cpf": "U2FsdGVkX1/cdafBF/ErjXy/YmvSICWbxVwH03DAbgg="
        }, {
          "num_cand": "U2FsdGVkX19Z6QA1lwpDaYphegyLJH+TgAIzND7HhE4=",
          "cpf": "U2FsdGVkX1/LwLhtCs1H5cVHbAKGg1DGmRUiwfY6LgA="
        }, {
          "num_cand": "U2FsdGVkX1/Jpi54UagTBR6UoUSMBfY+d/SQVQfumOs=",
          "cpf": "U2FsdGVkX1/7GOPFiKnFDPsHrYXqc7hUJ9mixTPuPLY="
        }, {
          "num_cand": "U2FsdGVkX18CRHHYiTT4N6FN+a3unKvOmjlHMTF2Sao=",
          "cpf": "U2FsdGVkX19hos5lXnMssCY2XFIz+orgaB5/iclC9eg="
        }, {
          "num_cand": "U2FsdGVkX19HZx2TSb70YU8ruUZm1Zl7Mzu0jB+0dgU=",
          "cpf": "U2FsdGVkX1/9XXiuzeFxSR/6UPbF1m7TU6zDZGdSIKY="
        }, {
          "num_cand": "U2FsdGVkX1/glzlYUkOJR9yfrzcJcjzpsyauCs87Xbg=",
          "cpf": "U2FsdGVkX1/0AqfT5GrYvl7Mr4CaQA5GTUWfXg0oi8I="
        }, {
          "num_cand": "U2FsdGVkX1/5WXqG9jAcyTLUj++Z1U+TY9rWphQqoGo=",
          "cpf": "U2FsdGVkX1/4Wuwn8XxnVYaKiVRYLXS50OqrGDYLmOk="
        }, {
          "num_cand": "U2FsdGVkX19cKtwQO+7J2G9J+U1FbpCim9lzz2JZwuM=",
          "cpf": "U2FsdGVkX1+d2iKi4mI5ntFGh24fPPCIz/J6oM8WIDk="
        }, {
          "num_cand": "U2FsdGVkX1+5VfDTl1carY+h+feDoLUiTwLTKVRWDrM=",
          "cpf": "U2FsdGVkX19kkZucBjVWG50HOG/98ylNQRzh9RA8j00="
        }, {
          "num_cand": "U2FsdGVkX19lG6uFBKxAIQ4RDRn4gioCDVaSR6Lh5Mg=",
          "cpf": "U2FsdGVkX1/TpvNTVjMS1CRymvT3L6ohqrrLtfdyHdk="
        }, {
          "num_cand": "U2FsdGVkX18CxymLcNz4Cxn/vN/r2FJFjw62uAj/DkQ=",
          "cpf": "U2FsdGVkX1/1gsmUYwbyUazPNcj5F2AIvoX3ERYlJ/I="
        }, {
          "num_cand": "U2FsdGVkX1+VxJf42HAKLtTS1ZvuMs4eYFa2cuXOWlc=",
          "cpf": "U2FsdGVkX19pIXW3oZ5aeJLJ44PzX7zJsuG3HGsmxUI="
        }, {
          "num_cand": "U2FsdGVkX1+MTPbruU1FYfyarPlkMlyDiKLhPVBsd+4=",
          "cpf": "U2FsdGVkX1//Y0c9WfNzZcuCZnfqAzTYG6YlCymVNxk="
        }, {
          "num_cand": "U2FsdGVkX18I/XtYZUtNbQeept49FvsTscbgtZ97HZY=",
          "cpf": "U2FsdGVkX183N5a0A5y2Lo7y2+n0khPgDCe+tEICRN4="
        }, {
          "num_cand": "U2FsdGVkX1/dSDomYYFky5B1Ilwjpwa7Y5BK4a3y6fs=",
          "cpf": "U2FsdGVkX1+Z8AVcZczlwqZPfosbT/SwD/QZqJGlvJA="
        }, {
          "num_cand": "U2FsdGVkX1/k0AE0rGj2rSPycnB6ewz+Y6Dr+P2QraU=",
          "cpf": "U2FsdGVkX18fGdEh0XM47u6UKuRT/17y2cG5aWfEikk="
        }, {
          "num_cand": "U2FsdGVkX18V9Bzp8DNFhzk1aE5IMcp7s/DeqTkvynY=",
          "cpf": "U2FsdGVkX19XyROE7BOE6wUI2cpbrwFQYjOyJ8GK8m4="
        }, {
          "num_cand": "U2FsdGVkX1/8EYq6A++9Q5xCrDj0xNN4oOlvagiCspM=",
          "cpf": "U2FsdGVkX1/91PM1h5iNIrv6ty6w2vHtdJmm4Sg3KBw="
        }, {
          "num_cand": "U2FsdGVkX18hsPG0myKdxQGLw/fpFrU/GLE+WwAXHfc=",
          "cpf": "U2FsdGVkX1+spCbgg2aAGfzNUh5EwqpTl74D89Qjytw="
        }, {
          "num_cand": "U2FsdGVkX184dhXihG9KeMcesOBw0i2LeFT3rNPRE/8=",
          "cpf": "U2FsdGVkX18GJAYTvdujChHd/63buoDftRP205VP2wI="
        }, {
          "num_cand": "U2FsdGVkX1+Kwvn8Lb8Op45Yjk8AJWb0JRoC0E3Ee9E=",
          "cpf": "U2FsdGVkX1+tiYf+Ff2Fx7bf+7dzRDlHdSYnCgfIVDc="
        }, {
          "num_cand": "U2FsdGVkX1/3409pkYvz3qoejKAz1FRLvI8jxlOOVAI=",
          "cpf": "U2FsdGVkX195S5b4e5IiAtm3KkM9jUju4ChX+U+dB4M="
        }, {
          "num_cand": "U2FsdGVkX1+6OGaxr6yoqU2Q4P8fI4RG85MHrMIBeZY=",
          "cpf": "U2FsdGVkX18tlJzdQYoiKgu8wpWnRzCHoOAwfwAqQWQ="
        }, {
          "num_cand": "U2FsdGVkX1/icn4NsL1QgeCD5IT3/NXBpIE3JDT+gnE=",
          "cpf": "U2FsdGVkX196gtcV/cvjwggOzXoZrH67S29mf03bY0c="
        }, {
          "num_cand": "U2FsdGVkX18nO9OtZYa+HEEZnpmYJjsAJ+aLV0Zxa/Y=",
          "cpf": "U2FsdGVkX19hyedlkp391QjdwyXlK7bE7fVW6Xia09U="
        }, {
          "num_cand": "U2FsdGVkX19ikn5iJ7WJtkiohOOrK70ocWyKqYns9rQ=",
          "cpf": "U2FsdGVkX1+Zo3ScEb6YfvgSAbcxEjZklT2cc4USb30="
        }, {
          "num_cand": "U2FsdGVkX1/UUrIYSTdsgT87nOHXZY/HkLcOB2wIFig=",
          "cpf": "U2FsdGVkX19/JLK7VN8jKX51tG5xaoVJuVAUnb4NgVs="
        }, {
          "num_cand": "U2FsdGVkX18S/aamfFKBc+Iz+CAMt5ydMcjOd+EFM78=",
          "cpf": "U2FsdGVkX1+ZGq/9pLGFyXrnEFw7cFsV0JhW3qL71+E="
        }, {
          "num_cand": "U2FsdGVkX18wW2hPgmukeL5nESx1kACqdn0m8ksWY/4=",
          "cpf": "U2FsdGVkX1+G4zmLZCa4licfv1CN4v2+N5D9RfewNeE="
        }, {
          "num_cand": "U2FsdGVkX1/LJ5nck19XFiFb8kOznqIvksYVrvJxF5Q=",
          "cpf": "U2FsdGVkX1/ThiQat4kSX2/orhQleBGOIJgFThTV7is="
        }, {
          "num_cand": "U2FsdGVkX1/XuedkJsf/6Ipkh44iAUBUk6sISepIAJY=",
          "cpf": "U2FsdGVkX1+bhyfnQBQXMBFgTHBwga2aZGx3tbKFDiE="
        }, {
          "num_cand": "U2FsdGVkX1/bHhS+0ZzZWcUMNTEeozJx17R5ReIKU+o=",
          "cpf": "U2FsdGVkX1+COmgPhVV/cKdjhqowpV8puQL3WBF8RCc="
        }, {
          "num_cand": "U2FsdGVkX1/lLwuy1ZE/LKBntNXZa+nkRxNgs61HMS8=",
          "cpf": "U2FsdGVkX1++6XYn4COCF8azs6rOKFOfrtFHOKwVwfs="
        }, {
          "num_cand": "U2FsdGVkX1/PvLEYDqkZLFfT6WN0AyiSu4GLcX6trAc=",
          "cpf": "U2FsdGVkX1/Z4SdTmHJvXeYH5SowqcpGF6pnzRHosdM="
        }, {
          "num_cand": "U2FsdGVkX18wLoGanFCLJT5fE39N33b63TNDhwLGkFY=",
          "cpf": "U2FsdGVkX1/atbczy5nbL06WAkfCn0on/qvYbVAI9zo="
        }, {
          "num_cand": "U2FsdGVkX1+IEUb1rplZu87j+4HNyJJBvBP2oK385RY=",
          "cpf": "U2FsdGVkX1/8qDiL/eKiej8RkQheCC+/hgi1a9LR4no="
        }, {
          "num_cand": "U2FsdGVkX18/Bsi0iz+Uc5P5/GuVvSf6+MJknTpMCMQ=",
          "cpf": "U2FsdGVkX1/uVpaF3hMtZRrfdjU1VDgEZMDjbfxghLA="
        }, {
          "num_cand": "U2FsdGVkX18tqzV4EtSaQK/F3Dqx+5SBBrQ/h2Cd6E4=",
          "cpf": "U2FsdGVkX1+1voHWFJLuUBDIXClFJfn0WAYScMCJXJI="
        }, {
          "num_cand": "U2FsdGVkX1/mi9SjdR0V+BnJ38bw/GxQYCkPsqxieaY=",
          "cpf": "U2FsdGVkX1906rXn/AgvLVwPbmuPydH/BqJXLYAMMzE="
        }, {
          "num_cand": "U2FsdGVkX1/9BYMOL9Rtoi5OMAhGPIWvfDvnV4eQbdE=",
          "cpf": "U2FsdGVkX1/U7MmU7GiDIChLF9nuTtruh7FHjDwnKPQ="
        }, {
          "num_cand": "U2FsdGVkX1+WmGHJRe9LliqUkVGP/CxSOL0pArIblr8=",
          "cpf": "U2FsdGVkX18PWCXDvB4c4qZpKoBd35lXC8XJOzzF4E0="
        }, {
          "num_cand": "U2FsdGVkX19OmQo9Gj4oEDhvFRTz2lJIzOLr8xzZuG4=",
          "cpf": "U2FsdGVkX1/oJqppeT+VB1+HZ1gEhGpK03qfyU1eTxI="
        }, {
          "num_cand": "U2FsdGVkX1/vEJkjDop+ckU904P+GXNBbQf+tChWl9g=",
          "cpf": "U2FsdGVkX1/LxlKYo5xCCCOgWiwVK2InoorYatPIpIg="
        }, {
          "num_cand": "U2FsdGVkX1/zPzezYXWR9svy9lvCvhkvgzVvVBHnKUo=",
          "cpf": "U2FsdGVkX1+Kvc/JyUltizChOXF0dTtnVfFN1Ce9elY="
        }, {
          "num_cand": "U2FsdGVkX1/czyZtJzoEOLNlBTg4Md7a1NN/8DLeHek=",
          "cpf": "U2FsdGVkX1/NIpQC7r1XQVYOw06sT/lbDBdX39Wqd60="
        }, {
          "num_cand": "U2FsdGVkX1+IVSrz6iMhspYbJuoeZf3QeG/d4jajvoY=",
          "cpf": "U2FsdGVkX18fnvLsDxfOE4RNRfF7CavkDxvZGjylJxc="
        }, {
          "num_cand": "U2FsdGVkX1+d9pyu9zyIjHNmJZVW8OnTHgijRorOwAw=",
          "cpf": "U2FsdGVkX1+5iDXmu9szcEoM5tPrPKwnOSR87yue4XE="
        }, {
          "num_cand": "U2FsdGVkX1/wilrAv16UnB6idp0KgTBAU+aTxp0LOtw=",
          "cpf": "U2FsdGVkX1+QNaZQBvBwd7+72kP2VdGCY48T8PI05ZA="
        }, {
          "num_cand": "U2FsdGVkX1/nA1s5emseT6Pl+1IkxMTBJ77CJczy3wo=",
          "cpf": "U2FsdGVkX1/Wd5A8t9I6Pnz+XBOtbubd7vhlwMdyRBs="
        }, {
          "num_cand": "U2FsdGVkX1+uV15UeDaYgC0kRL+i1+6Ahl5fXNd+U3Y=",
          "cpf": "U2FsdGVkX1+hUEQ/bz93CDbVnDf240FT8IhPe1Rwoig="
        }, {
          "num_cand": "U2FsdGVkX18LY58ytZiDq09OXMAVw0tzO9DSyD6/MSI=",
          "cpf": "U2FsdGVkX18sn4N+6Ltl1GVb1zQ+j+TNUCCu///aTA8="
        }, {
          "num_cand": "U2FsdGVkX18JIQS4A2Eu92NwjvjCPTca729a8pMe7Fs=",
          "cpf": "U2FsdGVkX18cwfC0NXK0XximmH7oOD3DdpeUiDpkphw="
        }, {
          "num_cand": "U2FsdGVkX18eyr9fXvK9WB+j7geWKUV71R9oXPVp698=",
          "cpf": "U2FsdGVkX1/iXI8VCvQdRbkmQsLidVYklTnNfD0PZ0E="
        }, {
          "num_cand": "U2FsdGVkX185b+TqGvrQfKEIw3EX8bcUvTli7MUoZus=",
          "cpf": "U2FsdGVkX19A0MwZG6uKZUPofUK2M/5ciVy1pNTWStc="
        }, {
          "num_cand": "U2FsdGVkX19l2C9z5tJn3ZrgZKvz5qGagkHzEUhf6TY=",
          "cpf": "U2FsdGVkX1+3EfFEL9Hg6QLIghRiAzvxilYh/Jr49LU="
        }, {
          "num_cand": "U2FsdGVkX18Qt21ibacKKkQSwnWbDBoXk2M8oqLVaw8=",
          "cpf": "U2FsdGVkX1+iXwBd9bW6HtOEu+9XOqzDRxseUuo8EeY="
        }, {
          "num_cand": "U2FsdGVkX18KovPBWjank8Xz2yJ1/jFaM1yBJq/800A=",
          "cpf": "U2FsdGVkX19XaqrLIEPIPJPJSSwXv8/5ptF62386tP0="
        }, {
          "num_cand": "U2FsdGVkX19uhQKzcEiq47qFFOHn7akSGJidQif+p9A=",
          "cpf": "U2FsdGVkX181UVIgQdzmZ69JLQ3S+OtOpEQUk16HwDo="
        }, {
          "num_cand": "U2FsdGVkX1/89VnBbul6+0xeFoys5vtuDceYzv28H9A=",
          "cpf": "U2FsdGVkX18aVpbcMtcDAMGvYACjd2pIyh/IrI2XPrU="
        }, {
          "num_cand": "U2FsdGVkX1/LYNBNY+aZQFGgA/6ST/6L0zAMF9gz9kI=",
          "cpf": "U2FsdGVkX19VI/LmBZJ9BGQ/8UQ1dfhwSMgN+EB+54U="
        }, {
          "num_cand": "U2FsdGVkX1+yOkmcfkLZk315tS5KAbGq5Oeme5/0g9Y=",
          "cpf": "U2FsdGVkX19TdIZzov5sQsVv0twUHwDlgZPC0t1VRjE="
        }, {
          "num_cand": "U2FsdGVkX19ITFKGK5DCyRx0XyDzfpqus+E5xze+6HI=",
          "cpf": "U2FsdGVkX192aD16LCfnJPVRCQIJ1LVPQGqxSxPOQ+A="
        }, {
          "num_cand": "U2FsdGVkX19FuxD4g1kFnIk3hLLDDq26wGkz3z8Vk7c=",
          "cpf": "U2FsdGVkX18oJSZ5bJTQbimsA/lwtX5G6cI3LLHBAGc="
        }, {
          "num_cand": "U2FsdGVkX19YJ6ALz8sJp2eZZJM791HjC1kHcc9Eagg=",
          "cpf": "U2FsdGVkX1/aMxvc3cgwMGbvV3yD+yndotZooEZc4Ts="
        }, {
          "num_cand": "U2FsdGVkX1/1GdmIG2BzjJiukbRHnU5bfEuWk5MtBts=",
          "cpf": "U2FsdGVkX19W8npNSx9D1vB1TtkAUxodme7jvFK8hBk="
        }, {
          "num_cand": "U2FsdGVkX1++s5VwQUH8wL92/Hij2qGi2WVRgVH9Loo=",
          "cpf": "U2FsdGVkX18fq22Ii8nLEqxHKE/nfz1IFXjkUDCVA6A="
        }, {
          "num_cand": "U2FsdGVkX1/yleHxFN5uM11zJWDD/pNXwedRD9Ksi7Q=",
          "cpf": "U2FsdGVkX187h9BaDy9KU9VXkfumYwMi0Pk4Ykk/YOk="
        }, {
          "num_cand": "U2FsdGVkX1+MSIB5Y/0JsBfCWpQkAZDoR6F3Jl5kczY=",
          "cpf": "U2FsdGVkX1+B8QYsfzAwyjvapK1QSFO1CRmljiJMh00="
        }, {
          "num_cand": "U2FsdGVkX1+wHR4dyyOCeGIx72Vo87KxQqxmK1YoQlw=",
          "cpf": "U2FsdGVkX1/Q+dN0aRjNNO4iT0UucRNXHz7xZKYJEN4="
        }, {
          "num_cand": "U2FsdGVkX18p/fUW4ZZ30I9cX19cParYULhSqw5+erw=",
          "cpf": "U2FsdGVkX1/onou5SWyN8qHr8M/Os50UXXrcdmMl5GU="
        }, {
          "num_cand": "U2FsdGVkX19BBNkQpS7XdxaEiNBlrP5DsRT6fyuefbM=",
          "cpf": "U2FsdGVkX1+fVRX3ubZ2ChKAEHomV6ZuK0IpED/JWFQ="
        }, {
          "num_cand": "U2FsdGVkX1/icmF0fFGaolZSDCh1UJfmBi/S5Njs6l0=",
          "cpf": "U2FsdGVkX1+yCeeW8qT+x/192FcIHI2lZ///BCalR9c="
        }, {
          "num_cand": "U2FsdGVkX1/p2+a1P8w3ErW5o9MhhnMFVTp+J7TL6JU=",
          "cpf": "U2FsdGVkX19s5f1ZNUV+EI/Qfdx0WnN3UIiyB5ebGS0="
        }, {
          "num_cand": "U2FsdGVkX1+J/l6KugpXIWBZmSsUMLNfX9eyrT+gUkw=",
          "cpf": "U2FsdGVkX1/TTeUKyUZ+5ZuhHPwuY1s46W45ik1rr70="
        }, {
          "num_cand": "U2FsdGVkX1/KWHawYmSBSmp8UiQ4HdLenOzFo7b7hRE=",
          "cpf": "U2FsdGVkX1/aD8x2M1E05yKmw+FFVpBJl8CcyFDhIKA="
        }, {
          "num_cand": "U2FsdGVkX19XditmvmTZ+Nq/Qy23Wf0uiMQqocnI4Ac=",
          "cpf": "U2FsdGVkX19ggyq0ILSVwSmtINh5SWGCcSTuND/mEUU="
        }, {
          "num_cand": "U2FsdGVkX1+enznmKxT3T6bIYIJP/sVzvzWY75MohmU=",
          "cpf": "U2FsdGVkX1/ojyUfDDdn4ki40XOL92+bQ0Mc1ipr14Q="
        }, {
          "num_cand": "U2FsdGVkX1+QEYIAt4KKsdCDQJ2sZwHYvyqtE0meLdI=",
          "cpf": "U2FsdGVkX18hBgxtvHmMNkIMxciPuIKiMy7qFCP7tXQ="
        }, {
          "num_cand": "U2FsdGVkX1/Ro4/hTJllLTeXBHFaC1nb4r0YsYtVKes=",
          "cpf": "U2FsdGVkX1/d7s4ehJYyhvnxW/b/ENQP/G06dWR7IZQ="
        }, {
          "num_cand": "U2FsdGVkX1+sKjM6MJYU+H4aQAo7ERnxkR6mkI0r4c0=",
          "cpf": "U2FsdGVkX18YuvUTCd8f64YAEfPQIid4zQEu1BG6I+g="
        }, {
          "num_cand": "U2FsdGVkX18IXm3usSpma7qebKVg7PjS3WY1cIiw2+Q=",
          "cpf": "U2FsdGVkX18NkQ9RHz6Wg1dO1jjpLuD1h/Umf/xCaRs="
        }, {
          "num_cand": "U2FsdGVkX1/2+6XAX3QGd86+sKpIA5tt2uTweHFIFmM=",
          "cpf": "U2FsdGVkX1/mX+tkJzRwruXBSeIaGr3s19r8VAVejQI="
        }, {
          "num_cand": "U2FsdGVkX1+lL0daspQnEAq5EJpO+g7HyDEOkjM65qk=",
          "cpf": "U2FsdGVkX19A5QwGzAFbMLNY94G4/MSCSyWfFvM5/k4="
        }, {
          "num_cand": "U2FsdGVkX18wX3b/IZvfoZSZyy6f/RUMefBqkIOImsw=",
          "cpf": "U2FsdGVkX18rKbzzN4f5U0mBy74OVw243FA4cVPnsvA="
        }, {
          "num_cand": "U2FsdGVkX18yXBs4k2+CF0v3lcX1rw5JgXW3OPWLXH0=",
          "cpf": "U2FsdGVkX1/gMsBlkAEMIAMDz+Zc70otWfmYPJ8jZmc="
        }, {
          "num_cand": "U2FsdGVkX19loBPVIyRpDqN5UFvnDmpaZKFmErCgo04=",
          "cpf": "U2FsdGVkX19+bWraLZyPBPFDxpwmeJYsJU2kXUHtqrk="
        }, {
          "num_cand": "U2FsdGVkX1875pLHkwiOxfoPxwqWJr6V1JPw1TwQ/aE=",
          "cpf": "U2FsdGVkX18WliWh83yNhrdEc0HP9Vfmb2s/3NY4jvc="
        }, {
          "num_cand": "U2FsdGVkX1/+/CYHgGVVRflZVnP0HlRkq8fdu7cSWjQ=",
          "cpf": "U2FsdGVkX1/bSxKDJPdsMqsJmblrFQhP1gNZ47z5uSY="
        }, {
          "num_cand": "U2FsdGVkX1+FTl3xeOw6g5NJOe7Sb92yUvdvaMHkycw=",
          "cpf": "U2FsdGVkX1/Bs5mZ2UlIUdKjKZn3liqyRGrTuTI68LY="
        }, {
          "num_cand": "U2FsdGVkX1/WWihJzDIGHIFFZgiloUG209rMJ7zxm/Y=",
          "cpf": "U2FsdGVkX1883ypVn/s+GVjlYu6UgJKk/F48sKbdzys="
        }, {
          "num_cand": "U2FsdGVkX184KT1gVy6msR14gqNoudN+KXeTf3KH968=",
          "cpf": "U2FsdGVkX18UZCDDPSysAOu0bUJZL2aZ0PT3UGuYrgs="
        }, {
          "num_cand": "U2FsdGVkX1++/MC2UOWORZ6TKDj4yq6X+Ji7mu5qP/0=",
          "cpf": "U2FsdGVkX1+ux+LvjGg9ZJORNYCb3Dbz+921GVaEVLo="
        }, {
          "num_cand": "U2FsdGVkX19fJpjcsz3nc+GCv8AubFohD8fwbOKk9Lc=",
          "cpf": "U2FsdGVkX1/1paxn8JOLhoTa6zyFXYu2danigYmQNKQ="
        }, {
          "num_cand": "U2FsdGVkX19mvSH0D97ZVyUBWOP0XGWbtX8SA2BLBrM=",
          "cpf": "U2FsdGVkX1+nRKljspkHM4w+ZNW0+8nzAKcGWZJJBOE="
        }, {
          "num_cand": "U2FsdGVkX19kpmxd2JdMWm5P8iR19siV+vYwnk7Z1cQ=",
          "cpf": "U2FsdGVkX1+FIjf8ElFBFJd8y7qQ3lpYWOpHDiZdjeg="
        }, {
          "num_cand": "U2FsdGVkX189UH4zVCgBhEv+VzC51SanQmKyHRP1uYo=",
          "cpf": "U2FsdGVkX1/fM/IWQNPGGeRiwAzPJXk/7PlfNGW+weo="
        }, {
          "num_cand": "U2FsdGVkX1/T3tQighwQtO9LM3X4CanoHDQrvIjLU4o=",
          "cpf": "U2FsdGVkX1/SEuw/S5w/b+eKb+Qdh+wk/MECZLmuRzI="
        }, {
          "num_cand": "U2FsdGVkX18A6iKxV/d9Bi2aJLdfTyBNdowUdJFB0Bw=",
          "cpf": "U2FsdGVkX19L40jhJQcP7d98QDl2SRSkRKEdG6AwYko="
        }, {
          "num_cand": "U2FsdGVkX194TsA6fupDffdDw+rbvFioJx8oMccC2t4=",
          "cpf": "U2FsdGVkX1+cZEfzViyIAM0kCOfxoasF9f99KLf/7yY="
        }, {
          "num_cand": "U2FsdGVkX197uthhQZcuT3++/MUmg6uvGiN5kydWxn8=",
          "cpf": "U2FsdGVkX187Nr5XGHAtAsB1E3+A6k2GmRQX5z+LOOo="
        }, {
          "num_cand": "U2FsdGVkX19ovIuUrf69LcejQY+6y9DBH+t6XXT54Ow=",
          "cpf": "U2FsdGVkX1+PhxVqhreZCIfFuKgwhRWwpuVQC2oweuw="
        }, {
          "num_cand": "U2FsdGVkX18sp4+3CRlJxHh//8+dHYwsAriJ6eajlIo=",
          "cpf": "U2FsdGVkX1/FVexSVWkznM9L3T15d+aMNOYWwxZJDLw="
        }, {
          "num_cand": "U2FsdGVkX19gtiSLkE5htG1ur95QgZ9BCtGY5yalMXM=",
          "cpf": "U2FsdGVkX19ViLijWs+QgGti1sS/l1Xk2p7a4fyRVbE="
        }, {
          "num_cand": "U2FsdGVkX1+QFiHlWA2ddjHtyHcd86p6SPR8bOMnbY4=",
          "cpf": "U2FsdGVkX19H5s8IwcFip+I0/Jzm63dssrurhZckusE="
        }, {
          "num_cand": "U2FsdGVkX1+awX0VRZuE/AB2xWzaYPPTYDo2iSo1ASs=",
          "cpf": "U2FsdGVkX18FbDuRssNjCsy2j1RfSjxzJRe56uNrbYI="
        }, {
          "num_cand": "U2FsdGVkX1/qj9qSBVc6lX8OTZxXvT1mdtA2EfmBr5M=",
          "cpf": "U2FsdGVkX184VV2ry3s3hBBNgPHVpDgWVu1VEnk0cas="
        }, {
          "num_cand": "U2FsdGVkX19iMDIfVEL8iPPwhbhSG90eAQ7/DYmZPJM=",
          "cpf": "U2FsdGVkX1/zq66eFP1ehcALZuTsvYkL5ziRvHz0/2U="
        }, {
          "num_cand": "U2FsdGVkX19UnS3Y7BWGBx3tCJObaQSLqPkHa96kNmo=",
          "cpf": "U2FsdGVkX18d+9ulGNTowGPglMWMfn2xH/+ctn+/VAQ="
        }, {
          "num_cand": "U2FsdGVkX18OvyCWcqzux2w4dFsTk1f5cABELdGl+pw=",
          "cpf": "U2FsdGVkX19BamEzp3y36fmvg1UdIImnpvZw24z9OnE="
        }, {
          "num_cand": "U2FsdGVkX1+4CkX/Cyr79LQR+R215pDH4+HZ41NM/BE=",
          "cpf": "U2FsdGVkX1//uMdpsVpcL6hiac1nkBmQeePtn+UE4x8="
        }, {
          "num_cand": "U2FsdGVkX19Mp/X8UntuIihl2PBKFGwyGQOnq0XM89o=",
          "cpf": "U2FsdGVkX1+JUrXeak6NabxQA76wnrSIMDB/BlRIAHI="
        }, {
          "num_cand": "U2FsdGVkX1/FuyElqSzrlAGqmygDMy46NaO/dmBXlf4=",
          "cpf": "U2FsdGVkX198V62MBUIl6CH+Rm2dIe5R51qwmmVhDVo="
        }, {
          "num_cand": "U2FsdGVkX18aGxCnICLUHsxI6cROlnAHSLxKa1WpwQw=",
          "cpf": "U2FsdGVkX19W6DiO2yFtI/tLImW6Hzvita9gkmFy8Jo="
        }, {
          "num_cand": "U2FsdGVkX1/rwHhU2i9/CPHrFa1brGwWY4mZdSgp4+A=",
          "cpf": "U2FsdGVkX1/4v7Ib6J8IETR3i2/FzQVXzX3K4p2DY24="
        }, {
          "num_cand": "U2FsdGVkX1/Czv8fdueTwR2u+7sjyljeYHYYLblCBes=",
          "cpf": "U2FsdGVkX19nuVshREMXrCBPbaQuYIg3UsC6V3sW7CE="
        }, {
          "num_cand": "U2FsdGVkX1/pCaGiBBwUEzxWY5MHUW7nnakLCB6Bia0=",
          "cpf": "U2FsdGVkX189uc8LgxEec195ht7gY1ZMyupoialCcn8="
        }, {
          "num_cand": "U2FsdGVkX1/xkhBTODLpa3XG+7oVZS53pb7Ig/XSAvw=",
          "cpf": "U2FsdGVkX18NbVGgtY2j6MNppg++33M4SfelE+bnuBg="
        }, {
          "num_cand": "U2FsdGVkX18DmYHY/EFvlVXiz85qZhG6s9R9eeYmMl8=",
          "cpf": "U2FsdGVkX18EcvYabpFcFiE1LXhxtwwI3KivDExlqt8="
        }, {
          "num_cand": "U2FsdGVkX1/YncLZNRuAJINTsfg3yXenAwx+9+oG2QQ=",
          "cpf": "U2FsdGVkX1+jRz9jrEKU7nbBtHFK+bwc1+9Kqv7T91U="
        }, {
          "num_cand": "U2FsdGVkX19XdIhMiigU/WZCOLyka1MMg4m5gwn0rCc=",
          "cpf": "U2FsdGVkX19T46c5hq5u85RgFboWhOQ9Z5Xz1cKKWQU="
        }, {
          "num_cand": "U2FsdGVkX18k0oU8r0hIl7T8bmhq0eJp2oX2Kwb8SGY=",
          "cpf": "U2FsdGVkX1+RsRJ2rxpDwnP/08+NbW1fnA+Ghw6sjlI="
        }, {
          "num_cand": "U2FsdGVkX19Fkz7cSfh2dkAMLmU1qywPWbPFRPw54bA=",
          "cpf": "U2FsdGVkX1/oepIxTFzgQvbYPB6bDztYYgEvXxubXxk="
        }, {
          "num_cand": "U2FsdGVkX19WxQc5voI8BCXJk3RtVaJ9X0Ax+CTXOG4=",
          "cpf": "U2FsdGVkX19uv4Sj2qbugfG70+fHH8igUrhCeCqMbxk="
        }, {
          "num_cand": "U2FsdGVkX1/qXfnEJubal2s4/SfuMvtR9rt3Qv2Wm+k=",
          "cpf": "U2FsdGVkX19qXDTzqUz6lI/VSwETGBUgD5ZLK+L7xwE="
        }, {
          "num_cand": "U2FsdGVkX19nMLyV58ook8U+mbqdZuyU39NAO+XWei8=",
          "cpf": "U2FsdGVkX19V5jgzD4PzX83DWXcBygKKRMS/qIf7tfg="
        }, {
          "num_cand": "U2FsdGVkX1+HrpmuF8XH8qsZTHUwsIcMTsyjNyrWMHk=",
          "cpf": "U2FsdGVkX1+x2UlZjKfVHR8ee/19BWe48bdBWjJr9Qo="
        }, {
          "num_cand": "U2FsdGVkX1+aUE7P+ALS6Uo69/X31DM/vda8pkS6N6c=",
          "cpf": "U2FsdGVkX19PDYNCfoxM/3KEVpRJqeWmI1WDpoz1uHw="
        }, {
          "num_cand": "U2FsdGVkX18f4ak8ypg4SebrYviiqXssFcDEHqh+2Lk=",
          "cpf": "U2FsdGVkX1+ee366hg/1k/39TGGtFg53VgJDKuKDoTk="
        }, {
          "num_cand": "U2FsdGVkX18cCdBTW73VrXc+vWXlbEfPniZjcr6DJaI=",
          "cpf": "U2FsdGVkX1+JK88mJ61Vqcd0nwK+OIpWq7reYaiy3b4="
        }, {
          "num_cand": "U2FsdGVkX1/2loQr+gli1kmL65LzXVO6oSd9I7ZUxS4=",
          "cpf": "U2FsdGVkX198uPwVHlyVC/wQlhLzJLFklX5syLSHpJ0="
        }, {
          "num_cand": "U2FsdGVkX19c3Rm77uL37rHlmOZtxFHD8xFAJBOEivw=",
          "cpf": "U2FsdGVkX1/Dj0iaAOCocGVjqSlwhVfHS9+MqViOpMQ="
        }, {
          "num_cand": "U2FsdGVkX1+lXJAuG2v0t6Gb4yVTy8q7XrlHaYUGDeE=",
          "cpf": "U2FsdGVkX1/xjPDVSJjCeUj1vu1emnVcX0+JOzZqtaM="
        }, {
          "num_cand": "U2FsdGVkX1/PhOHB0CJxwPTRui7+cBeP1Vt04FXOFus=",
          "cpf": "U2FsdGVkX19HmVvbBQ9DfwrbPNHZn9dSnow8o5dk2wE="
        }, {
          "num_cand": "U2FsdGVkX1/VyZ8cFhnQi9BlqyOIm6ts8ECSSzJv6hA=",
          "cpf": "U2FsdGVkX1/GhROIi1MQjv744UIdJzHMU9f2g2NUdyg="
        }, {
          "num_cand": "U2FsdGVkX18dnzCGwAkIFz+rHHk6Y6Wd+4HAQTwZ/v8=",
          "cpf": "U2FsdGVkX18DypDMEpiSzMEDe9rvinwie/2hR+bISZo="
        }, {
          "num_cand": "U2FsdGVkX1/TdT6OVPZD7JQxyT3EV0GAp/8LWL/seAk=",
          "cpf": "U2FsdGVkX1/s9C8m476553f1SQoZPq2Pnb0YnNYbr5Q="
        }, {
          "num_cand": "U2FsdGVkX18YZ7YysiJMsLSBAbWuYMg56A5iq/at4hk=",
          "cpf": "U2FsdGVkX1/rXeJkgM1TWRENXkMzaNfTShdBDabV3vw="
        }, {
          "num_cand": "U2FsdGVkX1/q4UsNTc62CLcN+RBlm1rV9cRbBM/Y0bw=",
          "cpf": "U2FsdGVkX1+bSF2Bbkc8Wh61Z/tfxt9hR7x/tK2GoPE="
        }, {
          "num_cand": "U2FsdGVkX1/JYh2KjP4i12KjduqLQvSL3pcI8AWR5rQ=",
          "cpf": "U2FsdGVkX1/T7VXE/L77bs6B9suADuS+IYYL8m5sCXI="
        }, {
          "num_cand": "U2FsdGVkX18hfmbnKzrav8zt0UrHonpsaBw4rSvGZ6I=",
          "cpf": "U2FsdGVkX1/xPw4Si4R/E4BcHb6gCgF2gfI2haXaCos="
        }, {
          "num_cand": "U2FsdGVkX1/sYHAru2ZhBw+JpYaUduWtz37HpvFXrm8=",
          "cpf": "U2FsdGVkX19LIPIAW/CBVqgPnvM8on2rEjP+GtVTgVc="
        }, {
          "num_cand": "U2FsdGVkX18OAan04Iu1waSq6dZ7wAK8IlfeniYLmds=",
          "cpf": "U2FsdGVkX1+xzHIl8wjS2xgP7UDkgL/SfRj22EpPY9A="
        }, {
          "num_cand": "U2FsdGVkX19d0ae2YtuM8fLzcVbjfOp3OeTxtdGMB3E=",
          "cpf": "U2FsdGVkX1+nin1Qoq0qe1WIdv/ZCsJqfAqIT/LLzFQ="
        }, {
          "num_cand": "U2FsdGVkX18tQ0PuL1x/qRJJ9+5vOkivk9PZtjUZk6k=",
          "cpf": "U2FsdGVkX19TIxzwgX8Y1gUFLEQnnA5SO67oUTfvnfI="
        }, {
          "num_cand": "U2FsdGVkX1/F4o7uABhzdjKrUSi0KE/RJ4y7XEy+c1M=",
          "cpf": "U2FsdGVkX1/eBqPDOi14mwRAQB2vF+M7/Ix3VaOaCOs="
        }, {
          "num_cand": "U2FsdGVkX189IChhA6fffklQY7YbRHxWvj5erCeOZDo=",
          "cpf": "U2FsdGVkX188eBd6qQlpru6IyzBoZbVI3PfrqDpMfu0="
        }, {
          "num_cand": "U2FsdGVkX1/xEDbOzhfZ8WhN+fYc6/Gft0EiDUjgtYM=",
          "cpf": "U2FsdGVkX1/FG48moMVJviQId6IO4OHmOR6GpUDp6IE="
        }, {
          "num_cand": "U2FsdGVkX1+tyBnm7xQ9TYnsqVV7LixVp6dkTLLVSvY=",
          "cpf": "U2FsdGVkX1+qfwnWOCq2VXUF66slzGuFtV1Gi/FqxB0="
        }, {
          "num_cand": "U2FsdGVkX1/IUGyCVdPjmDnw9dWg/xYpQ+lq2a3kJvA=",
          "cpf": "U2FsdGVkX1+b8Rgk5CUsV1P3vBiOTsNPM98vUXLRwfA="
        }, {
          "num_cand": "U2FsdGVkX1/QWP5ry6pY2q74n8jRX+fvTMeCNhLOnbE=",
          "cpf": "U2FsdGVkX1/XYxyObZrFYgzQwHtE0uFYD6Euujzo6qA="
        }, {
          "num_cand": "U2FsdGVkX18L3LYSP6O2Ly6NjdCusaqT89Y65u7A5Kc=",
          "cpf": "U2FsdGVkX1/9LnFxWz9oNcHDg3tq3oE08UMCJY0zi2I="
        }, {
          "num_cand": "U2FsdGVkX1+vFcs5E9u5BXOrHZoNFQOUICZ28t3150c=",
          "cpf": "U2FsdGVkX1+1g4F54fAXPY6EJYMg0ySTwJhBoZDKBp0="
        }, {
          "num_cand": "U2FsdGVkX18CKwa+AGKUrkaouiqQKQ/DRrpLyIFvS2k=",
          "cpf": "U2FsdGVkX1+voSuTG376EA19C92YXqxwNARRx0cfM40="
        }, {
          "num_cand": "U2FsdGVkX1+tKhpghLDlcn7oRgaP2JIL9aR2ZLJMnXw=",
          "cpf": "U2FsdGVkX1/+pu1tTdcVFyQB3FeqDEBREdTS+f7pnH0="
        }, {
          "num_cand": "U2FsdGVkX1/B8DoKOtgApLApHGm4V3KW9t8H9gani0I=",
          "cpf": "U2FsdGVkX1/gTIQlPUsEfY2CKbqeh4g5cDzt0dcter4="
        }, {
          "num_cand": "U2FsdGVkX1+orlpIUIFvpxJcibmweYXfv38z/NdlMSs=",
          "cpf": "U2FsdGVkX198IC4BCIYzkynFL3ptUoelvJ38RixT0jw="
        }, {
          "num_cand": "U2FsdGVkX1+Qmv8JYnojroCHngSh8k0mnBbcuRItcAw=",
          "cpf": "U2FsdGVkX18A7Ezylk1vNVpagRM+uPNoY/rdyemxTNw="
        }, {
          "num_cand": "U2FsdGVkX18z+hGrhunpYCgavzZ1broejLrweK/72u0=",
          "cpf": "U2FsdGVkX1+qBR2vALKjnTItFNU/UKSwbkbA2eZq/xg="
        }, {
          "num_cand": "U2FsdGVkX1/MtGLFXcrlZ1myfQUnNuKoGsxY7asGl9w=",
          "cpf": "U2FsdGVkX1/N4vmUuiV6S47PXNTC1l2ogojvgXNp3A8="
        }, {
          "num_cand": "U2FsdGVkX18y7ekcaoxgEVoX3WbY7MMNW1u/go2EQec=",
          "cpf": "U2FsdGVkX1+/o//NtX0sdfTlxI+fEN91aTzHWhEjKww="
        }, {
          "num_cand": "U2FsdGVkX1+vdnb2GdSz9Lg0FPJgAEe1jImx7/FQ41M=",
          "cpf": "U2FsdGVkX1+q5POpfwNZVSHJUzXuVYmR2qWUtgkP2lc="
        }, {
          "num_cand": "U2FsdGVkX19EKeY0OW065QnNkbdhjJiS+KQaap5N7KU=",
          "cpf": "U2FsdGVkX19wNdkFE+hwP0GsDjkURomnNFPPJ72PTB4="
        }, {
          "num_cand": "U2FsdGVkX19mVWQftRGORxVhf1e3q/Q8NG+btth02tU=",
          "cpf": "U2FsdGVkX194IKK273utKbf9vuWe2g0dJ24SgZWiwLU="
        }, {
          "num_cand": "U2FsdGVkX18lOPGSlZWjIoANKzB8KhYpx7fJZsXWMxI=",
          "cpf": "U2FsdGVkX18rEh/6mney2SLb5MT/tceY3rV/eaYZTuo="
        }, {
          "num_cand": "U2FsdGVkX19G3Bp02/LWpFrlQWo2Vevqzf1Bof5eVL4=",
          "cpf": "U2FsdGVkX18xwcJnNVCIxJddzyuMSVmTx4l2NffKBxA="
        }, {
          "num_cand": "U2FsdGVkX19wQEFEN6U2K5CgHMJ76qV1tLPQ1XSEYlo=",
          "cpf": "U2FsdGVkX1+LZ7O+LOqnZxagVLn4o4zD28KAjID0oFo="
        }, {
          "num_cand": "U2FsdGVkX1/l257+OsQOif+tD/Pbh2w2Zv2xUIVrVqs=",
          "cpf": "U2FsdGVkX1/fmytpxt88DTUbJUCfdK//5dDqVeRQ+1E="
        }, {
          "num_cand": "U2FsdGVkX1+L3bHG+5gTA3Qh9v/MZXTdEufRFLfHdVI=",
          "cpf": "U2FsdGVkX1/VUiaFV1UanLZBp73zMPSXJDMPA5K9GhI="
        }, {
          "num_cand": "U2FsdGVkX1+P3/OQSQTM/nHO+m71GWYr8oxwuSlm+Wg=",
          "cpf": "U2FsdGVkX19HRkEZUvQmnQh59l2bioCPIatnVVgUdTo="
        }, {
          "num_cand": "U2FsdGVkX1/OTNKY1wwddvTrI5mQRMd0it7ysnXGvEo=",
          "cpf": "U2FsdGVkX1/FCkgwUJnuJPjqqv2MTabJQU9keDwegFU="
        }, {
          "num_cand": "U2FsdGVkX18O0uUUiRvKy7K/Q4e4RfS0vcWFXDS21HE=",
          "cpf": "U2FsdGVkX183+RKZlFeszL6lrW+T6lyc4IEMTgVDrYw="
        }, {
          "num_cand": "U2FsdGVkX18TcNSjPCiAKsyqn58NXcrGUT+yTwIqGXk=",
          "cpf": "U2FsdGVkX19o54txMUjM+IykzQP7US4tkk//qM3FfXg="
        }, {
          "num_cand": "U2FsdGVkX19gNbChTzfnf1trrVNpkr9knFxPZQkfNIE=",
          "cpf": "U2FsdGVkX19W2/fvx5RdmJeH13pkRP50umUvMryXnbs="
        }, {
          "num_cand": "U2FsdGVkX1/cpWU0QlqslpQwNxnyeqiutFhJRrMouDI=",
          "cpf": "U2FsdGVkX1+TLPji9gsiEhl+BVJUa0uvpIcUokq6wqo="
        }, {
          "num_cand": "U2FsdGVkX18jfSzENAL2pHCRfDnZuUHeDpyBwuoUQYM=",
          "cpf": "U2FsdGVkX18TsYuVauUv4ciwNXJIi0ERfGjKma01lgU="
        }, {
          "num_cand": "U2FsdGVkX18XE6uRXvUu/fVWVK72AbcD4w87Sw2hD3o=",
          "cpf": "U2FsdGVkX18iudzwWzbZHYbtP9mnh5l8tbhlLrQH2Oo="
        }, {
          "num_cand": "U2FsdGVkX19LqyYa0A60U5GuMJuSVdcXHf5ZZEXCbJo=",
          "cpf": "U2FsdGVkX1+7MOM/KL7c4Y141kQrlcCdiOFcusdC6fE="
        }, {
          "num_cand": "U2FsdGVkX1/sgfd0zgsRTg/yUWLsEHBwhlsyyH0Nr8M=",
          "cpf": "U2FsdGVkX1/PQHORhLmSPxCE0fJ2PyVqH0qyYJjymKM="
        }, {
          "num_cand": "U2FsdGVkX19IEIT4aqEBMHpFR0HiOZu/6qRyuy04HfU=",
          "cpf": "U2FsdGVkX18Z9Nv4p7wzA7LSxBaSWUVaW01qGJZVbdU="
        }, {
          "num_cand": "U2FsdGVkX1+FU6N7gxL0RPiZaLDGpXeRKdB2YC3d/uM=",
          "cpf": "U2FsdGVkX18Uv3dch/gu2oIilYxQ5MPihaTAPyoRTnw="
        }, {
          "num_cand": "U2FsdGVkX1+fl3mTTnirMx3V/1a+Y0zxAEUNNoBqP3g=",
          "cpf": "U2FsdGVkX1/3hIQg7GwtcErYwkdc3vVaP/vh0ICn14s="
        }, {
          "num_cand": "U2FsdGVkX1+Ip/syMwthW7u62ON4F5BrfWulNMxMMN8=",
          "cpf": "U2FsdGVkX1+6+9+ebzIcoLo6e/+iF/dZYnEWzvCa+c0="
        }, {
          "num_cand": "U2FsdGVkX190Tgz8KRHAlwS0uxJRCiqDZDWBkY47rOA=",
          "cpf": "U2FsdGVkX1/VIRdg/FDqupdi+mqG0nproO3Z1SRT/Ho="
        }, {
          "num_cand": "U2FsdGVkX1+tP+/HFMr2KyhOA+0esPVXjW53GjNQ8aA=",
          "cpf": "U2FsdGVkX19bQmlwTBQgsJESL9+M30o3uDXY6ZST4kE="
        }, {
          "num_cand": "U2FsdGVkX1+bWWSrRRSMN1Wx5dM1z473Zu25lcFI/9A=",
          "cpf": "U2FsdGVkX18UM5gWssHViHgNCMiuTAZ1sa7wnGCeZXU="
        }, {
          "num_cand": "U2FsdGVkX1/3+ZOAQctA6Cu1tj7vqndYVI108FeYjBY=",
          "cpf": "U2FsdGVkX1+/eYzu2GyZ93MStLrUUh3uMYuO+AFIyCU="
        }, {
          "num_cand": "U2FsdGVkX1+hZuPVG+4Np/63lDfXQvECzqo5ayvqn7I=",
          "cpf": "U2FsdGVkX1/B0iqQGGztC+Qj/+akUab/eto1SAhu9s0="
        }, {
          "num_cand": "U2FsdGVkX181VzN3lyiiQ5y+AKxWXh2F5o4XImN0i7w=",
          "cpf": "U2FsdGVkX1/+CIVxWjH/CBlJkp5NnaQFOORlUhOg2v0="
        }, {
          "num_cand": "U2FsdGVkX18pWCUKon3o0b4clwfyM0JhP9jIpHgFdhE=",
          "cpf": "U2FsdGVkX18zOPnLav7q3fDkx8u8KmMbN0/hrMLpcDc="
        }, {
          "num_cand": "U2FsdGVkX1+z6b7y/akRkh86FxhM/CZ2IsI/pklXSAk=",
          "cpf": "U2FsdGVkX1/nZm52ZCkSYzbpEfS/1FlNE5EsnULWE90="
        }, {
          "num_cand": "U2FsdGVkX1/7VK6oAV8LM/hwuSRGcqzlsGlLFqNJDIg=",
          "cpf": "U2FsdGVkX18XCP+LNIDb6G5/WAVj8I1V2cKZ/KI8SIw="
        }, {
          "num_cand": "U2FsdGVkX18IAGqiz28x/63uYV62uKMOnJcCKBZ8aVY=",
          "cpf": "U2FsdGVkX19ts/kqwyN680np70Wgr7/JFWuz8LkxzK8="
        }, {
          "num_cand": "U2FsdGVkX18wU3bV2R5bxZVN60xvUqhHdx61xv9r5gk=",
          "cpf": "U2FsdGVkX18/tvoD0yidl4lD7hBpgAbDgOmlf/QIsl4="
        }, {
          "num_cand": "U2FsdGVkX1/Hogic8uZFYs/cEvQwl4EN9RdK/XEz+gw=",
          "cpf": "U2FsdGVkX1+DGTD3xVTUjrY6/1+o6a3moCTy/Q2x4NY="
        }, {
          "num_cand": "U2FsdGVkX1/wNHmcFNAwqyDbVbc9UvWJHJAWPK/9sIU=",
          "cpf": "U2FsdGVkX1+2vG0qMSiGdNoCbk7T2H5LUFv/wRziEBQ="
        }, {
          "num_cand": "U2FsdGVkX1/XlPTlEF5TD1q7bkatVqUTBNbUmUggkU4=",
          "cpf": "U2FsdGVkX1+uDESxgvGvGIYpcBHcgHvibGAKgTPpclQ="
        }, {
          "num_cand": "U2FsdGVkX19+ROquTWRxwihOh/tN43nppSBpfGFynZs=",
          "cpf": "U2FsdGVkX188a8e6+gYVWz6XLODVP606eoWE1XSLBbA="
        }, {
          "num_cand": "U2FsdGVkX1/NoV95U5A7eeAzc6YisF0kvi7aXSRDfU0=",
          "cpf": "U2FsdGVkX1/Pp+w62xAQqahS1W/XUP4iOv7lMR1DZGY="
        }, {
          "num_cand": "U2FsdGVkX1/6TrHxGXfgL+QgvuL2eaW+jY2Er92RJME=",
          "cpf": "U2FsdGVkX19EMXY2U4++VU2EkzMBk50F0lYVU3SqkZ0="
        }, {
          "num_cand": "U2FsdGVkX18VKS/Gnq6sYG+6bW2M7eQy7tVzKJ8mxLc=",
          "cpf": "U2FsdGVkX19uKf8dNzKD7ZnaUJxvD314I3RPqcDou1w="
        }, {
          "num_cand": "U2FsdGVkX1/qKH8tZHfNxEPyp40Rrk9AWbiK1XVptPY=",
          "cpf": "U2FsdGVkX1+LEtSegJUskMUoEqwkPXzbciClK5bZ/0o="
        }, {
          "num_cand": "U2FsdGVkX19k1wk5J+5EwV3GEOhGFpbmQd4wOnHRnEc=",
          "cpf": "U2FsdGVkX1+GmP3/cYTueoE9uqIqYynbzRYzvVuo50s="
        }, {
          "num_cand": "U2FsdGVkX18+rMu2QRJu5ylzWccyzRIT/cLwiARKy+E=",
          "cpf": "U2FsdGVkX1/C43oBDs1EHvNREtqiwKuSOwpd5f4uvJ8="
        }, {
          "num_cand": "U2FsdGVkX18ic9WRxbcBYvDRZKKe12IPn1Mh/21IY1I=",
          "cpf": "U2FsdGVkX1/alwSAAY+Nd9xYN+iyU6kQPOeRAGgz45g="
        }, {
          "num_cand": "U2FsdGVkX1/yxUExnA7oQU1+HmxgVCHKCLP5051B1qA=",
          "cpf": "U2FsdGVkX1+ezc9exy83oO9ieLddiHdm8DGwiGTwohQ="
        }, {
          "num_cand": "U2FsdGVkX19fKI1k+MbVVJT0yYp1DivghuMsI+uGbzE=",
          "cpf": "U2FsdGVkX1/OLbqFEnDxMfaOJtQsFJKaKMBRHq28dGU="
        }, {
          "num_cand": "U2FsdGVkX18eqlUuSOWuOEiYYhEON5Ee3x0gbINgIX4=",
          "cpf": "U2FsdGVkX19MBsP7YcS2yOWo5944ohiPBeW/jx+6KuQ="
        }, {
          "num_cand": "U2FsdGVkX1+SHh5hWXKctpKEN/lQuAVq4LIlRm+pbVc=",
          "cpf": "U2FsdGVkX1+REZLhYIOf3uvGCJoZvV2POkNXik8xNSQ="
        }, {
          "num_cand": "U2FsdGVkX1/Tpvmo07QAb7ev+g6wuZhSEQF1e5Rt42E=",
          "cpf": "U2FsdGVkX1+eKtGbHkTcV/MnSuUCQ3+uq9DQ/7wlYUI="
        }, {
          "num_cand": "U2FsdGVkX1/Q+hKZHicPllU8tvz+wpMwncich31aDpo=",
          "cpf": "U2FsdGVkX19rmQFpqCBsvaFI/iVZjGlsoxaIcPI3/Vk="
        }, {
          "num_cand": "U2FsdGVkX1/fTtEqp8b+kZ27kyvUQofTmcLIZ1R32Fg=",
          "cpf": "U2FsdGVkX1+Icz1Xm92O2qWFtg1oG6MO3hp/VzL0dmQ="
        }, {
          "num_cand": "U2FsdGVkX19l5I82IuZVcavTOemvUEnwJBQT5qz9zFw=",
          "cpf": "U2FsdGVkX1+kp5Z56dKaFfAEIT7eqtX3Q4528qQLW0g="
        }, {
          "num_cand": "U2FsdGVkX1/k2OXJA8WaSfV/IYrAZbgK8f0ZSqtNLUo=",
          "cpf": "U2FsdGVkX19BuxQSInWnBO/slmoNlYLAoVvdf1Gvjdw="
        }, {
          "num_cand": "U2FsdGVkX19nx38YdLtkyi4TDsjnM4C7ZOwMx/4a674=",
          "cpf": "U2FsdGVkX1+CZ2J7VvMsrADmS+LGjD0/crj938zyiOY="
        }, {
          "num_cand": "U2FsdGVkX19mjDNmXNi0FqG5Z1CTk7KFv4jJb0pzYn8=",
          "cpf": "U2FsdGVkX1+VxUEGiwcgpGwWO8BXPeWNC8mY6PF4Y68="
        }, {
          "num_cand": "U2FsdGVkX1/eXWeua4c9BrG7QrBNOaD5g1rH12iuQdE=",
          "cpf": "U2FsdGVkX1/6GIS/UKUPjBOx7WY58dp04/Gia3Rrmyg="
        }, {
          "num_cand": "U2FsdGVkX18C10eoGdUUEFRmboHBnZxQSqQPvzbCzrA=",
          "cpf": "U2FsdGVkX18HshUTrfUxzN/CXWP9bYs8Chqhhloq2IE="
        }, {
          "num_cand": "U2FsdGVkX19HYWXmvaV5tRys9rCSZDxtVQkff1zcG/c=",
          "cpf": "U2FsdGVkX19Ez9EDWvFIl98cfQrq/dgEjmK6jcqPo04="
        }, {
          "num_cand": "U2FsdGVkX1+s3UWdCJcOZzAmeQaTd1iRcVgTHwJaT2Q=",
          "cpf": "U2FsdGVkX1+MP2kkLDi0Lym3HY9YbkIFAQWZ2oEa+Is="
        }, {
          "num_cand": "U2FsdGVkX19JnuNRlLXbX+P6FFIjAzlHJwbB5fi37FE=",
          "cpf": "U2FsdGVkX1+aeVEtCORkMJWGARSadF5NCJP7nM5T6Y4="
        }, {
          "num_cand": "U2FsdGVkX19ElMbn7PqHHM5F64iOVa9EztviVJjLg4g=",
          "cpf": "U2FsdGVkX1+w0O2uww9wO+EX4l4aAJsxMrEsTBWiggY="
        }, {
          "num_cand": "U2FsdGVkX1+WHDGo8rMQhre7p9SZqG1qKkM4/hIylt8=",
          "cpf": "U2FsdGVkX1/6L925g2Ql0nG0oQJc9fBlTCXdPh4z2eU="
        }, {
          "num_cand": "U2FsdGVkX1/NBksOOc8X+W+APt7AGEj9cOzR5S1p2j4=",
          "cpf": "U2FsdGVkX19j4Tr/Nv8U6L9V47eDCkJxTkkaI31gP0A="
        }, {
          "num_cand": "U2FsdGVkX18w7xrgmO0CL6z8azQiOOk/lfD1x0On6To=",
          "cpf": "U2FsdGVkX19V1aeisDnY0HUjFbOuxHCvx27MAKAMG+g="
        }, {
          "num_cand": "U2FsdGVkX19htjCgVLSoMSQrsm+iuW6omCWmnWtLshA=",
          "cpf": "U2FsdGVkX1/SFIyvzorgI7FCLbXOdinjguN60LhLI1k="
        }, {
          "num_cand": "U2FsdGVkX1+8qZLlTrsa8t1kVdndpT1byPuIWdGRQQ8=",
          "cpf": "U2FsdGVkX1+DBUFHIN5Gr1uvbW67jtfcCVarms9mrBQ="
        }, {
          "num_cand": "U2FsdGVkX181mDJ5vsL4N3n94wLj0G9UDxwlrOwN7sk=",
          "cpf": "U2FsdGVkX19y+yWHm4Azl3husuWa6a0rXVZcTFJbru4="
        }, {
          "num_cand": "U2FsdGVkX19ne15moCn4YQPvhIss9QCRORsi9IpH58k=",
          "cpf": "U2FsdGVkX1+pKoKCPUzhxkkC26Op9Kx8hwtnbr6llmQ="
        }, {
          "num_cand": "U2FsdGVkX1/I2rHuB3Eq7jU8VOfilYQEANvtgVWVFpQ=",
          "cpf": "U2FsdGVkX19TGzolI22lq3TTneg84ZSUXskU2wiXT84="
        }, {
          "num_cand": "U2FsdGVkX19bP067kpuLEV85urGspmkAr82P8IJxmME=",
          "cpf": "U2FsdGVkX191jN1yLdzm3/p1xFMtn3DoODG17MwOxIk="
        }, {
          "num_cand": "U2FsdGVkX19dlyaXwPQYD2Js/VugQqNlkSW0OY75i/E=",
          "cpf": "U2FsdGVkX18TCXcKO+hcJuEFs0+4ewP4wMFK7qhVXAE="
        }, {
          "num_cand": "U2FsdGVkX1+0YyVj4bJX6LUyZfX5GCZWCGnCAoKrohc=",
          "cpf": "U2FsdGVkX1/XNLtb5TOmxaJkMgoNEj5f5zMaFVRkCjI="
        }, {
          "num_cand": "U2FsdGVkX1/tNgOGSpH5I7VE5FqrIusw369DijBSH2I=",
          "cpf": "U2FsdGVkX199jI+LFHj55hm4Qh4rQu8yLEa9uWYHeTc="
        }, {
          "num_cand": "U2FsdGVkX1+V/xQm4oq5AnF/z6emOvgQBm4M8VMqMgE=",
          "cpf": "U2FsdGVkX18ggmg/v7nQ7yoh25VbmWb3KcGyR78G5Zg="
        }, {
          "num_cand": "U2FsdGVkX19pffYQTOHalukIMnC3ThnVTSq3A0OLNIc=",
          "cpf": "U2FsdGVkX1/eWSty/xiD35QErgkFtq3jZ1Ox/sib178="
        }, {
          "num_cand": "U2FsdGVkX182FJpESqjQn6PHbqobrcetTqFlLh0zIN0=",
          "cpf": "U2FsdGVkX192VQgoW4iRnBjl1tietLfNbspgMYUGhqI="
        }, {
          "num_cand": "U2FsdGVkX19dgRTxZmZq7H3E2onoJfsTjTQpAEdsRVY=",
          "cpf": "U2FsdGVkX19GDMLyHaDk15aEihrRJ07FXNdDQSIgMdo="
        }, {
          "num_cand": "U2FsdGVkX1/MUPvNSXcJsgGJGNqpk4p5SBLMHg13hgU=",
          "cpf": "U2FsdGVkX1/eDtUjH5c6reNK/gpsHUeuKPqfFRRITdg="
        }, {
          "num_cand": "U2FsdGVkX19/xLfiJBkeQ15Dz0HgxTTrkKvaHooqfyo=",
          "cpf": "U2FsdGVkX1+j8txUvQ282GfVBml4eYM2Zvy/48++A0E="
        }, {
          "num_cand": "U2FsdGVkX1+b2A8ueNO5276h1AZ1ZplAN++UpC3ieaQ=",
          "cpf": "U2FsdGVkX18w9/67U+WZby73G82+sLxHbHm510mNBjY="
        }, {
          "num_cand": "U2FsdGVkX19Avfgc1N9cRxu/K0FZQUNdwP6U/LSbT2E=",
          "cpf": "U2FsdGVkX1/ufzROs4MwGuV9v1j0nUljk3oX8cP9Hfs="
        }, {
          "num_cand": "U2FsdGVkX1+TMpNXPoZRrP1tTYJL3YAjNyobGd5uILU=",
          "cpf": "U2FsdGVkX1/OzshlYfKZw0GmsFufgnEqxc2eeku50qA="
        }, {
          "num_cand": "U2FsdGVkX18yNZvl2w0jLBX5dD1pSxxKoUxzhdtTS6w=",
          "cpf": "U2FsdGVkX19cxrq1G6gbj8TPZixae3BKOxZFYtjtKoE="
        }, {
          "num_cand": "U2FsdGVkX18UUa7Ldi2JDUEoo8dfO/DOTQznVRQI120=",
          "cpf": "U2FsdGVkX19GKEUk38XQYr4IviIGY7lB+k2/H8Rc53M="
        }, {
          "num_cand": "U2FsdGVkX1+mNCUzE5DM9p/36YOrsAjwStjkFLHn+TY=",
          "cpf": "U2FsdGVkX1882Wbv92LwTSXrlH9rNdGH/mmP5qXdhO0="
        }, {
          "num_cand": "U2FsdGVkX18wQqCjfvX1XrvwbsN6puSQJOueFqE72oU=",
          "cpf": "U2FsdGVkX18YqMPaahKJuzE//oH+UmP6lza48no22wc="
        }, {
          "num_cand": "U2FsdGVkX19Ak5HFpG6+LbPSA5MxJHtHVDzd+xZEBL8=",
          "cpf": "U2FsdGVkX1+DKHHj/EQP3bCGmdKGoQP/u8hffAMkd/0="
        }, {
          "num_cand": "U2FsdGVkX18ZYny2PdRaQPmSleIMiuSvrcBHMGns4yM=",
          "cpf": "U2FsdGVkX1/cSnHs5hCcXVzIZ7uTOBBDm6SytC7+hwM="
        }, {
          "num_cand": "U2FsdGVkX1+Sq1Nx54cT5x5l4j/G/riOp0mPTl6Q83E=",
          "cpf": "U2FsdGVkX19dVM3BRoruOho++N41TRYz4jpAIo4SV2I="
        }, {
          "num_cand": "U2FsdGVkX1/dX+C3drc8Cblt4R9uIdAlZhHckq1PR80=",
          "cpf": "U2FsdGVkX18jIrgVaPq3gQAUTUfRRRAEdZvXz4jpaMw="
        }, {
          "num_cand": "U2FsdGVkX1/lWH3RePuHL9hxVC6Vt9xdpesyTYAZgVA=",
          "cpf": "U2FsdGVkX192e83vdlNwFYWFfp45ZujX2XMPqJKHcJQ="
        }, {
          "num_cand": "U2FsdGVkX18lve93vf/DqrhRVIzc/t6WjLh/5UyMyRI=",
          "cpf": "U2FsdGVkX1/6GxEHvaOHUrF02Untita/5M9E/9qBKVg="
        }, {
          "num_cand": "U2FsdGVkX19+KJJItdajGziIOQSzbKMUXSEH+pml8f0=",
          "cpf": "U2FsdGVkX1+WvKVyzYxzeSL13dHE+GGwt2cu5uqOBzk="
        }, {
          "num_cand": "U2FsdGVkX19RsNygEcRy618AVOaC0WbVye8gOGEP/OE=",
          "cpf": "U2FsdGVkX19/iJcw+2o8vCurazqVopN2yf6owYjkteQ="
        }, {
          "num_cand": "U2FsdGVkX1/4JIQ1B64ql1yV70kr1Hkia0lkvBK/9AM=",
          "cpf": "U2FsdGVkX1+KLrMqldGespeephOWK4pGa8Etec8kY9g="
        }, {
          "num_cand": "U2FsdGVkX1+p0gGRqdA26rY4DNvkrC43vlVNUhncDEo=",
          "cpf": "U2FsdGVkX18IazYBRr0xzFUSBmkXl+K8UGtTDCnfQWg="
        }, {
          "num_cand": "U2FsdGVkX18jwPVDr1/3Lb8IBvch++I0EcDNuEnl6hU=",
          "cpf": "U2FsdGVkX19fx+u/uQOHxIsS4fyI72Zqbmgig/ASt3g="
        }, {
          "num_cand": "U2FsdGVkX1/TbTURMbqRgEZ1TKus/rgXkWSch1EnffA=",
          "cpf": "U2FsdGVkX18Qqc+mC9IBPe6AH3u9YG9OjmeX0FyYpio="
        }, {
          "num_cand": "U2FsdGVkX1/h8OuHj5Jk9bp+CpPC3hY1kHX1oh7QqI4=",
          "cpf": "U2FsdGVkX1+qpFhKkrpgGO8tr7T/Pgi82KIKkoz2ZlY="
        }, {
          "num_cand": "U2FsdGVkX19xxDSYbTsrY+xbGPR6FcRM2x+bNfz8M0U=",
          "cpf": "U2FsdGVkX18/rCnVCAEePSXZyGcIfEQUT76gPPNuN80="
        }, {
          "num_cand": "U2FsdGVkX185XpGLCm+YrHTm3Kwnt8iOSvKGsx6giTs=",
          "cpf": "U2FsdGVkX19Y0e5roKkaFQEToNJl9PRBZZ3+tNM9t9c="
        }, {
          "num_cand": "U2FsdGVkX18DZbmr0geeyLsUlvrhFQWtLXvTbr3jUHA=",
          "cpf": "U2FsdGVkX19WQ9JtTfTCQ5G7mN/sgq6oeINs+E2RO7M="
        }, {
          "num_cand": "U2FsdGVkX1+F3+9UNIw439gvHxrthywZt8Zgm8sBZfE=",
          "cpf": "U2FsdGVkX1+wAjTLc1LTo7F7quLX/yDfM0yluniAXG8="
        }, {
          "num_cand": "U2FsdGVkX19P5Wc2i3E3dzz4vZtqCej4YYNhsFhuR+Y=",
          "cpf": "U2FsdGVkX1869GdKSUK4fMRD9nAhGAzSIdvDBoQimeY="
        }, {
          "num_cand": "U2FsdGVkX183QBEO+fUEro07C2ZSn3av3iVVzpqmcuE=",
          "cpf": "U2FsdGVkX1/UNZntgBs9+QupLktbaAVIP8KREIf2y90="
        }, {
          "num_cand": "U2FsdGVkX1823hOJfXYsuHKs78XULzBFMWlP7zi590U=",
          "cpf": "U2FsdGVkX1+mHy7B5q3MHa9H7B+ZmzzkxOkDLKwHQY4="
        }, {
          "num_cand": "U2FsdGVkX1+ztbGQKGaz4RLdV/MD1yvcVwuKTNM/PDU=",
          "cpf": "U2FsdGVkX19U+auNrA+sbyxjzZBvGepgknH8qloLYME="
        }, {
          "num_cand": "U2FsdGVkX19l7aoTVvCUsq8hV+bySuxSDQ6EOz+mlGw=",
          "cpf": "U2FsdGVkX1/9vS0mfs3wDsIZDfT3MyTuA0XBuPaUda4="
        }, {
          "num_cand": "U2FsdGVkX1+QIiveZ1/thdwZbttZxWK9jmn7rs/oc4s=",
          "cpf": "U2FsdGVkX1/jUMxTc9BdQQ/rd7gF3zBbGurmGSGxZeQ="
        }, {
          "num_cand": "U2FsdGVkX1976lAnSCTBXpjhgSkkJAcHnRaZc6lggo4=",
          "cpf": "U2FsdGVkX187s5/8Rl8nYyRPfPziuPiAd5PJ6ssrxNw="
        }, {
          "num_cand": "U2FsdGVkX19ltLH2K5ik5HkH70laD56Ff22SDbCxx/E=",
          "cpf": "U2FsdGVkX1/sIMefntRrPefFzTpikdhgT3s0BiVibF8="
        }, {
          "num_cand": "U2FsdGVkX19rrcGibYhxKgA45L7SaZxdc2R17d+VSnA=",
          "cpf": "U2FsdGVkX1+0xewemKwrsbvxjrtph/OpmjK9Op0xNdw="
        }, {
          "num_cand": "U2FsdGVkX1+2zLIlMhMUHvo6RAx8SocUIga/Ln/O5Sc=",
          "cpf": "U2FsdGVkX1+cTS08liFN2pmL0EE/r0aIuMs925Jo+Jg="
        }, {
          "num_cand": "U2FsdGVkX18ya598HrfJY4BjvWhR4j5k9TyrxJzINow=",
          "cpf": "U2FsdGVkX18UpxbxMniD2fw49LBMjES4riKWksYLCXg="
        }, {
          "num_cand": "U2FsdGVkX19b/UjvcrE/GUZhuvl4exukqFkzi0Zpy3E=",
          "cpf": "U2FsdGVkX1+u3/KxPHTKim5IEZ1GKc7u0mMmShQWefU="
        }, {
          "num_cand": "U2FsdGVkX1+gfC6lBSLh2HLiMTMKZboaFmuU0a4cMHI=",
          "cpf": "U2FsdGVkX19k7R6ho5rvW5xaZAVuoY7oZBRap1FK0/k="
        }, {
          "num_cand": "U2FsdGVkX19TpazWrgUnmbAnZBn8pThVFJ/ESVBQQR8=",
          "cpf": "U2FsdGVkX1+nQvSYM11xoZwdtFXDQG3Nk94kl6Qpi3o="
        }, {
          "num_cand": "U2FsdGVkX18T38G8392rB3EiV0yu6ebWCWPZtbtq1n0=",
          "cpf": "U2FsdGVkX1/rQdJVuErm5GDNdhhT/iu/GA2WCjPu66Q="
        }, {
          "num_cand": "U2FsdGVkX1/OXVlxXcnoPvfj2phQqHdSquT/oQCSiGo=",
          "cpf": "U2FsdGVkX1/Cl3JuY0tY7CT+co3RATUU+HXQKeqZ7B0="
        }, {
          "num_cand": "U2FsdGVkX1/QAgme4GlaDR823iIiLpuPHOpUCsXRyS0=",
          "cpf": "U2FsdGVkX18lUsPdz6DU/pXs99Mdgo/5PxovTiwU69E="
        }, {
          "num_cand": "U2FsdGVkX19UVO+zIMtLRDH3qAlILYrX1BBHxbX/wZU=",
          "cpf": "U2FsdGVkX198GbT2Age4e7HSEst0dlmXFNHR2eFZF2w="
        }, {
          "num_cand": "U2FsdGVkX1/ReSCu0RG6D8G5sOImzxtD/692KCL/IJw=",
          "cpf": "U2FsdGVkX18RfCbNZmcD0wwoY3YjQ2lVP20iuuG3ubs="
        }, {
          "num_cand": "U2FsdGVkX19UOC3oxtbSwRXfjpzIG+Xd5i7USVKpcHc=",
          "cpf": "U2FsdGVkX1/dGpm+oabplT53AW0Y3aZax/lrySVSpF4="
        }, {
          "num_cand": "U2FsdGVkX18YQox4+GMcg2+8AwauLlu+BLDyLswiIcc=",
          "cpf": "U2FsdGVkX1+/cOFQNKvESkXhy80nhQDh7L5RP5rSgQE="
        }, {
          "num_cand": "U2FsdGVkX18wTye5z9H86mU670vuzefcnZiiFmL+NfQ=",
          "cpf": "U2FsdGVkX18ReiBuoR7Ier5wXI8Txj3NGCwPyJbRtVw="
        }, {
          "num_cand": "U2FsdGVkX19Y/lJHXVmPZaZ5HnMN1SZe69/6Fx370IY=",
          "cpf": "U2FsdGVkX19TeoDfEZsK5/UtAcqp66HByNWqjBZjPyQ="
        }, {
          "num_cand": "U2FsdGVkX18O3TUKbWf72GbLjI6Ddgs9EE4hj/cVg6o=",
          "cpf": "U2FsdGVkX1981pdGQvBcD5HpYS/hQpouZlrrx9H4w/Y="
        }, {
          "num_cand": "U2FsdGVkX1+SdbN7NClgXBXDI4M2VJCjnMFw7D7AzPA=",
          "cpf": "U2FsdGVkX1+L/f08k+Ec349jzS2iufzOoWIBoNAVhW8="
        }, {
          "num_cand": "U2FsdGVkX1+h5S5ytpohjJRy4sA5PnvT1tYnv5G+04I=",
          "cpf": "U2FsdGVkX18zOmTiQjOl2jPi1OV/1Ps9K0+twAbrDv4="
        }, {
          "num_cand": "U2FsdGVkX18j+vU/weq+nSHuf2RCHjqCYq98Sb0/PyI=",
          "cpf": "U2FsdGVkX191Ldmg2Ycy+97lTgZHcIYfXFPR2kAjGHk="
        }, {
          "num_cand": "U2FsdGVkX18+TWkLmhUacpI9Dx8o/ArDs8S0nUMieu8=",
          "cpf": "U2FsdGVkX1+W4HVm1adB7du4UGtLUbBBB8IWthNElp8="
        }, {
          "num_cand": "U2FsdGVkX1/oFKPgBAKXOv+vOyOzQqEuzwOpcL57atI=",
          "cpf": "U2FsdGVkX195ZY52NjeMVxmPS60lrkk2xD+EPx/plDM="
        }, {
          "num_cand": "U2FsdGVkX1+y5UnjIi3bYCzYN06XAPPf62nQKMtsiVc=",
          "cpf": "U2FsdGVkX19irUpKdYRHRi/SAKLmZ3ekccV1Xef3L7Y="
        }, {
          "num_cand": "U2FsdGVkX18anKz7dZKxnfZfNyEkOOj9g26bIvt9W7Q=",
          "cpf": "U2FsdGVkX18oaJHc1TV/MwJ7Txy007QN/lANML3kEMc="
        }, {
          "num_cand": "U2FsdGVkX1/BILqxs6CMLKcHaHg/82fkkRK8j9x/ANk=",
          "cpf": "U2FsdGVkX19sSvCYIywvNEDaFeI65ULZ33Egw5DOjYo="
        }, {
          "num_cand": "U2FsdGVkX1+qDykFBj5YAvhVqrzmFcrwUct0nJmmm34=",
          "cpf": "U2FsdGVkX19clLn6fcVITqRQPgE4QVCP64ppu7EPJUA="
        }, {
          "num_cand": "U2FsdGVkX18vmdjmOgIcWQJJ+8icOb+VQtPL4mN8GQ4=",
          "cpf": "U2FsdGVkX1+QH3mY9nr7UHnQ5RCze5hokb1pe4fzD9g="
        }, {
          "num_cand": "U2FsdGVkX1/4QGVsjai2A6YxqaAQnPQI5bMC6uRl/dQ=",
          "cpf": "U2FsdGVkX1+92anAN2pxTZyBP8TrX9nHAQa0B8khtBI="
        }, {
          "num_cand": "U2FsdGVkX1+01swBmhxyj+YZwivFcCQavcCtzeH1hYY=",
          "cpf": "U2FsdGVkX19Rbq9EFPEArTc/3/CIhNdzBy0cM6Z9VbI="
        }, {
          "num_cand": "U2FsdGVkX18fcTRctaQCDvRlEeH07KjAxJNuOYW2Xkw=",
          "cpf": "U2FsdGVkX1+UO/4L6Hvs1R7aGKce26uVEsHPQ2D+H98="
        }, {
          "num_cand": "U2FsdGVkX18X4w8X1jmgfTxS9SfNCXEwOy8vJ3dB8hM=",
          "cpf": "U2FsdGVkX1/cQktt4efdptim0VWMK1QyRVtk3KGBMpY="
        }, {
          "num_cand": "U2FsdGVkX1+4ikVlSJOkgJXfOEoG1DS6StiX1S3c0QA=",
          "cpf": "U2FsdGVkX18mM/DyOUgUW8qUy0/Wy59Kp8A3LRyQetI="
        }, {
          "num_cand": "U2FsdGVkX19Es4Zfi/Nc6451jouV8tiXneVhw6YFb5c=",
          "cpf": "U2FsdGVkX1/sS97IwBkfKMjBsPWy2PHkieIE89YlEX4="
        }, {
          "num_cand": "U2FsdGVkX18xZjgF7LtYVrOmsemRssWl4+yArIGdVBo=",
          "cpf": "U2FsdGVkX18hSaOIRuPnZEN2IG01QgxVai6AZ+GFWrM="
        }, {
          "num_cand": "U2FsdGVkX18ixKxic7pYyBeZTult+yNblM4gm76HZNo=",
          "cpf": "U2FsdGVkX1+xzrRF7uZ9G8SoWwJ0DS9zlVtI4ZvXTDQ="
        }, {
          "num_cand": "U2FsdGVkX1+CQ4GIv12FLa/JHJ21XQVco0ullEA/zjM=",
          "cpf": "U2FsdGVkX19zTFfk+bflok3r2TjVsdYMRCL2tDMF5y4="
        }, {
          "num_cand": "U2FsdGVkX19MbSi9r36VNLAlGRGO4zjXUXMLKjSlWSo=",
          "cpf": "U2FsdGVkX197k3z+EsLo3THGNwcg1gSw0sabF0i4APM="
        }, {
          "num_cand": "U2FsdGVkX1+U9ECvn3pP09F+Xe6FCThG7BZXBf3VkJk=",
          "cpf": "U2FsdGVkX19bQfN3AW1HtGFjKQeszUnuZ+qMGxgyIjg="
        }, {
          "num_cand": "U2FsdGVkX19XLln+PLhfYCuvfJv0pxxk+/pcQXRyGUM=",
          "cpf": "U2FsdGVkX18PI4bVZJy8+h823TYEVc97M2852VTm/rY="
        }, {
          "num_cand": "U2FsdGVkX1+lt9Kflk20hZkdTMwOT096ELnwm/nDx6w=",
          "cpf": "U2FsdGVkX1+tlkuTyHUCdChY0V2TjudLk7NPeXNgMh8="
        }, {
          "num_cand": "U2FsdGVkX1/7BSx7GzqDnK6yMf4XpGCFt3OhdOPg4kI=",
          "cpf": "U2FsdGVkX19DJOPQYjxjiuXHX3zEZcmvSWDGV0QfobI="
        }, {
          "num_cand": "U2FsdGVkX185IFwfXc6R0dyCiRTHaHiAA6bXGKTGFdk=",
          "cpf": "U2FsdGVkX187dZ6bpGiClhAO+LqpexUusg5bkQnQzWI="
        }, {
          "num_cand": "U2FsdGVkX185OzR/XFs+irnsmaMFGx9Z069lq5wXH+I=",
          "cpf": "U2FsdGVkX1+iZ9pIAosEzoDnEoXvGOEjwEIsM+rKE7g="
        }, {
          "num_cand": "U2FsdGVkX18pbssysLgWcATXoEgSCKVsrndta4EcWKk=",
          "cpf": "U2FsdGVkX1+zLtI1a59KVhW87YhvjQaTn7gIMiL2XVc="
        }, {
          "num_cand": "U2FsdGVkX18lhV8VyJ2aFxp/YFQVBl7IoimEJFiQIXY=",
          "cpf": "U2FsdGVkX1/+YHmb/AioHN/fid7hCnHq6e3vAWx+7JA="
        }, {
          "num_cand": "U2FsdGVkX1/vhKP7AJLqoc8ErJcbl2ozoQEChEnXa1Y=",
          "cpf": "U2FsdGVkX1/wSPb1UrXCtWFAzBv7nEzzSTJVWqEkmac="
        }, {
          "num_cand": "U2FsdGVkX19rMAtrWZRmqUIq0dI5jOFrON1OPNe4QLE=",
          "cpf": "U2FsdGVkX1/TOcy+h3NWYgm2QZRKOzxs53kQGL5/bqk="
        }, {
          "num_cand": "U2FsdGVkX19izzU3iyLAJuoC+OPJTwEWr/Y5CQR7aCQ=",
          "cpf": "U2FsdGVkX1/X6zEp4MpnNGyd+ivn5GIm6GkT9R1R840="
        }, {
          "num_cand": "U2FsdGVkX1/FoKBuUhFfaCokNZj5U25I0cgcTFqbMYI=",
          "cpf": "U2FsdGVkX18cp3UlUQGg5gvrvtdoLuojcDquPTVoWjQ="
        }, {
          "num_cand": "U2FsdGVkX196GDp5Bnot9b2z4sOTsE8umJVUdadgfDo=",
          "cpf": "U2FsdGVkX1+DDdRhnkLA1Gh7GEvyfJys5nvA7rNhr5o="
        }, {
          "num_cand": "U2FsdGVkX18O4cCWRxnG2zFB0t/8Mo4A34WNxFZzIXU=",
          "cpf": "U2FsdGVkX1/QqqEYZlB18KXAAu4fj0671oc9WgycTe8="
        }, {
          "num_cand": "U2FsdGVkX1/apU9sgbZ8jhnudMqvH+5q7YsTjzTO+5M=",
          "cpf": "U2FsdGVkX1/J3ySTZTYIhvO42JK9ovC2FD9TJmxQVHU="
        }, {
          "num_cand": "U2FsdGVkX1+BCRLQekN3WIxstSo2bvM7XJKVm4SmaSM=",
          "cpf": "U2FsdGVkX19iLpiH0pti3N5oBEa6Ks967RIC0CJq9dU="
        }, {
          "num_cand": "U2FsdGVkX18SDAVnqTRiNaKSbEKqXNWmPYbuR3CkM84=",
          "cpf": "U2FsdGVkX1/Pqo/0HXBttZxLTnL5wRy5uFl2v1kat1o="
        }, {
          "num_cand": "U2FsdGVkX1/L0ZCuFOb16IOtRnQm0deBXSPfTmeOFWQ=",
          "cpf": "U2FsdGVkX18NRg2+4aF158rnvOmSdIMYCr+dL5i00Fc="
        }, {
          "num_cand": "U2FsdGVkX19NoJQX2VI4fS9RkbX7vrdvO/PGh8x2Vr4=",
          "cpf": "U2FsdGVkX19S8xpSA6k5J7e1+f6WW/x9lj0Pi3qSo58="
        }, {
          "num_cand": "U2FsdGVkX19sSh7XyfunEfIln5kSYQ4LD9zb6/xw/jY=",
          "cpf": "U2FsdGVkX18pMRysXgKDVS4wHpAtOYV4q7ypITgkW38="
        }, {
          "num_cand": "U2FsdGVkX19/coW7xjYN+wehcN3p6WeNxMqsgEcvUmM=",
          "cpf": "U2FsdGVkX18IYkgdH2CCjQVh2GBDRnLTsUaXsFZiFJo="
        }, {
          "num_cand": "U2FsdGVkX1+G0TEgIZugojd4P3tuj58BM1KTIs7p8qo=",
          "cpf": "U2FsdGVkX18+CoPYxDZG+ch53bQ/6OA7Frlny9WKqQo="
        }, {
          "num_cand": "U2FsdGVkX1+ayQQrEg4+Fd06YF3ZMAjzjdFjsiz6EgM=",
          "cpf": "U2FsdGVkX1+5z2shJlfpCeYnQVLwH3etgvwnPfByfR0="
        }, {
          "num_cand": "U2FsdGVkX1/eXz2RKSu7WzdeiUvrFrCeXTiBc4ExTpY=",
          "cpf": "U2FsdGVkX18FwfB2luKoBzKtXKA3bWsn/nYG2RJftns="
        }, {
          "num_cand": "U2FsdGVkX1+iJS/4Po2CWK61TpVtptpGVEaw1IL8qHs=",
          "cpf": "U2FsdGVkX19jJsC4j5G6qbfAvc52CpKgkluQqs+LTHk="
        }, {
          "num_cand": "U2FsdGVkX18GXzXv4HzZk5jFbOGya/MxYAAKCoq7KFg=",
          "cpf": "U2FsdGVkX19wHVGJIbhvZTZ63daVVCkzMcMUf1XH528="
        }, {
          "num_cand": "U2FsdGVkX19XfbGtXJwM/1TEKNhnfQlqT95kyABxHJk=",
          "cpf": "U2FsdGVkX18dftT9JKiiZd0WOyo0THK2FKjPAybbJ4I="
        }, {
          "num_cand": "U2FsdGVkX1+sIb/64DAIGLfGkZnORzU5s2xbrEUfRjs=",
          "cpf": "U2FsdGVkX18vo09doIzQY16MrCi/0o9daTekY0YQISQ="
        }, {
          "num_cand": "U2FsdGVkX1/FjmVqHHQE+vVo6PXQm0Nw5WeIl8PiSlc=",
          "cpf": "U2FsdGVkX19Aq13rtg9aXprDOGra4ykziXtfz8C9QZE="
        }, {
          "num_cand": "U2FsdGVkX19NL0iv5kwOC7D+zbv+6CjJcrnUFXfVlj0=",
          "cpf": "U2FsdGVkX18bndFZ2VdSG+j2+TjUBQptE4xv2sTCxGs="
        }, {
          "num_cand": "U2FsdGVkX19r2TTyW1Xd87jmZhgGhQUlsGz+4G8pJ7Q=",
          "cpf": "U2FsdGVkX18JbtS6zB7eG9NDbMPXDCfz2AJLOfRV+78="
        }, {
          "num_cand": "U2FsdGVkX1/xurET8b7Uk4nZJuf4Hh8VV9o86Z49e9g=",
          "cpf": "U2FsdGVkX18/OxkypZ+N5wf7OoQZdMsmbzIR2RPOtaI="
        }, {
          "num_cand": "U2FsdGVkX18hH2JksTaqHaZ3zgNSMf6hgvmhm9m+xb4=",
          "cpf": "U2FsdGVkX1+ce697HtSNtbXaSIjWHyfTsIPP2wZH8OA="
        }, {
          "num_cand": "U2FsdGVkX1+dkChP1T6MXPXGOkVDEFW7qBA7zlgkjM0=",
          "cpf": "U2FsdGVkX1+qSmRcVLNR0gfrHZYTmIoYMjjPxgAPWJo="
        }, {
          "num_cand": "U2FsdGVkX1+iHshgmsslRCYnDFlWj3a415RhdMsNF4M=",
          "cpf": "U2FsdGVkX1+Sm1fqnrFh9IroEk4yDBP+AJGvDboEMBU="
        }, {
          "num_cand": "U2FsdGVkX1/Yfc+nXIJjERg5b2MaKWxas3UH0QtQStI=",
          "cpf": "U2FsdGVkX19xTjzp+ezYabEi5ZgK1UgNuFZZW6U9tR4="
        }, {
          "num_cand": "U2FsdGVkX1917O+6jMieNL232h1h5xWo4Z4mtU74YvQ=",
          "cpf": "U2FsdGVkX1+AVpQ0bHi6bRH1TOXmCRYtkUZ8qCsqQ4c="
        }, {
          "num_cand": "U2FsdGVkX1+8fzdVSfrHXK/V2XsVfzQZac8Vwsw8Drw=",
          "cpf": "U2FsdGVkX1+vI/Ew6CZbZIsV/jcqSNE8ZbGPKrJKolE="
        }, {
          "num_cand": "U2FsdGVkX187LJW7sis+H3zqd0hSItcWWvo9VkQr9RM=",
          "cpf": "U2FsdGVkX18LRsVfFGR8vFDpW64rAyJPIHQHz9XCjtE="
        }, {
          "num_cand": "U2FsdGVkX186r3+Dn76cmL1cBUzTH4UunmI0CrXe3vQ=",
          "cpf": "U2FsdGVkX1/BqmKnVwy653Y7T9zeznAc9TVPvlkGlTw="
        }, {
          "num_cand": "U2FsdGVkX18AlEK/8OT6d0e39m7VuRpW1wvj53NGucg=",
          "cpf": "U2FsdGVkX1/CshFnX6VeWO5Vowa5OimxMcXFlFwZo9o="
        }, {
          "num_cand": "U2FsdGVkX1/JEOkLgd2fhzdfXGbc/okwLcLw1iMbzLo=",
          "cpf": "U2FsdGVkX1+upDUOBwvU04bLLtne0Psw/j0vDsYhwPM="
        }, {
          "num_cand": "U2FsdGVkX19CEQEoW8JjsBRGWfQQqso/K/ibOPhqdKQ=",
          "cpf": "U2FsdGVkX1/dhhAO1GVw5hKwfurWG3FI/o9EuB9nrwg="
        }, {
          "num_cand": "U2FsdGVkX19Gb8NnWYPXgylL1b3HrC4y9T9bn+7iiJo=",
          "cpf": "U2FsdGVkX18v/5el632EYjhLU4uwl8ZOPQfRMrr44ek="
        }, {
          "num_cand": "U2FsdGVkX18h11netxC2xyc8HHxxqVjwmg57a1ztiJc=",
          "cpf": "U2FsdGVkX19WqWLLh+S8lIwBdzegC9F3WVjpxW6y67k="
        }, {
          "num_cand": "U2FsdGVkX1/d6pnQK4Vvn5M6nD4rRx2EGzLrtShSQrE=",
          "cpf": "U2FsdGVkX1/A8Gz7fxiJHQOzdyXnPRUWTRY2NlkCAe0="
        }, {
          "num_cand": "U2FsdGVkX19zdHoxVAAvrEETMT+qP+f93i9fFP2ey7w=",
          "cpf": "U2FsdGVkX19FVfY0Eze92UBuTIK6Oh0YIqhVkhYoi88="
        }, {
          "num_cand": "U2FsdGVkX18/e/SP49UQgm5MsvYCPnWhqmzT5y/JKx0=",
          "cpf": "U2FsdGVkX1/xlawc8BFJFrOv49qTAsjIo7QRIP8r164="
        }, {
          "num_cand": "U2FsdGVkX1+yJXhViF7Eo1oaXl3LxZDZ+ztiO5Z1AuI=",
          "cpf": "U2FsdGVkX18oxiI1DRn4htaEV9X1GSklijBpwsJaXrg="
        }, {
          "num_cand": "U2FsdGVkX1+huyt+AASHxROuZCU0K2YqOoDXnYTghsE=",
          "cpf": "U2FsdGVkX196f6qiMZLpqu3DoURheLl6gRwqHTZWxkY="
        }, {
          "num_cand": "U2FsdGVkX1/zu2WywkvrBlYafS6DFf+bEYpvP91VrRU=",
          "cpf": "U2FsdGVkX1/pxY8qWatr/85WZWJNtqP25x4HSImNNm0="
        }, {
          "num_cand": "U2FsdGVkX1+rWFDKLZ/orT3RiIqvB0kw9AoyzQS8CZE=",
          "cpf": "U2FsdGVkX19Ra2/Rnb/CDxqHpylirIb8TBb7Gc8h+Ww="
        }, {
          "num_cand": "U2FsdGVkX1/zO7YQaYukb0IKu2xKuU6b8taXyCW8SHU=",
          "cpf": "U2FsdGVkX1+s9OEoayF9Aqdpxft4+Gx352wPiunOGlA="
        }, {
          "num_cand": "U2FsdGVkX1/oj17Fb2TjJ8AHJiVpfIal1eSyXjqWO+A=",
          "cpf": "U2FsdGVkX1+VIL22yyxjfS7k6OTV/67fGn/9fq+UOjY="
        }, {
          "num_cand": "U2FsdGVkX19bG9eSuHxe/xK6at3yxAgovnrE9+ZBxWg=",
          "cpf": "U2FsdGVkX19dd7/8B3RCY4O9qRMfigiClW6MEHk3CmQ="
        }, {
          "num_cand": "U2FsdGVkX19fik4JwtzX0FJfUEJPua3Bf3mZCAA8s8E=",
          "cpf": "U2FsdGVkX1+TP+CpvtseddP6nNkqFb7UOTjrHlexNeg="
        }, {
          "num_cand": "U2FsdGVkX18sj3m43uOIS4ifg+H/gKrSrEPveJ9NTt0=",
          "cpf": "U2FsdGVkX18f776HLmxAc+OYauqVz9O/jeCh8/2Ai3s="
        }, {
          "num_cand": "U2FsdGVkX18bPwYUOTGRGsTpGflzcITduRDKm0opqn0=",
          "cpf": "U2FsdGVkX1+DpekwSHamxEypSCCE13L9bw81KNDygAA="
        }, {
          "num_cand": "U2FsdGVkX1+rcfexNrNwuaEbISmBM5DeAUsm4bn6Kok=",
          "cpf": "U2FsdGVkX19Af8z0NpXsYpho74ryCuX9qEgSvLzQbTE="
        }, {
          "num_cand": "U2FsdGVkX191EoWQ0eOlS6gPGWMc6Yavmp+U7+fbkTc=",
          "cpf": "U2FsdGVkX19rjLedGSuymYE9xJ9RDvuT0ML+oFbZpGo="
        }, {
          "num_cand": "U2FsdGVkX1/7vj+uDYT6GRj897ZDxs3lL4mCUgEY9HE=",
          "cpf": "U2FsdGVkX19XYo00IMUvSp3+rFLbjKSnM04CkshCC1c="
        }, {
          "num_cand": "U2FsdGVkX19D/Rn3TJtReJ4qK0Bb1W8GpXmSmYGtEDk=",
          "cpf": "U2FsdGVkX1+4/qstnQudwMPgWucRwKX4FpLjJxd7ywY="
        }, {
          "num_cand": "U2FsdGVkX19pRLIAuJmPVKU45kWoGKkaz6+0Xbc1MsU=",
          "cpf": "U2FsdGVkX19neNKxwgd+QzgQp+xGE8t9M2kXBySI4OM="
        }, {
          "num_cand": "U2FsdGVkX19ooe9oYw3HGFNLUuZaUXNG05Q4gYziPKc=",
          "cpf": "U2FsdGVkX1+lpWGlDuOZP9+wBDueqU6dj4Y5p/f4jc4="
        }, {
          "num_cand": "U2FsdGVkX1/dLCFA/s29d3VXDxgA09TbPOjKu61Xnqk=",
          "cpf": "U2FsdGVkX19htdqW6SyjuW69Wkgp/W6Xf91QejCGXt0="
        }, {
          "num_cand": "U2FsdGVkX1+fvfU59vg/4i+CUGu5wVuUTVNciegWa7o=",
          "cpf": "U2FsdGVkX1+8ZuYjYXzuavgwxmd+gUsWAipBUObFKJQ="
        }, {
          "num_cand": "U2FsdGVkX19Yi7oApXIPymMbOoJ1QQedYi4pdUhG/+E=",
          "cpf": "U2FsdGVkX19lFP7lO46Do3XfchKhCAcX+IQIbjJ5e/8="
        }, {
          "num_cand": "U2FsdGVkX198XSa2JJrtqO/R7q9ldv+j8FXhzoWzWJ8=",
          "cpf": "U2FsdGVkX1/1DeapVexxX4L2Z00CcXxd1JeaMsvqc/4="
        }, {
          "num_cand": "U2FsdGVkX1+CcJeTqkfegeiDCCOyzW1oO8y7FpcJNe0=",
          "cpf": "U2FsdGVkX19lkfUQm+qMbhzCONWZVENO5r+nXAKVU8w="
        }, {
          "num_cand": "U2FsdGVkX1//X60uEsR2XAP7tgK2hGv4PFYVTuIp/AM=",
          "cpf": "U2FsdGVkX18Qn5rtIgBOL7LzpF9R5ACxfmLkDiDANmk="
        }, {
          "num_cand": "U2FsdGVkX19ibf9ReSyz3IpP9YmYEa08LgYwi2r0ZW8=",
          "cpf": "U2FsdGVkX185AzxHShNFLB8Y1w0kvr1v9TKsl0AXRWk="
        }, {
          "num_cand": "U2FsdGVkX1/UNC01eInVzX01rLOKxenRk9W03l1i94A=",
          "cpf": "U2FsdGVkX1/Hz1/CORJPzDvJFL+RUwi2RlGZJXrPMO8="
        }, {
          "num_cand": "U2FsdGVkX19tiwb9sIX+gTr3zFjtL1Q5Ksb3fDq/S8Q=",
          "cpf": "U2FsdGVkX18dLUaDYCSrkphF33OdoOpE2IqEGnHfM8E="
        }, {
          "num_cand": "U2FsdGVkX18FrRAoW3nt0LMQpHT1wf6yGVimMx9jWII=",
          "cpf": "U2FsdGVkX18GtOg1dd69IyTXm4FxXb6h5lUgHLuwh2k="
        }, {
          "num_cand": "U2FsdGVkX19WWdgdeaA4ZDb7sKk+WIsyE60WSYEFEzQ=",
          "cpf": "U2FsdGVkX1+/JrQ6kaWlRPvyyNcjUeIZUN4VgnRbqZM="
        }, {
          "num_cand": "U2FsdGVkX18pzAh37TVCNfKvKj8bhVF3kgm5bQzJR9o=",
          "cpf": "U2FsdGVkX1+rzGVR++iCSRwt0bvSZTfFU6ja2z0oESY="
        }, {
          "num_cand": "U2FsdGVkX19HKbpBdkBdzDZitasintoy3v1nUobz4wU=",
          "cpf": "U2FsdGVkX18epbWG29KNFjIbNjAdhi7LmYnTHU8a13Y="
        }, {
          "num_cand": "U2FsdGVkX19wtU1q0OdB74bLjHvaBW93eojpn3SHrLY=",
          "cpf": "U2FsdGVkX1/2IRTWHPfUWQmc8gIwbBgC1cXeDiz9Sio="
        }, {
          "num_cand": "U2FsdGVkX1+Q5wqbP6SGLaM3RDOdMzlGxaQ/j5VBaGA=",
          "cpf": "U2FsdGVkX188t7zyUkbWL65uZQjWER5bTeFZ0QvyXsk="
        }, {
          "num_cand": "U2FsdGVkX1+yQv2bNg1SU/zL1rRqy0Wp79xUTUOicXU=",
          "cpf": "U2FsdGVkX18x5q1ELGQtt+i3DRIIQdRJyS4xHk8gBn8="
        }, {
          "num_cand": "U2FsdGVkX1+tIbSDoemrcgZuPczE/ciESh2353TOQYQ=",
          "cpf": "U2FsdGVkX18sy151gHobxLYDZncoJYn2j/JE3JclKGU="
        }, {
          "num_cand": "U2FsdGVkX188ZEGaw53rA5c99MdaOW2uEyZEj0z+wms=",
          "cpf": "U2FsdGVkX18NrAyQ/p5jRgv8qUa+NHwd2zrzdfhftb0="
        }, {
          "num_cand": "U2FsdGVkX1/C7ZAYrorAypHw9QrxDoMeY1BFDgXjcLg=",
          "cpf": "U2FsdGVkX18xdLbccK2I5uNJXPU0E7rgbq8+w6tUxsU="
        }, {
          "num_cand": "U2FsdGVkX19mxBE1Yh2zyB6Jrm7Zmj1gn+LJ1MQqsJg=",
          "cpf": "U2FsdGVkX19jI9sVgS8Q5U+KJbep3KgDInN3LSYE3kA="
        }, {
          "num_cand": "U2FsdGVkX1+kSwSkARXNKS6TMpWj2R8AT9UWNXnFuhI=",
          "cpf": "U2FsdGVkX1/XjPhw9/rk/+Eakjw6IMwlOs5PnBcSZqE="
        }, {
          "num_cand": "U2FsdGVkX1+vJibOrvSc/eMY9gExNMToNHvLJkTqZBY=",
          "cpf": "U2FsdGVkX18+EL4SCM/toUfwFFZLHILk8e/KmPjXfWk="
        }, {
          "num_cand": "U2FsdGVkX19lLvEwt2SyuJNWFNrF/8rXWvdJos4dcak=",
          "cpf": "U2FsdGVkX1/OTWVS/dhjE5hVnIFIMpYzsf35GAgKU54="
        }, {
          "num_cand": "U2FsdGVkX19TZnAdKEhNi7lZwZsdzQXDg4uNBvSw8uY=",
          "cpf": "U2FsdGVkX1++4CyziX1AarAd/Uz+MFmkYw4FdKuldjc="
        }, {
          "num_cand": "U2FsdGVkX19a2zGKEu5952ktNPdk8BtIGdI4iZjDF5s=",
          "cpf": "U2FsdGVkX1/eDUv8NEHyuv0JGbZ1ANe1WBJg50Yrj2k="
        }, {
          "num_cand": "U2FsdGVkX18wWk3J6jwDgtL5Iv/2nkWguOeA/BC/ZBo=",
          "cpf": "U2FsdGVkX1/PrxDiv9qqlpMHrH5ITcDOBhZF64hjc1c="
        }, {
          "num_cand": "U2FsdGVkX1/oWM2AYKt5ZdXkjyLIKWpucRejB9BL5zE=",
          "cpf": "U2FsdGVkX191rHxG1XxheJbnVxTjTOwpFW5VwL+n090="
        }, {
          "num_cand": "U2FsdGVkX1/xnGqs1JTD/gLesMZa49VY8eXS5FUap+w=",
          "cpf": "U2FsdGVkX1+X5qgycREF6Nsw32wh5QpdR/52jTheHxc="
        }, {
          "num_cand": "U2FsdGVkX1/HUo1ZiJeqUg7hoEXZL2deBtWl9EOaSmM=",
          "cpf": "U2FsdGVkX1+Wxxjo1kiw3PTSn9WPyNPyLOJb6N+aFRw="
        }, {
          "num_cand": "U2FsdGVkX1/QYZW1OeSH9syc50Ded3vFeLxX++5ly5M=",
          "cpf": "U2FsdGVkX18uvbQZs/8i7ogHoABIdPGiVCKgPJQZS3U="
        }, {
          "num_cand": "U2FsdGVkX1/+3U2UIAVlhqtzWvlAkK0eUuFNETDvt+c=",
          "cpf": "U2FsdGVkX18YpWOqm6FjyQPSY6ZXVEj+CYWdmpcZzis="
        }, {
          "num_cand": "U2FsdGVkX1+/5DXcNQ2y6rbxT7aXBQ5RRxjd9owgdok=",
          "cpf": "U2FsdGVkX1/pCBiSe3YYEDUeN6PGV6U7StURn8nWxWI="
        }, {
          "num_cand": "U2FsdGVkX1+tRvAVO9nBfvG77eWKthE2zvOGrwPlYJA=",
          "cpf": "U2FsdGVkX1/hdhJEeZvb8F/B+OOOCTpzBcHkZC+55kA="
        }, {
          "num_cand": "U2FsdGVkX1/VT9wTipD4CkljB4Q41/Vpjc+RMgO0uv0=",
          "cpf": "U2FsdGVkX18+6sVR7aC9IVWLafz19HuF/nP2oD26w7o="
        }, {
          "num_cand": "U2FsdGVkX197/+zzo5NwAK6MIOyzK0aXnwWEVXwEcV8=",
          "cpf": "U2FsdGVkX19K7tbjOv/ZfEawfyavowECC2t1Jxy6IW4="
        }, {
          "num_cand": "U2FsdGVkX181W3mwdzIHy5rvPo8d5TekWMt+Efss0I0=",
          "cpf": "U2FsdGVkX19rryyyzCQFyx6X0xrBsyO0jrpuhH1SHro="
        }, {
          "num_cand": "U2FsdGVkX19lNPiw9zXSfUez8NYuwZvhr6XXCiHk2zo=",
          "cpf": "U2FsdGVkX1/wva5DwlwBUYhAUh/pGcSQGnRkvMxIYxo="
        }, {
          "num_cand": "U2FsdGVkX1+HvgpaRj9uGKJaLwKMMNmj9ZdG5mx20jQ=",
          "cpf": "U2FsdGVkX1/hVGybQxf4+34FNAsWsBYMdMdFhBZCsWs="
        }, {
          "num_cand": "U2FsdGVkX1/x215vnBRDpbfrcYLwbDIytVR3kEsbWo4=",
          "cpf": "U2FsdGVkX1/6U4PclAEXfDcY+0kCvuSz8CmkUD/4jNU="
        }, {
          "num_cand": "U2FsdGVkX182U+a9mYDFQGuGlyQs8x/hV4kicELb3Ow=",
          "cpf": "U2FsdGVkX19rSNjNko7Yjp8Jytseo2wKCp7ZuRhc87E="
        }, {
          "num_cand": "U2FsdGVkX18VLjtM9+fEZO3gmeEfCfag4Da7ijThFlY=",
          "cpf": "U2FsdGVkX1+MGrMsQ9PkdqjsrBOsvjnV07ulXejY9wY="
        }, {
          "num_cand": "U2FsdGVkX1/QlHHqLDxuGk5kktOK92QE0wmWbmvWFW0=",
          "cpf": "U2FsdGVkX1+eMUtk2FxC3TI3J0xESlH+aBpGC1tPpbw="
        }, {
          "num_cand": "U2FsdGVkX19zPylaKU+IXR2IZryHDDKQ0kVrvmU4NwM=",
          "cpf": "U2FsdGVkX1+bXU42dNzlrNa9S/lWNm38oGVPHPzxcB8="
        }, {
          "num_cand": "U2FsdGVkX1+sK2A5VGx/tDHrxMDXNehvfJdKhMBh+qw=",
          "cpf": "U2FsdGVkX18vzAjGQcBhP1TOqnWHaHc0n4PgsrKLdDk="
        }, {
          "num_cand": "U2FsdGVkX181jJ4nYMPcWDUXRBfZx1ydu+4m1xhLBgs=",
          "cpf": "U2FsdGVkX19Huqmtf7Ut3Yv/tNthrvCFUfOXxpGMtO4="
        }, {
          "num_cand": "U2FsdGVkX1/cZ/jlCUzIsouNGU37xrN55d5yO7862VA=",
          "cpf": "U2FsdGVkX19w4hhwswbT5eBT5BWjZIKVBwCfgXqMvX0="
        }, {
          "num_cand": "U2FsdGVkX19bNVxeietr9UvNNtN7xhDqkoHi0gEPZeg=",
          "cpf": "U2FsdGVkX18Zom4LddQLEb3wRSgnu738p97pZzUxfEk="
        }, {
          "num_cand": "U2FsdGVkX18wJSvPzv+WiSLKqz4GPXSszckEUeKR6f4=",
          "cpf": "U2FsdGVkX1+4dTHDx41ge1Ns8XC0cmckyjUdSJ/S0Cw="
        }, {
          "num_cand": "U2FsdGVkX19SJ52rGrb3DuBh+UHwMHLeIFOCV8IC7jA=",
          "cpf": "U2FsdGVkX18301vv+EosQjDASJ/+D1b8FzmOckm8Nvs="
        }, {
          "num_cand": "U2FsdGVkX192vmtn7coP5Tz+yiZAh0XuHvzTdmO5450=",
          "cpf": "U2FsdGVkX1/LeAluv3XEL5K5IACHh0hfGxnBY2D2XC8="
        }, {
          "num_cand": "U2FsdGVkX1+2zCJfZb4wMC+FCjoEtOsEvU0wn6ridE0=",
          "cpf": "U2FsdGVkX18EcmsFNQ+Xudc++Hx0lOs78t2MjFrLaGw="
        }, {
          "num_cand": "U2FsdGVkX19TE12DtNf9GDkF7p6I/xUSz9G2zElpEJw=",
          "cpf": "U2FsdGVkX18z8eojWiSDYw3al6J8biu/sL6r12Lu1XI="
        }, {
          "num_cand": "U2FsdGVkX1+fj0NQnazQ30QFKHpjvalvvu86ribNnx8=",
          "cpf": "U2FsdGVkX1+Kwh8KNsrmuxcdm3qsExgkGmYkKi7cl/Y="
        }, {
          "num_cand": "U2FsdGVkX19EA1o0sZNrJHgqvlKWdRF7lWm0Ux2ktsY=",
          "cpf": "U2FsdGVkX1/KbHiNf61mkemAfXnW1yQbNOlQHMFkx7g="
        }, {
          "num_cand": "U2FsdGVkX19Z8NnrLaLyneuqUtFgwqO8FeayQmEzn7I=",
          "cpf": "U2FsdGVkX197fmaElNuhVoLk4AXKwqOsQ0DrGX2+GeI="
        }, {
          "num_cand": "U2FsdGVkX1/7NLAapA78Y7XHGIh2q5rz6z5CYnsVaJo=",
          "cpf": "U2FsdGVkX1/oaEvWKS7O79Lj/BFADrLywB8taexFQ9w="
        }, {
          "num_cand": "U2FsdGVkX18Ajnmz0nAijiW1ZjNQEcpMlQVsCTfyfOc=",
          "cpf": "U2FsdGVkX1+sGjOveJd/rB7bKAIEm31aZ9RZLa/o/co="
        }, {
          "num_cand": "U2FsdGVkX1+eZMZb5A+5FbYygsCTSsTIJwhZRsPZoIg=",
          "cpf": "U2FsdGVkX1/o0gmVcf7r5OieV0aOTWAyW5mesr0Wn88="
        }, {
          "num_cand": "U2FsdGVkX1//LF/IpmkwP06CevAmw6XQ4RsOb7o2tWg=",
          "cpf": "U2FsdGVkX1+H5rlirO7pKXCZpNgzpp316G8OTvB8O8w="
        }, {
          "num_cand": "U2FsdGVkX1/hDdHTJQpXgHEuEyzOl2pWWuUg+hE9w/Y=",
          "cpf": "U2FsdGVkX19sTfxMuycVdBcTjrtIMAlTmjTsPM53SgU="
        }, {
          "num_cand": "U2FsdGVkX1/BPQXbRo8DxmUfNsot/Pa2I62bKxBU0f0=",
          "cpf": "U2FsdGVkX1/rWlKGTGHa2B1iEOMtlwxhAzCd6qmhkos="
        }, {
          "num_cand": "U2FsdGVkX1/NX/dJRXFQ6DJyJoWj/PpQhYJz1PQtxw8=",
          "cpf": "U2FsdGVkX1+2E/kAf4kL612d8MmzI8nRyvd+Jh3XKRM="
        }, {
          "num_cand": "U2FsdGVkX19EqRy+RBW7gtwMKVJiT61iAEz9JVGNEhQ=",
          "cpf": "U2FsdGVkX19h3zUAl2ARQ2haIiL3mzxn2fiJpDYJi4I="
        }, {
          "num_cand": "U2FsdGVkX194ZqFpVHKEwrDXHllM1R0qSYC4fpFxRr4=",
          "cpf": "U2FsdGVkX18K+nV6MKYX01RAHXZYYO0/WINymMCLMKY="
        }, {
          "num_cand": "U2FsdGVkX19Kl/kVdnjXgeN0xltjIyLZWxXaYAE/+lo=",
          "cpf": "U2FsdGVkX19fH7wi3HQ2cZ45JGESyxoc156i6BL3uZw="
        }, {
          "num_cand": "U2FsdGVkX18ESjItQ/vcH5fdXakmE/zNLLnNxfdFWzk=",
          "cpf": "U2FsdGVkX1+dvH4Xkt6NpTiK42e0MaJEJd7rmkxhklU="
        }, {
          "num_cand": "U2FsdGVkX1+jc7yrowMFIeau8yOU5kiTqrcK4aevW9E=",
          "cpf": "U2FsdGVkX18iVNz7fGDdAiXRp9MwpWe9NJKbmlRQ5MA="
        }, {
          "num_cand": "U2FsdGVkX18qkJiadGCatbA1sqJ7+mPqlxJhc/fNWrY=",
          "cpf": "U2FsdGVkX1++LY2kometH9zUAFYEx80YCku5b0krwzs="
        }, {
          "num_cand": "U2FsdGVkX19c4zst/HyiQDkszoFZacSqZCo+YWjuhkk=",
          "cpf": "U2FsdGVkX1/AoJSmHn5OwdMXHGkEsewR/4TbrD1qo7M="
        }, {
          "num_cand": "U2FsdGVkX1/VfEJ9zMZdoVEkvI7FiNIYhwXxkzYqKfE=",
          "cpf": "U2FsdGVkX181R1IcZ48qZ0U6EgmEa8AJZzMAq6fgCxo="
        }, {
          "num_cand": "U2FsdGVkX1/2JMTK+bt4ix6tBtWyPivqBbOksv/Zfs0=",
          "cpf": "U2FsdGVkX19TbL65DGyiNrPZp2leul6dBKMhE+3POq8="
        }, {
          "num_cand": "U2FsdGVkX189rCrhVeKbRD14Nf48E8AAYi52BJoRIhw=",
          "cpf": "U2FsdGVkX18rf1a//quA/4aRAV0Hgf3kSesleCnDFh0="
        }, {
          "num_cand": "U2FsdGVkX1+4T+YNq8hgyZX5fjbUXIJdqy0yp0s355g=",
          "cpf": "U2FsdGVkX1/TObgH9D1wZEJ044c8Wbc0WHt8elb1pPk="
        }, {
          "num_cand": "U2FsdGVkX1+wu89k4Zvf/UyQaShBmjqcdkxi2rKlhX0=",
          "cpf": "U2FsdGVkX19tV52jPhhETBKkiMolCCdUa7ZGUWRnYoI="
        }, {
          "num_cand": "U2FsdGVkX18cDk5o2D8RgtfJXTkjRl4m3QHOoqAzJ3o=",
          "cpf": "U2FsdGVkX19/3Jnjk1hCdjfXd1o+s+iELLBVGtQpO/Q="
        }, {
          "num_cand": "U2FsdGVkX1/soi3TjucPPMS4e4bMTH3miaye/glZqQk=",
          "cpf": "U2FsdGVkX1/sGKczLCqIs6t374IW7Q2Je+/5kwYjyF0="
        }, {
          "num_cand": "U2FsdGVkX198vWrC0PXRx/dzkHUcUCNQ8ZmMxUNwkGY=",
          "cpf": "U2FsdGVkX19GMcqi5Dbv43KzuwAHuhM8TFQ07qnZ8pE="
        }, {
          "num_cand": "U2FsdGVkX193Itu6aN/e5ZvPPhYmvWr5HzbiEdUwlVU=",
          "cpf": "U2FsdGVkX1+VrPGnB49ukybmrRWgCTLHrfWlUYflfms="
        }, {
          "num_cand": "U2FsdGVkX1/OIacbn+30tCybOjlczLumx3LJNIRPg1Y=",
          "cpf": "U2FsdGVkX1/XgdOIy24JEdZ5hhC8IZ1ozGCmaHNgxCs="
        }, {
          "num_cand": "U2FsdGVkX1/9PI0u47PbYcYwtLAzLRh1X6Y67YGO0N8=",
          "cpf": "U2FsdGVkX19RPlp5zzHmlPPoTvzFqNcv1GHzDpHEHBY="
        }, {
          "num_cand": "U2FsdGVkX18+w8EWg0FTCFo6Fcm0IcDwrwC+60d/948=",
          "cpf": "U2FsdGVkX1+QMrRwydcqGp8xqtoZpMDNNJiNTmP3DOM="
        }, {
          "num_cand": "U2FsdGVkX1/QqDKpqf4uKcZI3Jg44D+U/EkzF92N0oQ=",
          "cpf": "U2FsdGVkX19rB2v8vFri9cVH9Nvw78B6MMgL2p/QdMw="
        }, {
          "num_cand": "U2FsdGVkX18SQOgRlHv1wualxUOHCJLPjWP6P3xOQDI=",
          "cpf": "U2FsdGVkX19eR7GhDvP+QLntqQX+9IOrO9d6hlpp0q0="
        }, {
          "num_cand": "U2FsdGVkX1+XRDg9sINKLjGFrzEXe904J3OR3c987hI=",
          "cpf": "U2FsdGVkX1/r6w/mP9DnF3SkhgR1koKm5te3raOdySI="
        }, {
          "num_cand": "U2FsdGVkX18gUAFLEX/fK7if6EoSdidfMtY5zL0Vc4A=",
          "cpf": "U2FsdGVkX19kpN9qygIbWo7vZRnNIp7JbVXyShOgiYY="
        }, {
          "num_cand": "U2FsdGVkX19qwGYSTRIKdh+yV1tE8zGH9C6I+rIByy8=",
          "cpf": "U2FsdGVkX19OSAS7Gp+DHUnNjN5FzzI13KW9aBR9hLA="
        }, {
          "num_cand": "U2FsdGVkX18bkz7N4AVSvhNyPCOdz7t5OYbggO1p7ZA=",
          "cpf": "U2FsdGVkX1+V5qvyxy/T3J628INj4wXwQ7xfYPhJ+sE="
        }, {
          "num_cand": "U2FsdGVkX185GYgqfw2gcBu/kVZ9Ccd65i0cu5jHf4s=",
          "cpf": "U2FsdGVkX18aGW1LKi7bDX1esrNHcdz6PW/DbWIAwVs="
        }, {
          "num_cand": "U2FsdGVkX181/fvbQmvqoHeVGptHBOeI0NUuSN9oyPk=",
          "cpf": "U2FsdGVkX19jWBXJ315s+aBBISl2kcu61U7OsNfaeMI="
        }, {
          "num_cand": "U2FsdGVkX1/LrPvb0HtsT/TIbxyMLPisoj3scUo2XHM=",
          "cpf": "U2FsdGVkX18syiP2DpopeqGaXAoK5m1/b35JUa+Qz6k="
        }, {
          "num_cand": "U2FsdGVkX18R+pBon7lNR3f2Gi6Z9xnWb6SnoUHUk0E=",
          "cpf": "U2FsdGVkX18pxH7YrKlsnPhRfK1THEuiy3gBLja8674="
        }, {
          "num_cand": "U2FsdGVkX18YXBaU3tvbosDrGWMyIoitB1sj2Sf6yD0=",
          "cpf": "U2FsdGVkX19cj7G/V3FA01uoUH8arEgRN2AzZyWWtNE="
        }, {
          "num_cand": "U2FsdGVkX19L+VhdO6FbMH14GyijujPn/v5LSLgPIyk=",
          "cpf": "U2FsdGVkX1+svfVV5nEkzCi624uh6ayUrRcT8eVk0lo="
        }, {
          "num_cand": "U2FsdGVkX1/R5PmsCDsWNOSDyDrgb8peM8/ERXVJgvk=",
          "cpf": "U2FsdGVkX19Cy4A1sFIO5aNSvn/MMdaqBHfesEbbEaw="
        }, {
          "num_cand": "U2FsdGVkX19fxAu7Yahn7phiOVOczCvMPoAWjT0HpOs=",
          "cpf": "U2FsdGVkX1+H1qjXXjst5kQ2vU2BkvwE7XfZsKi6RTE="
        }, {
          "num_cand": "U2FsdGVkX1+7di6a34FXS0COh9w0VGk4Okhx+0Dp6+4=",
          "cpf": "U2FsdGVkX1/brzWggWTf8y597KXJAP7ssLK4EwDevzE="
        }, {
          "num_cand": "U2FsdGVkX1/cY0s9PJioOKZLB1LHN2ypcRcNI2NJ4fU=",
          "cpf": "U2FsdGVkX1+9OJCytJLFWE1y7Ul/2l0C2dc+zIIObpQ="
        }, {
          "num_cand": "U2FsdGVkX1/RlO84wldSw2ooO2rxK/tAWBR0ElYmBqM=",
          "cpf": "U2FsdGVkX1+gMv7kG8quPEY7PmWhOLPZpNr3JDeW3OQ="
        }, {
          "num_cand": "U2FsdGVkX1+ZEuseFExCoWFh6Z1P1YAwGH+vuWlXb6o=",
          "cpf": "U2FsdGVkX1+plnNVad6btNT5wUi2tZZfW6l1OdIrWSI="
        }, {
          "num_cand": "U2FsdGVkX1/ccVtGJ3tUUZ2gB1KkkhFi3dam+0vQm9U=",
          "cpf": "U2FsdGVkX1/OZgHVFvjgmO9t8L/+wcZFkij7T3uBe6I="
        }, {
          "num_cand": "U2FsdGVkX19dggfQT7FgTaW4VjpEnR7Mv9FIxI8bBsU=",
          "cpf": "U2FsdGVkX18qmIWH6jLxXLH9iMApfWHS8B97KB8o3Tk="
        }, {
          "num_cand": "U2FsdGVkX1/LdGEhVf6Icoagi8HJTEDST/3KyabZA0o=",
          "cpf": "U2FsdGVkX19m7AivSt/VIhdXD/gHBB6zxZapBgtBWW8="
        }, {
          "num_cand": "U2FsdGVkX19EcgpRvOyPyMlp4oZyVXZJA+lkvJk7TP8=",
          "cpf": "U2FsdGVkX1+F9ErmEtJBemfsILxwORSQzQqpS5qMpwc="
        }, {
          "num_cand": "U2FsdGVkX18eDucBDxjNpB/jO28Q+e39TAA+RYcA+ms=",
          "cpf": "U2FsdGVkX18kkWeY1jm/uWgsqLBvoh6jeKFpPW8juLw="
        }, {
          "num_cand": "U2FsdGVkX19eBeclYEQHq/NRFSIsqsBW3bzP2BMl8T8=",
          "cpf": "U2FsdGVkX18AsALNhxrcqlfYOETDfPX8z2uzOSj7NYI="
        }, {
          "num_cand": "U2FsdGVkX18JZNp79YnquGGTqVKvKXXLWPJOQFjVNPk=",
          "cpf": "U2FsdGVkX1/qHv2WylSf13HcgUJPYTlxDKoif5VIT7Y="
        }, {
          "num_cand": "U2FsdGVkX1+oZ4YEXtxY7PY2zX4SCwTDV4PborOFusA=",
          "cpf": "U2FsdGVkX1/mZzv01pca3VOMAhikhqortNhMfxw0Hek="
        }, {
          "num_cand": "U2FsdGVkX1/AyAWkpWDONk7+Wp/PkDpTPFPYiNEMVtU=",
          "cpf": "U2FsdGVkX18zMQAajgUPwjhfBObOF6IZ6trWC0/ivA4="
        }, {
          "num_cand": "U2FsdGVkX19hy2Ru3lLi44mE0hsaEGAyphFkeuMV5Mg=",
          "cpf": "U2FsdGVkX1/ygYZyif1TWr1GoSecma98lIFI7b5dcjw="
        }, {
          "num_cand": "U2FsdGVkX1+QDPc6tIBw7SUjK+UkDmj20B11cjtOKWA=",
          "cpf": "U2FsdGVkX18G3YXeI+GHv1Xi9zv9hE/8rKI/0kvGHww="
        }, {
          "num_cand": "U2FsdGVkX18OMaM/h9b8UtdZP2r/k2U8FYaZ5NlQsCI=",
          "cpf": "U2FsdGVkX19vEwoMWQV360XEi2N4D5ATuDmtoAf4890="
        }, {
          "num_cand": "U2FsdGVkX18Eilj5HqfSgGy3rA7D5aBZ9nHYbMkWNrQ=",
          "cpf": "U2FsdGVkX19h3ev59+7665nCQ6K/FbdfMJ41Ue0SnTg="
        }, {
          "num_cand": "U2FsdGVkX18GlbiUgTRWIuA0fqaHD3yc2mev4vydK8A=",
          "cpf": "U2FsdGVkX1/6CU6NFKETGWnFYBcOsnxXu5xNOgy9og4="
        }, {
          "num_cand": "U2FsdGVkX180DpzkJDIIrI74ir2gyp6hfD7udrvbJZE=",
          "cpf": "U2FsdGVkX1+lu6fGx1KmHTm8x28KhGk1xlwuGcGeYQY="
        }, {
          "num_cand": "U2FsdGVkX1+SZNCokAapntHh+9na0lVo26fuOlvRfEk=",
          "cpf": "U2FsdGVkX1/beL2OiOfhnjtv0wRbLAU19hZV1etq8GM="
        }, {
          "num_cand": "U2FsdGVkX1/9qZNgBfNdreZykUBf+kCpoo3zQoN7+vs=",
          "cpf": "U2FsdGVkX19u31YoBPsBjshiv59eXRtryiY8hZXNklY="
        }, {
          "num_cand": "U2FsdGVkX1+83CehZXn8SSLpT6rBoad8NiMRdkgKPpQ=",
          "cpf": "U2FsdGVkX18YO85YXm2Lo7DIr2TaA9HpPg28cAGVgq0="
        }, {
          "num_cand": "U2FsdGVkX19HIVMs0r9Q078T2dzg1Tci0qs3IvT7Wb4=",
          "cpf": "U2FsdGVkX18yIfBXtdWFNdzOHHhONAjdvLUakn7GmGM="
        }, {
          "num_cand": "U2FsdGVkX18LZJfBVLDJFYC/ien6fJj2Qz1ITpB6fE4=",
          "cpf": "U2FsdGVkX180EqDhK77/ZdZHw5kbkqG20eB+A7RRF3g="
        }, {
          "num_cand": "U2FsdGVkX1+Gou0oIODWZNLS9nvW0eyxBQxtroMb22Y=",
          "cpf": "U2FsdGVkX18STugs5sDoabqKhW7mH2beRds1NY+8mXk="
        }, {
          "num_cand": "U2FsdGVkX19rzwHp2R9b3/sHyL/ZtGb0yBHdzW0AV8o=",
          "cpf": "U2FsdGVkX189jjlQ39XoX/AoZJiNNx/Pp6hIvk2eXv0="
        }, {
          "num_cand": "U2FsdGVkX18teMNLPhERqKcAN4qIeTfGGBKVBe4L6j4=",
          "cpf": "U2FsdGVkX19yOwhSUdqygYa/jkhojVu+wqMk1/CLV8c="
        }, {
          "num_cand": "U2FsdGVkX18vHF3eiXT8DcMQgX/Y7xJfXx1PmX8ex4A=",
          "cpf": "U2FsdGVkX1929t54P+kJ1s4CCysfQY+XeflEyfVWZzc="
        }, {
          "num_cand": "U2FsdGVkX1+be9yZVFpq/yWQylAC35T0gTanhPOIbsU=",
          "cpf": "U2FsdGVkX19TbpzOCzBOuhZjQ7GC/h4onvIxZzFdgEg="
        }, {
          "num_cand": "U2FsdGVkX1+dhs5wfLPqhgS+gh+Pnf7nyUVakla19uI=",
          "cpf": "U2FsdGVkX197U+9+eXQOp6U3DMbDscJ12WstNyVNRdY="
        }, {
          "num_cand": "U2FsdGVkX1/d2pLlY0Th3I/VnCiWBJHAbbEf7rf708U=",
          "cpf": "U2FsdGVkX1/3DfrXKBoCOkokKE4H1+c0+v0cQVAej08="
        }, {
          "num_cand": "U2FsdGVkX1+PKAD4DLebE20PEkmjxgnn12AX0NrEWU0=",
          "cpf": "U2FsdGVkX1/07SLt5dGIVEj1xsocxDAgDV0GpFAMrPY="
        }, {
          "num_cand": "U2FsdGVkX197PE5qYaMTHg48AltZ6AWg5fRW0/ufobg=",
          "cpf": "U2FsdGVkX1+6EbebGcfQHh+zw4/c3fzR5Be0w2/UEKs="
        }, {
          "num_cand": "U2FsdGVkX19hJuBDClejRI0cbp4+qExBqTKVe9Qj4W8=",
          "cpf": "U2FsdGVkX1+MHbptGRBlzHMEQukfR1mQy/LGViv2cpE="
        }, {
          "num_cand": "U2FsdGVkX1/s3WwrD4jAmbO6P6GgOlAxxlJnOs0C/DQ=",
          "cpf": "U2FsdGVkX18fZq+cEanf2pzriU/TPh8Q6aJ+9Gm8vq8="
        }, {
          "num_cand": "U2FsdGVkX19oMYJ9tWeZE74QDrPRzS9BfgDawq3Xti0=",
          "cpf": "U2FsdGVkX18X+2HdenY5Qz1J1mhwpIRhGDkiQ3jtRvk="
        }, {
          "num_cand": "U2FsdGVkX1+8BzFnQ5cBGrrsUzmFbj50nLBYyk4tbbw=",
          "cpf": "U2FsdGVkX1+TQtAt14cBzUzPY3kYZFarW2ZEXQWJwCU="
        }, {
          "num_cand": "U2FsdGVkX1/tPbJRU5ygf/xiRxZ4iDlSJCahzQEXi44=",
          "cpf": "U2FsdGVkX19tAFAYcAmmMEl5JArzEhGyZeJ9vejFTbc="
        }, {
          "num_cand": "U2FsdGVkX18VO35uzH4K4MWjcShp5Xgjv+jV9AwdccE=",
          "cpf": "U2FsdGVkX18GzpUZ9GlJC3J8jMj3s3u+dNP39lxxyyE="
        }, {
          "num_cand": "U2FsdGVkX193ak3Tsh86rG40rapuikNOvrxhp1ZDc+Y=",
          "cpf": "U2FsdGVkX19ssbanC+ly5vjzZjC6VtAFJSFe5B6QDSk="
        }, {
          "num_cand": "U2FsdGVkX1/p3EukQxRf/EK9yxI8P2XghVBCDaTD3Ng=",
          "cpf": "U2FsdGVkX1+5GSSbVsayQNjjThUjah4WkTQMH/sNE5g="
        }, {
          "num_cand": "U2FsdGVkX1+UmZUq+AcevHlgIaoisHdVMUFRS+po8K8=",
          "cpf": "U2FsdGVkX1+FSAcivYuTHP+8xmoQA1BDal8V+E8lrZ8="
        }, {
          "num_cand": "U2FsdGVkX1926UNqewb0B4EYlC+fMx5nMp4/vQDrZCg=",
          "cpf": "U2FsdGVkX18J9UXSyIwU92uO70d/kdhVkaaarcY34lo="
        }, {
          "num_cand": "U2FsdGVkX18IeW6LwvH7NI86KW32Lt1Tu+OokqKM5ro=",
          "cpf": "U2FsdGVkX1+ptp5fwNX7d31HM32bOd518NNusjkFNB8="
        }, {
          "num_cand": "U2FsdGVkX18qdYGDcCjx25/YWi3pQf7doxGaq8H5iDE=",
          "cpf": "U2FsdGVkX1+KQ6YQdy3ZajXwiTIesSsg9eSuKsfm5CI="
        }, {
          "num_cand": "U2FsdGVkX1+M3LMGh8rZJ9lLQXcrcQnlbnxs3ORiOfI=",
          "cpf": "U2FsdGVkX1++SzS2QWq44/pCzf7wUeQhKuvoiRcjv30="
        }, {
          "num_cand": "U2FsdGVkX1/R1437Kl0fe+6tAv5dZzkazUflQHz+za8=",
          "cpf": "U2FsdGVkX19rOWkARXUcsTGvrO7aPlOmKC8cDBJxKZo="
        }, {
          "num_cand": "U2FsdGVkX1/fMpGgISvlK1nXXbxqG1MwwTe2KgqQkwY=",
          "cpf": "U2FsdGVkX18N9mqj785Js8W/9qaQEKALor/XaD5sovw="
        }, {
          "num_cand": "U2FsdGVkX1/ymizF0o5pjkwBlPTKQlUMHOmsbBQugjA=",
          "cpf": "U2FsdGVkX18DuJoTiJP6FjGV+pDB6JL5NQN/0B+nX4w="
        }, {
          "num_cand": "U2FsdGVkX18OhUVHvJcURh34xhA7E/bKL9IvCFivXA4=",
          "cpf": "U2FsdGVkX19xDT5BpPSFMWUd/LoMNU5pg0RpYaeZs30="
        }, {
          "num_cand": "U2FsdGVkX1/t9AjPmkjSa96RJ1/QZR0GolV/Dabz6Uk=",
          "cpf": "U2FsdGVkX1/w4qVa6cPVt85A1M6ZYuzJhzhj2JVauNM="
        }, {
          "num_cand": "U2FsdGVkX1+Jer3611vhM/pQDvrg/d7J/lA6lrze45I=",
          "cpf": "U2FsdGVkX1+RCFNRcwjRW3N+pZib7KuGcfGNfT+eVuQ="
        }, {
          "num_cand": "U2FsdGVkX1/2iFA0xERGJ9415HdUD/x0ScM4kmjvb00=",
          "cpf": "U2FsdGVkX18bVsgx+BDwIhK4+c3t1qh8EMLfCMxRb+c="
        }, {
          "num_cand": "U2FsdGVkX18+KqYIs9oFGRivTzxlCVORbXPk2EKwFEY=",
          "cpf": "U2FsdGVkX1/YMd1BIwmyKjDbnJm6gNo2Utof928zuq8="
        }, {
          "num_cand": "U2FsdGVkX1/3GR7Pix92ubIaEpx0flsG37uTOa0p41k=",
          "cpf": "U2FsdGVkX1+N45JKuERnJCQyxIhcjNhYUkPv+xjLR5Q="
        }, {
          "num_cand": "U2FsdGVkX1/DuA1cyk1BAhb7ub5nJAE2KSTNvs/WFoQ=",
          "cpf": "U2FsdGVkX18RbawYyr1HPc4rXPUhvmyMwvU9wjIG83g="
        }, {
          "num_cand": "U2FsdGVkX18ZG5HrMDQhP5Jovoed73pC0KICl635wIY=",
          "cpf": "U2FsdGVkX19haxbxAN9wxeFwc6HbG8YdZH/yFKg9Xew="
        }, {
          "num_cand": "U2FsdGVkX19kE/zajpxnWVQSKnl1BwsW/Bt/BRvVpqA=",
          "cpf": "U2FsdGVkX1+/PRkSTRrdfPPUBzakDFUqcK8tR8I74Sk="
        }, {
          "num_cand": "U2FsdGVkX1/hOW4FREyJrgevHwzcAaiRcHfxLnAjgoY=",
          "cpf": "U2FsdGVkX1+vSRR4N57TSJXbPw6lhLqh7z6hr+68X/I="
        }, {
          "num_cand": "U2FsdGVkX18FzO8RHj/wJbLoxEwcGKljfHi62VBleCM=",
          "cpf": "U2FsdGVkX1+HbFRg0uRF2fmNNyD5qeONhKyopRNhDhk="
        }, {
          "num_cand": "U2FsdGVkX18gbXLrGbLz42HOvTy66YH+qznaUEZ6nV0=",
          "cpf": "U2FsdGVkX18LRlwA7N6aaKltowY+oxp8d1DFn5UZcEM="
        }, {
          "num_cand": "U2FsdGVkX1818BPHrUHQpQwlja26/6jw2fKtGUp+8eQ=",
          "cpf": "U2FsdGVkX1+fJ39sxaw/AqUO9mhtU6BDUfGcpSfXyec="
        }, {
          "num_cand": "U2FsdGVkX18J3M9zH/FUu+b0YtWBXeYMj96AV6NRCzk=",
          "cpf": "U2FsdGVkX1+z4xItzkV+0DaP/cH8d2sYI32Vn9d+gtY="
        }, {
          "num_cand": "U2FsdGVkX19pl+uFAw/Re96x1BtEFxub6MrsduxEq3Q=",
          "cpf": "U2FsdGVkX1/p+1lRd0B5/BIXZy9khCTiDsyD8dNM6vM="
        }, {
          "num_cand": "U2FsdGVkX1+/Y/ZiiPnTewVLiNfBRYqmLuVYb/q+o28=",
          "cpf": "U2FsdGVkX19dY0OoWNpXe8AVbL+hNnGgIooKQ+9Gbk4="
        }, {
          "num_cand": "U2FsdGVkX18K3U6kaYfJA0SWoBgcDatlTVS02+vlSHM=",
          "cpf": "U2FsdGVkX19Op8dXI1DNZJOrw3ba+AyYzR+OQFP96Pw="
        }, {
          "num_cand": "U2FsdGVkX1+9vrb/Vm2PvoEE73nZJVHm7wNVEQ3uMNI=",
          "cpf": "U2FsdGVkX18HNYqYfiGa74X6vSc0W1pghSw0WtXTDnI="
        }, {
          "num_cand": "U2FsdGVkX1/HtXfRzklSJgl3+7dga4lo3/Odoc8caNQ=",
          "cpf": "U2FsdGVkX19rj9YlxTO6MAA57K61ngLsKeUl2PJURdg="
        }, {
          "num_cand": "U2FsdGVkX19gtexZ4WREPjpK2SRJJM/RwyDoSd03xek=",
          "cpf": "U2FsdGVkX18gsmNAm+FHR9UD5AoWu00SCcML85uPam4="
        }, {
          "num_cand": "U2FsdGVkX1+jw1VEFIxMuC0JePQjz6r0mynlgehTdUg=",
          "cpf": "U2FsdGVkX19/C7zCyANjq6xLmRYfmzpFWNmiaw9t5WY="
        }, {
          "num_cand": "U2FsdGVkX18P7jnNY8MqD7KjoHbwRh3GBONf572M+ak=",
          "cpf": "U2FsdGVkX18G7g+bQKYNCMXTGazltoVp319YxJUdfPw="
        }, {
          "num_cand": "U2FsdGVkX18rzmAHlLscVGS0h/Ys8PeBTheBBjh+h84=",
          "cpf": "U2FsdGVkX1+stNuuIAxGrPjYUIaEhgxD+9CzZ+SfZOU="
        }, {
          "num_cand": "U2FsdGVkX1+mEQ59Innaq2MXj6HsYptogk1eB/eVxLc=",
          "cpf": "U2FsdGVkX18vMzmvA2VRq9798ybjZ19EgZubt3WrkZk="
        }, {
          "num_cand": "U2FsdGVkX1+XT15me4DBaODfa5MAM0Iz3ybe6y/X6nc=",
          "cpf": "U2FsdGVkX1/ZyEdg4cmPgumeMlqAbPtAtiLmyZ7kK60="
        }, {
          "num_cand": "U2FsdGVkX1+e57Ths3Z81zy4Z4w2m1hoRwF+5/ANxzg=",
          "cpf": "U2FsdGVkX1+i7brcRnIWzJMhUGptRpG6vzVz0yopa5k="
        }, {
          "num_cand": "U2FsdGVkX1+NUqC5P473cBH5EcWfyGTXsOGTl0P190M=",
          "cpf": "U2FsdGVkX18BgfMPWTxn+UUxs47vHIkzGdcqqgaFryU="
        }, {
          "num_cand": "U2FsdGVkX19fKN54SuDnwSYK++c2GCcGlGeBFB84z+E=",
          "cpf": "U2FsdGVkX19Tz8Pa+lc2KYsRRQQdyXhwLirTz4Pg7uo="
        }, {
          "num_cand": "U2FsdGVkX1+pbUfRE3Qu3gFBukUkXLn6zzohgb8hWzA=",
          "cpf": "U2FsdGVkX182gueqIf0i0v+LnYUXrurTCKMyPMEpxIg="
        }, {
          "num_cand": "U2FsdGVkX1+iHuYutkhiucu+uLHbT32ndR1fpyoneyE=",
          "cpf": "U2FsdGVkX1+PeXNipT3NByhQWVQU8AS1os15+Y01+aQ="
        }, {
          "num_cand": "U2FsdGVkX1/TBLWFey6TeWnPITZyIRNNxHL0wzROZuA=",
          "cpf": "U2FsdGVkX1+pHOkq07Q0ai+XvZ5DpUZCt8pZVxcx7lU="
        }, {
          "num_cand": "U2FsdGVkX19ptgWTAWrs/z+NIM0PZfYf4u3VnrEyb+c=",
          "cpf": "U2FsdGVkX19vSfhQ+ZPkHc4QZvNwSjhzhKALJ6yetoM="
        }, {
          "num_cand": "U2FsdGVkX1+ggiuQbR3P5M+JlnzkvrogGUyV8m9XOdY=",
          "cpf": "U2FsdGVkX19E+SoLtSEwcRRKEngqc47VhVZtwLfyn5E="
        }, {
          "num_cand": "U2FsdGVkX1+ps3oIgJx2x/hZcL4icQdJalXFi8jx5/k=",
          "cpf": "U2FsdGVkX1+S6JcTylCN7DaVz8Nldu3925yCP7nPp1M="
        }, {
          "num_cand": "U2FsdGVkX18TvRD4EJf2HvGAkdJVKf06orgVs8/z6PA=",
          "cpf": "U2FsdGVkX18JNs30H7cEFvYjrymf9rI3pWzs81/jt5g="
        }, {
          "num_cand": "U2FsdGVkX184PZbDjN4Rh02b9UNLX8UMJdSOSWkfjtU=",
          "cpf": "U2FsdGVkX18rzbIeIMZY3Emg+HAZm/E0wTCCG+pnIMQ="
        }, {
          "num_cand": "U2FsdGVkX18qe2Jiu0n0gjMvfDFMNaTmTiFiN3pVKTU=",
          "cpf": "U2FsdGVkX18kzSRl1iYilxxfINWql2FBeaWkVqJjS/I="
        }, {
          "num_cand": "U2FsdGVkX1/tvIuOcO29NIfopMzW4wAJg2f2m0tGT5U=",
          "cpf": "U2FsdGVkX1+88yowM8te2k4Pbt2TcBzcqanedPKUzfc="
        }, {
          "num_cand": "U2FsdGVkX19TEnEGBQPfiHwd1DoSd5khBkFzE4Xaiw0=",
          "cpf": "U2FsdGVkX19c1Jq0xM/RiQ/sUkvBdzVzJjezm6c7odA="
        }, {
          "num_cand": "U2FsdGVkX1968GA0oScbUwfVBAktnYwKAnxdhXNJW2A=",
          "cpf": "U2FsdGVkX1/kGHDd2mDRpiNxyqRSO3KbmtYGO93jn2Y="
        }, {
          "num_cand": "U2FsdGVkX1+LAoyfA43oWYdVLlGlSjbtNS5rjgbbSro=",
          "cpf": "U2FsdGVkX1/auHl3vyz/NX4xXP5aZ1AXv6c/3WSAZNg="
        }, {
          "num_cand": "U2FsdGVkX1/Qglj1bKtw9I3PggM3XPGS/rG77muIPVk=",
          "cpf": "U2FsdGVkX1/XInv724PLYnJJ71yLVMHhSo7oghwbH+Q="
        }, {
          "num_cand": "U2FsdGVkX1+HLOXrip5JHRX5dfkAeObLWZ+442VLDRM=",
          "cpf": "U2FsdGVkX1/XRoxsiEsVD627bXWVHh6hnXcq3p4qWRY="
        }, {
          "num_cand": "U2FsdGVkX1/JZooPzXsWXbb5vZmgrUUJ1cW1zsXVBXM=",
          "cpf": "U2FsdGVkX19UJtYa9pkjYKrcj4I1TNm3PKTx62s+2kU="
        }, {
          "num_cand": "U2FsdGVkX1+sOtA/cqeqhrk5r3v89OTmSf9ZOMkzQp4=",
          "cpf": "U2FsdGVkX19puJ0Jmi2phQeSHd1S0YlyEig6qnElZHM="
        }, {
          "num_cand": "U2FsdGVkX18HWRtFkaYpFIKzCbepjZ2/80Fd3kP/5Qc=",
          "cpf": "U2FsdGVkX1/WMn6VzceFZuJHPqE3gfwRPD5LFqtwQ7E="
        }, {
          "num_cand": "U2FsdGVkX18h419U2bV71NOFgl5e+xnquy6aPa5S+0s=",
          "cpf": "U2FsdGVkX1+8fo4CdXL7+EadQwxLHaLNRJ3vaPbiErc="
        }, {
          "num_cand": "U2FsdGVkX1/D2MWq3EosssiQwxYAu002mDOO5HWO7cY=",
          "cpf": "U2FsdGVkX1/4b0RiolZWmRDrMXc5M/w/WHu/qaqsjg0="
        }, {
          "num_cand": "U2FsdGVkX19dHdAoLDSu/VaEKUI7YLuJ3J1sduMwjgA=",
          "cpf": "U2FsdGVkX19aaTzcerfXVyZDMQvhFIXLbachf0VYFYQ="
        }, {
          "num_cand": "U2FsdGVkX1+hhFJgLophWktYP21VhehK0aFYRu/xEI0=",
          "cpf": "U2FsdGVkX18jxs+19/dEd9UA2BYYd4XWVXVRMV0GKy8="
        }, {
          "num_cand": "U2FsdGVkX19Lm2UmPfKwR+pO8JdIfkAQf1uVbtalCl4=",
          "cpf": "U2FsdGVkX1+EP9nwIF1G4280xowx/jzIl+t+pyO0AVk="
        }, {
          "num_cand": "U2FsdGVkX1/LHAIATKBy5kx0XYMJSir0Nsg+x/+zvNY=",
          "cpf": "U2FsdGVkX1+VypVXAMBoqManu1veXllWDNLKvZO6j6g="
        }, {
          "num_cand": "U2FsdGVkX1/j6rYWMIglrX7d/jAdDObeRsVXA5XMOqw=",
          "cpf": "U2FsdGVkX1+pk3deMzA2Q4p9pzbXvblPvprUG+EUWxk="
        }, {
          "num_cand": "U2FsdGVkX1/wEWiB0qFk4dxB+OtoaF/IYIzUJnXpSLU=",
          "cpf": "U2FsdGVkX1/D7ewgg0XcPVvSMAESqIYe4PyHQn2VytU="
        }, {
          "num_cand": "U2FsdGVkX1+XeGRSWVVjeo00yGGCfRQmOh3dOJrOBNo=",
          "cpf": "U2FsdGVkX1+KAsFe/FVk4Gn/+Pr05hXU1RfmFhU24nM="
        }, {
          "num_cand": "U2FsdGVkX1/w1TyZBXGFROqeoO570E6SS8P2175p00I=",
          "cpf": "U2FsdGVkX1+7Il9VToaGDdcN+qT0FTt+O9E/pQVm9Hc="
        }, {
          "num_cand": "U2FsdGVkX1/ySMAuI9FqlspF42gDBImD3td6pZn1xJI=",
          "cpf": "U2FsdGVkX19pRhpNveux8SKrlldN/ImcvOra+GRl5+M="
        }, {
          "num_cand": "U2FsdGVkX1+hogne3yovv6jiUOkRH/kj+oZt+CpMy3E=",
          "cpf": "U2FsdGVkX19+wOugnJ326wc63IyA4OH5S5KWzTKLLPc="
        }, {
          "num_cand": "U2FsdGVkX19LPDdfrtpCSUJRwcqOD5YXOHIeKMsL4Nk=",
          "cpf": "U2FsdGVkX1/cbkPkoLVb1PTaNzoVpBXsz0bcm1PieiA="
        }, {
          "num_cand": "U2FsdGVkX1/YYHOsiGbMjAkAbCFzU0KO3dIgrMt6lgE=",
          "cpf": "U2FsdGVkX19u4VjqQunK+xVDx64TdOHutirJQkKFCkE="
        }, {
          "num_cand": "U2FsdGVkX1/Iunk1vq/xtPQX1J8SwovFj155qOVBT/M=",
          "cpf": "U2FsdGVkX199hfgWRl6fJDfwX6giyxCb2nzbGuf/7iw="
        }, {
          "num_cand": "U2FsdGVkX1/t1OXIhWU33lYgCed13JXnZT6HdIlMFWo=",
          "cpf": "U2FsdGVkX19HkpRza/10/ZKNJcT39lYYF/2knjrn4mY="
        }, {
          "num_cand": "U2FsdGVkX18Hr3IGg3/voZ6WDhLQ5shgDt7yQgTXp9M=",
          "cpf": "U2FsdGVkX19Naz6KZMJlACoC5L8vegLtG/PyeI3EMBI="
        }, {
          "num_cand": "U2FsdGVkX1/dYggZJQf52nxySnmikm4Ndhu4sA36lgw=",
          "cpf": "U2FsdGVkX19q0kHSbi2tx5xKJ1blzFNT5JwsX3uzX9E="
        }, {
          "num_cand": "U2FsdGVkX1+zrzTxdPY5YFgvpG6zvDM21C/KJOFhb3k=",
          "cpf": "U2FsdGVkX1/js57mbutlqh7EBcEAp3YStD39uHQAY/4="
        }, {
          "num_cand": "U2FsdGVkX1/+uY8a1566cSogqKnRK3BLNENQqJj4BSI=",
          "cpf": "U2FsdGVkX1/pubS51S4023KWFH+WuVy4Sqf0rG5Q31I="
        }, {
          "num_cand": "U2FsdGVkX1+pRJoZbC5UV9mr+Ahtu2OsMM+XdXdhuDo=",
          "cpf": "U2FsdGVkX1+xGzirZH4UYtXy/k+Sy64fdEw9CTSBpMI="
        }, {
          "num_cand": "U2FsdGVkX1926Yn+F7v+qm8ESU8lmyKAxwi6PfHTpuM=",
          "cpf": "U2FsdGVkX19qgN8IczZ/KisPXEG/s61tsg+hHVt87Ho="
        }, {
          "num_cand": "U2FsdGVkX1+YGWJWb3kF5cuymwNrCQDFDsiEImTTrbc=",
          "cpf": "U2FsdGVkX1+Zx+SZEsYiSk+SnAFCLanPhuYO6CXK3R0="
        }, {
          "num_cand": "U2FsdGVkX19RhoIFVgQVE0t1Ys1oKM/oLpRghILDMn4=",
          "cpf": "U2FsdGVkX1/CxFtgsX1URhKkk9cJebOYpecX3dtLpt0="
        }, {
          "num_cand": "U2FsdGVkX1+rZHuU0IhKQcbHAo5EQcOt19nMi6W5Ao8=",
          "cpf": "U2FsdGVkX1+cXuQ0lkbdC405XbYLiGYRDiuVTNZ8pD0="
        }, {
          "num_cand": "U2FsdGVkX19bHMhyogq5dU+Zt4TEZSJCLPxgpboBAcc=",
          "cpf": "U2FsdGVkX19A4yUnT/+e4tfomCf+5JosvhQE6tBbvEs="
        }, {
          "num_cand": "U2FsdGVkX1+cBsnOuZLfUEcoUmo065VGTc4evYUZtus=",
          "cpf": "U2FsdGVkX1+AGZro4ZB3x5Aagt4GX+0DOy/YBpB+wsE="
        }, {
          "num_cand": "U2FsdGVkX19Ri2T4Y7BfGOlEqk2OElYW7wFrHyyzJMA=",
          "cpf": "U2FsdGVkX1816k8EIuJSh2qjTpwosfBL2S7CaZZxMaA="
        }, {
          "num_cand": "U2FsdGVkX19gdIUSUiw7cNqoKx1dAA3gKqsOPtzI6dw=",
          "cpf": "U2FsdGVkX19pUzkegUbOEYWJGKRP6h3/ILf1D5CznZY="
        }, {
          "num_cand": "U2FsdGVkX1/bXbhfmmToW2D4s4JbqZp+DF82xMcAbE4=",
          "cpf": "U2FsdGVkX18tIYXPsiXMA1fVZfdO825RN2x9kjogB4I="
        }, {
          "num_cand": "U2FsdGVkX19Vp2GzKENMfNh9NjXMZQjSjdoo7aeVDww=",
          "cpf": "U2FsdGVkX1+36z3S4l50MfoJKUrh1GFfdUl6rSzcDZo="
        }, {
          "num_cand": "U2FsdGVkX1/RIIPMOPVCBj7DEtGQvH9/RY9t/umWKqM=",
          "cpf": "U2FsdGVkX1/C5c88t2W7biVOBX3GQlD6Q1BLuS91U1o="
        }, {
          "num_cand": "U2FsdGVkX1/30hvJY/PA7C3aSqfFlP1QU/FlZS/mcd4=",
          "cpf": "U2FsdGVkX1/Tjeet1Pizn5y7KmxcjLGbolqxlD6GDUA="
        }, {
          "num_cand": "U2FsdGVkX1+MgjOVJMFsV4APmGwyIfctoSa/Sr8GYMY=",
          "cpf": "U2FsdGVkX18rmVehtROwn0Zz4AVKsjWAw/W7bOue5To="
        }, {
          "num_cand": "U2FsdGVkX1/QDxYndG9JYjZ/pn5sm7SSRBVUds7Tu2w=",
          "cpf": "U2FsdGVkX1+bLGB/gQ+f0iBZH27yzpBYo++C9rG4te8="
        }, {
          "num_cand": "U2FsdGVkX1/iyIsu+AasgJtArPdG5FPU7eCEFehDfSk=",
          "cpf": "U2FsdGVkX1/5SM5EVbGs2D/b6KYcJSF6O8Xb1bY8Uus="
        }, {
          "num_cand": "U2FsdGVkX1+n+J70TU7fLhAbOQw+w8FWr5oprUMGmVY=",
          "cpf": "U2FsdGVkX1/IsbWo+R1lmptA+xMRfUmp6WoZTElkYh8="
        }, {
          "num_cand": "U2FsdGVkX1/PXe+UuNsy2d1eIeyzLo8ZFg2Hv0Qm4A0=",
          "cpf": "U2FsdGVkX1/yINt+z8wwp6dpYhnxKTMTi+qVgsqLPdk="
        }, {
          "num_cand": "U2FsdGVkX1/YiS6qCz/wyMFAbiVOrLyvrLyB1C4wIsI=",
          "cpf": "U2FsdGVkX1/DSOI9iG19hQarzMZCxmyEA3Lh5izqJy0="
        }, {
          "num_cand": "U2FsdGVkX18cbrC0RsbX0mKnozQYIknOuJB3oshEYK0=",
          "cpf": "U2FsdGVkX1/W7KZwDoJ7bsAy0h/DZwu6A2+vO+ZaoFg="
        }, {
          "num_cand": "U2FsdGVkX1+GrpFWzaiT4sbsTrWzfECdXHTeTkdpU6A=",
          "cpf": "U2FsdGVkX18/4ANsbqD7aZCAY55Z7OMh/I1JE5J6YFw="
        }, {
          "num_cand": "U2FsdGVkX1+PrGrmBc10WqHcveTN7G1JnKD/DhFJ/BE=",
          "cpf": "U2FsdGVkX1+CeSTjc1XcYplgjAUhuYIa3IoJrow49Gw="
        }, {
          "num_cand": "U2FsdGVkX1+vzDuJ/Fe1LsRyT9Dqgne0eA/eHmbf30s=",
          "cpf": "U2FsdGVkX181Q77LN4DB9I0JrRaK1/g7Bb4icXYIVvM="
        }, {
          "num_cand": "U2FsdGVkX19oCWyWMjquZdT5CTksbtKcmMDqb82Hk2E=",
          "cpf": "U2FsdGVkX18FRlTFN/19GLWjDCcrNFG/OElf6X3FB18="
        }, {
          "num_cand": "U2FsdGVkX1/0IAY7DaixXjO8oIza+zLq/H3GXt/PXKs=",
          "cpf": "U2FsdGVkX1+y3jz7VA706vK/WNvv3MZCuzPte7nHWKc="
        }, {
          "num_cand": "U2FsdGVkX1+sPmZGiB4GHqmcXgXKoH9QzXhBIiC+E/s=",
          "cpf": "U2FsdGVkX19yjcLmLeN/JvrBU9h696/U0MTBNH+qVqc="
        }, {
          "num_cand": "U2FsdGVkX1/EogZm++3u4ck/TMnHxJAwGO1lyut49/0=",
          "cpf": "U2FsdGVkX1+Abeoi2bKHEkMKIIgOu2G15tAlqAtbUww="
        }, {
          "num_cand": "U2FsdGVkX19JQEe8bbv0O2QGPwd7byhTcefKv+bB36M=",
          "cpf": "U2FsdGVkX19INGBXFmwL5xZWufR7GQmFVKIutSdIeYQ="
        }, {
          "num_cand": "U2FsdGVkX1/pGCXrik6EHcajkED41I7txsdPWCyHSGc=",
          "cpf": "U2FsdGVkX18YeNSAazjQMg0hrWjuPf/wfLO5fj2vUcg="
        }, {
          "num_cand": "U2FsdGVkX18+WA4P2emia6Flid5UPzmelsUsj03VlXc=",
          "cpf": "U2FsdGVkX1+O+T01dvgt1tnL1JY6234TZ/5PoAn3B44="
        }, {
          "num_cand": "U2FsdGVkX18KRfXpayUFQDtOldIOJZuhsS4Xd+cs5r8=",
          "cpf": "U2FsdGVkX1+q4UHluOHYuIFn3qOWAiraSAcErhFQKSU="
        }, {
          "num_cand": "U2FsdGVkX182f/IbDQZ4PYDNjYsfVmsIajEfkGYS+zA=",
          "cpf": "U2FsdGVkX18f3MsemZzRNC8V0lb36nS+U9yJ1t9Kp1I="
        }, {
          "num_cand": "U2FsdGVkX1+eR+EtPX3KfgVenKvUHTek6j8lNk03dQk=",
          "cpf": "U2FsdGVkX18NguNvn7Igk2wFH5thPYG1LrLh6gqTRBk="
        }, {
          "num_cand": "U2FsdGVkX1+cD8Try3yzOelN5Lr5cC/gayqeSFogArU=",
          "cpf": "U2FsdGVkX18NsWcbDjW+2O3S2KpNC8WhHzvR0317Hso="
        }, {
          "num_cand": "U2FsdGVkX19kRKn6AD+0gNhCoYXxfYds6ibSKbNFh4c=",
          "cpf": "U2FsdGVkX1/xaiyqLGZic8j3UoOQR/+ilwRbMG8Dmek="
        }, {
          "num_cand": "U2FsdGVkX18iAW+yE0isQ3JXJeFM6JGtrKDtwTTJJRY=",
          "cpf": "U2FsdGVkX1/WXHDrK9RWJuHZxuqFfLm9wme8+yDmwEQ="
        }, {
          "num_cand": "U2FsdGVkX1/Q5LisrZw1bCRRfvHRJMxkBdWRJ/U+O0w=",
          "cpf": "U2FsdGVkX18fxK4uwXfToJ6yuGTE7E4Bj5yee14Q14A="
        }, {
          "num_cand": "U2FsdGVkX18/R5q8k6Ju1SzNOVl9w/8KxnCx+5az+Ys=",
          "cpf": "U2FsdGVkX1/iJfUDMR9ajNvBbkz/IMf/oyJmXmfdMVY="
        }, {
          "num_cand": "U2FsdGVkX19BsAcvmLmhiYrK/rOuofJLx7nB9BQIOEI=",
          "cpf": "U2FsdGVkX1/+NIt/yJL5TqwSFn/rsMQXSLubw4Nfg+Q="
        }, {
          "num_cand": "U2FsdGVkX18Tta6JHsToCulWnX3UKXTxe9Y4Z0vJiM4=",
          "cpf": "U2FsdGVkX1/EYK9ubkWIabuEspNkU4XbqqlMOYjicxw="
        }, {
          "num_cand": "U2FsdGVkX1+uWG7VjwFvUvFC3/77Prmgov6AaVXuo+s=",
          "cpf": "U2FsdGVkX1/1uVSLD4Puu4znjFfumbseL2jelDBRRFk="
        }, {
          "num_cand": "U2FsdGVkX1/254zMHkA5TITmw3OB8mg1tKE55IQKjZk=",
          "cpf": "U2FsdGVkX19r05qAXGo3o6jmkr175Vl0ZgKBNXrsiWo="
        }, {
          "num_cand": "U2FsdGVkX1+a2vHdRN8l5kVJp2vm+5pO+AFumt29otM=",
          "cpf": "U2FsdGVkX18z6OE0dBeOxiW//xZu6b6otKIcFR8Zu3U="
        }, {
          "num_cand": "U2FsdGVkX19gBM8x4tKAtsFJhI2hYVWpchWI+B2CL2Y=",
          "cpf": "U2FsdGVkX1+kIE5n3jVcoHj7qhlYrdlElTUQrXmCDjg="
        }, {
          "num_cand": "U2FsdGVkX1/WF0aTlHcMNv5sgWoEkNfiiGc073kNYB4=",
          "cpf": "U2FsdGVkX18SsUZIEBlAbdnopr2+XdduXFG+rTwa73U="
        }, {
          "num_cand": "U2FsdGVkX1+yd/24ZJthQLVjI+mqJM2MFOUkKhKbBPM=",
          "cpf": "U2FsdGVkX1813fl5e2bBGOoV5EQamELcdh0jYYjVXKU="
        }, {
          "num_cand": "U2FsdGVkX18NxI9KxG2GoIEC7FTqJeoIQ7Xsgk4f0p4=",
          "cpf": "U2FsdGVkX1/+PX6pFza+6IWjsKSggewSHK4Rs7slQvs="
        }, {
          "num_cand": "U2FsdGVkX19XwQ3ef6mxJX4miFRXMFCv7MbUhiUXB5M=",
          "cpf": "U2FsdGVkX1+YbSpJTFjkPBQznNhr5Qok3ffTlUnBjgo="
        }, {
          "num_cand": "U2FsdGVkX1+wJGwmb0nWAlSpiEeKNSLSz4PBmfnsbMk=",
          "cpf": "U2FsdGVkX19ONPpbkYw/gi27ryYzIqsBjvUa9bHgmEY="
        }, {
          "num_cand": "U2FsdGVkX18mdik2DycmkO0A89t6e6za9/9TqBusJb0=",
          "cpf": "U2FsdGVkX1/h0YDhNNgO1XlC2xhYaImAxWt8wtNJj64="
        }, {
          "num_cand": "U2FsdGVkX1+wuO2aPzId8EZdUJ8vk50hS7B8wcwEDnQ=",
          "cpf": "U2FsdGVkX1+vM/9qEVL68cXx+UOJx2AOpdcqiCTI2b4="
        }, {
          "num_cand": "U2FsdGVkX19FvjXoxNtOD4lKFOXR111HvcHorFXWWTQ=",
          "cpf": "U2FsdGVkX18yhYlNjewbVWy+pv1Un2agKgPxOkgH0TI="
        }, {
          "num_cand": "U2FsdGVkX1971RbkqzVZkmqP3HAhKcKN9zOO6RNFifU=",
          "cpf": "U2FsdGVkX19aCpja6CB8TiJO6Gqus84KOsvWo0Sw4AI="
        }, {
          "num_cand": "U2FsdGVkX19JTruXPtgX43dKDCrWr1Sk87qvBwhFpo4=",
          "cpf": "U2FsdGVkX1/BHzluFw9YUYSQQ0kLICXw3rulrkImL8I="
        }, {
          "num_cand": "U2FsdGVkX1+Bozzsx9gJQSXM302u2XnD4k04tf5q5lQ=",
          "cpf": "U2FsdGVkX19jqPhAJ5NnPk86dx+8gQDE/cAJu7jX8L4="
        }, {
          "num_cand": "U2FsdGVkX190KutfgWz4umuaVCM/LQeQI+i7T4FMjfs=",
          "cpf": "U2FsdGVkX1/e6qRRpDRZvJgiHwAL26HSosUqICVfwdU="
        }, {
          "num_cand": "U2FsdGVkX18n7HesXdHQHibZ1UApPiaGfxWLtJ2mGh4=",
          "cpf": "U2FsdGVkX181A/9Bgsqvu/jJUt1iqsmzuN4YHwumQEk="
        }, {
          "num_cand": "U2FsdGVkX1/OnByaBQHU99437vy5j+PF+zgXZkvBEfM=",
          "cpf": "U2FsdGVkX1+NTNyETh38yCI7yGeWoE4Ptakh5mzG7sM="
        }, {
          "num_cand": "U2FsdGVkX1+voS8KHPHWdD9PgzkD8CJveSfUkLSoPeo=",
          "cpf": "U2FsdGVkX1/qa8swDpqSdZ8TcYE2pzsaVejEECdQ7ko="
        }, {
          "num_cand": "U2FsdGVkX19P8AwqcQlFaZ/7dztSbZRZ8b4yjJtvQFs=",
          "cpf": "U2FsdGVkX19yCAC0Boja1EvKKIWd9XgcyBxbczakwXw="
        }, {
          "num_cand": "U2FsdGVkX1/4FhXDKneQqn0eRvzPJTL9lDNyAk0soNw=",
          "cpf": "U2FsdGVkX19b4pI5nAV8881JKUu/V07eigtMHEavZ50="
        }, {
          "num_cand": "U2FsdGVkX19WjFsZebHzIRIVQaCGGG/NJRTZCYbs2KU=",
          "cpf": "U2FsdGVkX1/zRf2Sa8tVrxFa5NVALsn/O5X214ZaYZw="
        }, {
          "num_cand": "U2FsdGVkX1+2bHtSXMh/QZDWzInOUrgvm3deXS2w+A0=",
          "cpf": "U2FsdGVkX1+zZJfp72Y0DAGl6f8BTLz9KOtIYUF7rF8="
        }, {
          "num_cand": "U2FsdGVkX1+Ynyi4uy0+mBhBwcpcQc9niAnxbX0wkBs=",
          "cpf": "U2FsdGVkX18q/uFiuhsf3R5/LlBSUvdXxAj0QRcMtc0="
        }, {
          "num_cand": "U2FsdGVkX1++olVGrupbox+eIXC5m/ybJbzims5iHNU=",
          "cpf": "U2FsdGVkX1+WUdWAdOuDCAMlnhe4t/mDn8gEsBnCD5I="
        }, {
          "num_cand": "U2FsdGVkX1+8DijO4+Aa+L/mLJtLDbo58jVfIwopbBU=",
          "cpf": "U2FsdGVkX19N1Qxvz7klQcw8RQcR29KJGLzcOnOep9I="
        }, {
          "num_cand": "U2FsdGVkX1+FXkkCdi5P0y2yU2DugkGY3SA4MQRd8yM=",
          "cpf": "U2FsdGVkX1/LgbAlOkkYZfDFd9jDbBYjYNYqoabPW8Y="
        }, {
          "num_cand": "U2FsdGVkX1/iU7hKJWaRk8gyAjLa4FsfJkG6eX+8Qx8=",
          "cpf": "U2FsdGVkX1+EL+P/PFQHbzsvXy24Tm0IzIE0nkr5FYY="
        }, {
          "num_cand": "U2FsdGVkX1/Aa63pPtSrrTFkFuuptrv/P1qwheR+SDU=",
          "cpf": "U2FsdGVkX18utOo6B+4NCvdWC6hSq7fpHaPo1dVNyXo="
        }, {
          "num_cand": "U2FsdGVkX18Zr4dSOqLAZbiS/v0BR7Xu0atNBT9GoX0=",
          "cpf": "U2FsdGVkX18QuDFYulSLZk6Qbi1FqdVb1OeBasIKJRM="
        }, {
          "num_cand": "U2FsdGVkX1967MJ83n8VB6ZK/2/cg0sstReMvhRqWCo=",
          "cpf": "U2FsdGVkX1+L5ATXO8+sc2u1aoHqVU/FulxRKkrABDc="
        }, {
          "num_cand": "U2FsdGVkX1/SjOa58ibpwfnE28uPEuKzNgBBzEx4Gws=",
          "cpf": "U2FsdGVkX189QYyOXxQmAQwG1Fet2883XF7T6tDVTwI="
        }, {
          "num_cand": "U2FsdGVkX19HW1ODL2UjPNKEK2YUIHDd37kJmD1eE+M=",
          "cpf": "U2FsdGVkX1/hMY/o0wDQi0TrmxnC4135Ecv1nx10Qaw="
        }, {
          "num_cand": "U2FsdGVkX1+mGip5ZzX8YqZzzib+gHPJHG8hZHsoP4A=",
          "cpf": "U2FsdGVkX1/HS6nGA4ibYoPl6FmM3eKSPvjUqrTSbjE="
        }, {
          "num_cand": "U2FsdGVkX19EfA4h0/x9fLtFs/2JE1Yd7wvJQjMdmZI=",
          "cpf": "U2FsdGVkX1+PAkxx3K1CeW+ep0vOGJt1CbJ3c54wI4M="
        }, {
          "num_cand": "U2FsdGVkX19qV/XFonzx0V3ZAiIZeu+JDWHv2levr7I=",
          "cpf": "U2FsdGVkX18rMT7OskuGFVnzlS0/WTMYSm1DMRu7Eok="
        }, {
          "num_cand": "U2FsdGVkX1+TX+UgNzs17j3hRQgxhL4oyQv6nLD3MEs=",
          "cpf": "U2FsdGVkX1+g2+lr6YZEXFyHNPnfeC/UJk2iWFHIuCY="
        }, {
          "num_cand": "U2FsdGVkX191y7Id/FWBkuxofoBdVrCQByIziKywrR0=",
          "cpf": "U2FsdGVkX1+7DDMRH6bAChvetWNJPjbi1A2WQ/TywBc="
        }, {
          "num_cand": "U2FsdGVkX19sBxl8MjYFMqGrOYNFANOtPn5ypRM59wM=",
          "cpf": "U2FsdGVkX18sMJLfeSUS0csoPcznFDJGLbQ8gMOHGBo="
        }, {
          "num_cand": "U2FsdGVkX19qhDL+BY5DlJpAvhhwW2nEFdG3LqzLEsI=",
          "cpf": "U2FsdGVkX19c1/lZcET2zCf0gKpDc8BaiBrP9HISuI8="
        }, {
          "num_cand": "U2FsdGVkX1/Rhk8pJgEEyOAG7pih9MHWMM+5u+L3yNg=",
          "cpf": "U2FsdGVkX1+mpLrBjl4LdPajrvDrMwwCSlLbhdwpncg="
        }, {
          "num_cand": "U2FsdGVkX18bm7aRGkrWb8oqkUDBseyIpRwPgKSZZcI=",
          "cpf": "U2FsdGVkX18Z+BQlA83uBaSsE2tATH8LMpTcoOuWAXs="
        }, {
          "num_cand": "U2FsdGVkX18LyukuEAagv9lTtb6H74t9f/xmmWDBQX8=",
          "cpf": "U2FsdGVkX1+nFM0TiwoqhAWcZW3ue0eh1pI1vwuwoKQ="
        }, {
          "num_cand": "U2FsdGVkX197bkHCyb/Ooul4OthdpPWAtN8kKTxw1xc=",
          "cpf": "U2FsdGVkX1+m7YxOGndDYkkIpQdtJMe4z1YxDRf41Dw="
        }, {
          "num_cand": "U2FsdGVkX19EKSSoWT1PrMAIHL9NEChSBwaAFSr8mdU=",
          "cpf": "U2FsdGVkX1/qW7dz0lP1ChtxBzo211m07oJMh3462ds="
        }, {
          "num_cand": "U2FsdGVkX1/kB6AX+ZQr9vygw1FwRxT4DiWaqVBPEW8=",
          "cpf": "U2FsdGVkX19IEvfysvstuGHd8tFM0tRDIuz3u23PZAQ="
        }, {
          "num_cand": "U2FsdGVkX1+LSKxP5RWoz8acXw4bcE2PeAnvCEXb94c=",
          "cpf": "U2FsdGVkX19lUa3ZVhJjNIoKbIHHIvYTlZyBA0Rzttc="
        }, {
          "num_cand": "U2FsdGVkX1+6YXRulvQS+xtLrE4FkV+FTrNu9LubVUY=",
          "cpf": "U2FsdGVkX19MloMeY8/tn2od86QJhN1qMS9SPc3AWD0="
        }, {
          "num_cand": "U2FsdGVkX1/HJSo8OJbIl6WSZVo+46HwvHKZ7VLHQrQ=",
          "cpf": "U2FsdGVkX18nwbKOjya3CfO+K8ysISAK4bb/QyXcDkU="
        }, {
          "num_cand": "U2FsdGVkX18RxLiRuZ+WoCsEh1xeekBnJUiwZ7j8OiY=",
          "cpf": "U2FsdGVkX18BqdrxCy+5h2jjLpbG/ORmbnsW+2NJ8Zc="
        }, {
          "num_cand": "U2FsdGVkX18FgaIY9O22cHWmrCVLPIisWberYnf1x+8=",
          "cpf": "U2FsdGVkX19tSAtfuaJK03s76FVYem/oc178c5pYkk8="
        }, {
          "num_cand": "U2FsdGVkX1+/X2eUp3gbYPXV+sv0cbIWFx7JfrMioZE=",
          "cpf": "U2FsdGVkX1+hgSI4Vp9B7wAVgoA+88ZemApPlpCIK3g="
        }, {
          "num_cand": "U2FsdGVkX18W2usgnI0u2eQxSsNrqWEhrpBDBYf/24E=",
          "cpf": "U2FsdGVkX19H4SXqU61O5fo7poJTRQGaGcPzzESenjA="
        }, {
          "num_cand": "U2FsdGVkX1/f6iOVRU5+5A9egI7nA6ezuia4Q5c5TBc=",
          "cpf": "U2FsdGVkX18swBoH1PfoVl+bA/ptu1JXtmis6Pg6T68="
        }, {
          "num_cand": "U2FsdGVkX191TlWrMPFnjPWrU/Ohd3hK5kayNimVCcc=",
          "cpf": "U2FsdGVkX1+/c0tL0Xu7BZ0c+hJs/kHlwy4e/4hXLgI="
        }, {
          "num_cand": "U2FsdGVkX197VFu59SL7HhOtkCdztwaEzaYXan4NpkI=",
          "cpf": "U2FsdGVkX1/9ZYyvX2Y1atwl4AbrlbdRH0ybdOpbyt4="
        }, {
          "num_cand": "U2FsdGVkX1+n1arXoawe+zr/hFMPbNd8Lf8kTJnqP/Q=",
          "cpf": "U2FsdGVkX1+2e+OGjhOyu41h3pZQ6GFU2usbvA5zNUw="
        }, {
          "num_cand": "U2FsdGVkX1+VIihBHOmYOUSRM3gpVCJqnWcKiZXZTA0=",
          "cpf": "U2FsdGVkX1++xpfwsMt8DbLKoG39VC1M7Z/U01gjZ+c="
        }, {
          "num_cand": "U2FsdGVkX1+PR8VEXmd9LXz5kW3YvrfsX8QPB7jJ3eo=",
          "cpf": "U2FsdGVkX18OVBxJbMoc9T37DvyyIRWTHEGEeRSpwiU="
        }, {
          "num_cand": "U2FsdGVkX1/GHe2NOUkjXy60U2HhGLLhdgLA2YWcxcs=",
          "cpf": "U2FsdGVkX19Z3mrfFN11kCXSRIYqKM2RWfjM3quNQT0="
        }, {
          "num_cand": "U2FsdGVkX1+SzVIQxbrVa4scFNn8dbQeJsjVrdIeliQ=",
          "cpf": "U2FsdGVkX1+GtHYp3ewcIzvjAFkxA8lC2GSq8UvgIYU="
        }, {
          "num_cand": "U2FsdGVkX1/FDmF+65znCb43b51MJjyDkYAmrsKZobc=",
          "cpf": "U2FsdGVkX186/DuugZdiWpA7Vq67hCY0EX1bczEgo3s="
        }, {
          "num_cand": "U2FsdGVkX1/ULmtd94qTwl3Od+YLwD7hUZvAHAVsDbo=",
          "cpf": "U2FsdGVkX1/SU2xcRSYApVq2GeJ2T+xCb6EVyjllhQA="
        }, {
          "num_cand": "U2FsdGVkX1+v3Tgezpl4EQLQrguozWBQvkwirCKAK7Y=",
          "cpf": "U2FsdGVkX190TO4t3DwT7eOMCPcVQSM6D8Mvq9GvglE="
        }, {
          "num_cand": "U2FsdGVkX1+kzuRc3SJnM0/z+p0t/kiXejrX0OCBURw=",
          "cpf": "U2FsdGVkX19i6/HUkoSw6tI4K4UoKSjIapcYa9wPVvk="
        }, {
          "num_cand": "U2FsdGVkX19lnBU1KxHsPH0BxwOHAyROjB1fKHYBWqY=",
          "cpf": "U2FsdGVkX1/+diTKnHoo5peTnc9NESR/wZTZ8zCRbKw="
        }, {
          "num_cand": "U2FsdGVkX18L71YjeNkUoholbgyzW4jYIXx6jmAETrs=",
          "cpf": "U2FsdGVkX19IlntUbQJHXIjhtXqSIX1HWnEiAByD1ac="
        }, {
          "num_cand": "U2FsdGVkX18b/ekfyESkYs2CdwQyH5mMFrXdN+eLL+s=",
          "cpf": "U2FsdGVkX185lphZc/XNz4N22thXzL7gnY/GPihU8CI="
        }, {
          "num_cand": "U2FsdGVkX19LEFmZysKvFXOK+hKTrQfmJdJwtyq21ks=",
          "cpf": "U2FsdGVkX18Ei88WhQ8fsjM3YkENrsHlwTzyaH08Fkc="
        }, {
          "num_cand": "U2FsdGVkX19tlpKDDbW6HwAiW8LURK4fBNqridgKB20=",
          "cpf": "U2FsdGVkX1/BThPHfI0JaxA/hjxjD/bhgtxjWkz2Azw="
        }, {
          "num_cand": "U2FsdGVkX18486CWpikg1I9wm/83jwa4Lvaa5rQbFgk=",
          "cpf": "U2FsdGVkX19Hw5Dc0sPPRpi5zNTgYOp/lKmjYhXQjnE="
        }, {
          "num_cand": "U2FsdGVkX1/BP54W0a1W24VuI43G3rMp05EcrPJjSuo=",
          "cpf": "U2FsdGVkX19OLxyiIflpYHIntBByC/7A9wn1xaQfrQI="
        }, {
          "num_cand": "U2FsdGVkX19FKgTY2Nu1UY6DrIksJh7DM3p1dhUwG+w=",
          "cpf": "U2FsdGVkX1/gWSU13QXYNLhY8rSDHtdEIRayBipFGrY="
        }, {
          "num_cand": "U2FsdGVkX18JZzMDZ0Nvbsd6dReHgSms9CG7p1mEiLE=",
          "cpf": "U2FsdGVkX1+b9T9hPKxFCB7xGd3t1zdL3kSX7g/RfoQ="
        }, {
          "num_cand": "U2FsdGVkX1+1TGtLBDm65aXFsb2d3PIqnhvqEh9j3NI=",
          "cpf": "U2FsdGVkX19Zcl/24dOycwhVV/qfi8W7RaLmFmwYZKI="
        }, {
          "num_cand": "U2FsdGVkX1+gBmySkbSdrBqs8QHb/ii8YtYhk+2iDzk=",
          "cpf": "U2FsdGVkX1+MeEJd7kUlrqJSkNIiA476byBlj9DmP9k="
        }, {
          "num_cand": "U2FsdGVkX1/Z9LEQItWCNgIl6ZFSw7hw8J9DvrYsgAE=",
          "cpf": "U2FsdGVkX1+QVet+aqzd/pxOOQs1vgrZaRqgI2Y/9n8="
        }, {
          "num_cand": "U2FsdGVkX1/hNIw+ArdTi+13/W8f6aOKI8OkDGFTqvo=",
          "cpf": "U2FsdGVkX1+yM7lwUicRBxFEXz1SSGKneOsfwN2ounM="
        }, {
          "num_cand": "U2FsdGVkX1+rs/g47ORiQ35k6L6VlLHTxsRd0oH1mPo=",
          "cpf": "U2FsdGVkX1//uIco5shVteLHyRCL8bjHPOrD0sgxN08="
        }, {
          "num_cand": "U2FsdGVkX1/uphBakHB31AInbq7WtLDP+4qRIlxOT9c=",
          "cpf": "U2FsdGVkX1+IQSAh83SBc+N6F+YQ9+WIqsm9vLis7uA="
        }, {
          "num_cand": "U2FsdGVkX18RI2+LhvnnIkKOifbIIrmFAZRPMDxy8cU=",
          "cpf": "U2FsdGVkX19a8eTWPyHPm4QDdBHOwy00LzRZEiRAZDU="
        }, {
          "num_cand": "U2FsdGVkX1/a3D/m26e29Y1dObmV9kFI1InVnViyHi0=",
          "cpf": "U2FsdGVkX183Px4cSELiV4irfN53q1vJvq4NajHRwkY="
        }, {
          "num_cand": "U2FsdGVkX1/sBwwMMf3WsZcpssU2htwIIylirRu2dCY=",
          "cpf": "U2FsdGVkX1+hVE/+zCR0MJchJqgoOOPiZl0DfJIGYV4="
        }, {
          "num_cand": "U2FsdGVkX1+7f4U2LJsSCbw6aeZsc7feJ3yUnRVIrm4=",
          "cpf": "U2FsdGVkX1+v5dtK3vP0ryR0pynPNOZcw2AZ+th6MOU="
        }, {
          "num_cand": "U2FsdGVkX1+s+N5MvG4fA07imKCyjr8iHm327Xe+YSU=",
          "cpf": "U2FsdGVkX1+uPSOWL3SwN8UMduChCm8mB7GBMpUerYs="
        }, {
          "num_cand": "U2FsdGVkX1/nlK00OhWJTUhOcWtthiDvsRD46ZvnZGs=",
          "cpf": "U2FsdGVkX1860o36GegZsiPvy6WkAUFKExwgdGRKW/I="
        }, {
          "num_cand": "U2FsdGVkX1+QEIct7skfK35p2ltIroBY1KIu7dww34o=",
          "cpf": "U2FsdGVkX184zN/xoCCT3D8hHGq246coofPA6e+tkkE="
        }, {
          "num_cand": "U2FsdGVkX18wOQiJBlzL3MSy4Oene8HYhfi/FQ+mh58=",
          "cpf": "U2FsdGVkX18LoPpNo/M18yG4ZsIITNusTvRLUDXWTek="
        }, {
          "num_cand": "U2FsdGVkX191hjabpT70mu4Z3s+KLjn7GFng5KpL0ts=",
          "cpf": "U2FsdGVkX1+GMbCAkQcrywgPn1/4cmGsm6FPOx1LhUk="
        }, {
          "num_cand": "U2FsdGVkX19BYZJZaCYRjvW0iVPjCiycRLdHQQFA+Rk=",
          "cpf": "U2FsdGVkX1+JUgEltUzSEFMX7sIt8z46FRB+3qceh6I="
        }, {
          "num_cand": "U2FsdGVkX1/1ppTkfdDbP3iIv1StfmWS9cq1GBQzAT0=",
          "cpf": "U2FsdGVkX1+sKJMj4PNIX296EQhUoQLfgcpsDl++ndk="
        }, {
          "num_cand": "U2FsdGVkX19PIaxk8l1xVrTczKd/4sioBEoXTBsKvmY=",
          "cpf": "U2FsdGVkX1+MzyTFp1jadlqOd0II8P6O/mzGGfhS4gY="
        }, {
          "num_cand": "U2FsdGVkX1/4BrqtwIsxKn6EuQORwkveRWCtSZ0ys3M=",
          "cpf": "U2FsdGVkX19LwTy3ntdFOPrm2C9b0WMoMxQf1WEsCgQ="
        }, {
          "num_cand": "U2FsdGVkX1/9vrMDXIaM2olYUwLUSUgAngKNrrD8KpY=",
          "cpf": "U2FsdGVkX19Oqsk/AtHR7zLhx4025iLsS7u5De1v5oY="
        }, {
          "num_cand": "U2FsdGVkX188PKiZa8BVWyjz8/zuk3HL6tLIOWFzEK0=",
          "cpf": "U2FsdGVkX19hvV+5NJbiAmDlXrWrOnk//fpVSljWsCc="
        }, {
          "num_cand": "U2FsdGVkX18cFGHLt1NgnMZviAk+KXejgTCwyHz1U9Y=",
          "cpf": "U2FsdGVkX18M++TwykUTZcvHNuBw4le2KKMA8yW06GU="
        }, {
          "num_cand": "U2FsdGVkX19ANS/FPIXPUReVTp8buGAhcakznRucY2Q=",
          "cpf": "U2FsdGVkX1+/D4HH0nfXF77JacrkWNiB7Fg0jU49xdU="
        }, {
          "num_cand": "U2FsdGVkX18kL8sgM4Ygc2xnCN9WI5ejW9SomLMzvW4=",
          "cpf": "U2FsdGVkX18Djj4kvIq9VFrvSBPYJMeGDQag+uZYfgU="
        }, {
          "num_cand": "U2FsdGVkX1+sHYvr3dl+WAH0sUn/J4YslsMbm6jdGd0=",
          "cpf": "U2FsdGVkX19WWFCj3ctRI/UP3jxm3bDtuH6SJuf1XF0="
        }, {
          "num_cand": "U2FsdGVkX182YMl9+sFlue14K4P1oT9a2I1/oJ+tKTI=",
          "cpf": "U2FsdGVkX1/Myn/kZQtbp1qCstKIkpjTs6Ff1Fyq8VU="
        }, {
          "num_cand": "U2FsdGVkX19mFyaZBMNstjoXpRzIBIMBJ77f33fH3ls=",
          "cpf": "U2FsdGVkX18O90TzWHVtZU+uzzgheaPfa3dmHAjFjmQ="
        }, {
          "num_cand": "U2FsdGVkX1+BV6wwezEjbcIgN/pMS/1P/cHXYG1zrOc=",
          "cpf": "U2FsdGVkX1/I1T3yAQpS3geRDyecc7y0+SMS3I1rH58="
        }, {
          "num_cand": "U2FsdGVkX194BgKYQNcZ/6NYe5ldR3y3MS+RRUmwRvA=",
          "cpf": "U2FsdGVkX1+5vR7hWDG5M4jiJVrBWdAfw18CeEONUxU="
        }, {
          "num_cand": "U2FsdGVkX182e5I7mfvxrQvfwRUA6a3kZ8Ejg7EUlxc=",
          "cpf": "U2FsdGVkX18vR9D9QUd7xGQlP0bdDRRWMPiuMPJIEz0="
        }, {
          "num_cand": "U2FsdGVkX1+Mf5yn2GCFXCG+8NEi8ScT6sqwvf37i0M=",
          "cpf": "U2FsdGVkX19+1cYYV/CHQ6NFUF3WpXKuY2zBoj6sXRM="
        }, {
          "num_cand": "U2FsdGVkX1+eWnqLC6c18MHPz1eomxbYC2+QZaeVAZc=",
          "cpf": "U2FsdGVkX1/2m1h+QYxgHOs1DiecJtHkG+Saa7AoMPU="
        }, {
          "num_cand": "U2FsdGVkX1/dhht0JrxEL08Y9Cx0PDQspFN72F+/R04=",
          "cpf": "U2FsdGVkX19ADigT1sZmuCrm18Wf++bOkHp/04PU6ds="
        }, {
          "num_cand": "U2FsdGVkX1+DgFqTZZMasKl3x55ia/ynS/2KtSvWM5k=",
          "cpf": "U2FsdGVkX19Ndg2b7f43Q954UUtWWgycSVpA7R8IWQg="
        }, {
          "num_cand": "U2FsdGVkX18kyUXBp9FYoUMalvBCK9/hK7sDZouCNoo=",
          "cpf": "U2FsdGVkX19v2WPt2av296/A+cE/rbYf/xVy25m7+mQ="
        }, {
          "num_cand": "U2FsdGVkX1//ccII754PQghjwTj+TYG8R4mVYuIxpRk=",
          "cpf": "U2FsdGVkX1/tf/HpcL0klncsKAqywKiHp7eMugYv8cs="
        }, {
          "num_cand": "U2FsdGVkX1/d7dhQJuHkd4rXu+22HiTW93w9m6BasMw=",
          "cpf": "U2FsdGVkX1+W7rlGb/G7gfsJoCA1gtlQJlHjmErUSe4="
        }, {
          "num_cand": "U2FsdGVkX1/Vt1/kVtFN8ajOgXl7dk8dafcQVFkBCqs=",
          "cpf": "U2FsdGVkX19bloO7GWrbf8V65aRIW9x1cHGqB02KE1s="
        }, {
          "num_cand": "U2FsdGVkX19sIClLL42yUtEjjsFtGyL1ue2tZDqpo3Q=",
          "cpf": "U2FsdGVkX1/6Vs8ziSaaCfdAIVR+U6NdsdRTK7G924U="
        }, {
          "num_cand": "U2FsdGVkX19mXAx8qDtz8PMxwC9C91nWUIDP+rUdVxA=",
          "cpf": "U2FsdGVkX1+iNIFViewYkkmCLkqpviT4DEqq8clRwZ4="
        }, {
          "num_cand": "U2FsdGVkX1+L0EIQkLDJg0e/vW0esCFnPdyFcMepFFc=",
          "cpf": "U2FsdGVkX19/DXG34/5XfgVLjSdvwigoj4dhtQyM55E="
        }, {
          "num_cand": "U2FsdGVkX1+fkSH+IXzAskTQpbFh7fWjQgncDIEDrQQ=",
          "cpf": "U2FsdGVkX19VLm0R8yZiSBX+JJJyo+SPiM0J3rpR5ZU="
        }, {
          "num_cand": "U2FsdGVkX199YYrzk3ysdMrXm3WZQ0Tow21OcgI9uU4=",
          "cpf": "U2FsdGVkX18FyZi76hmpABSXRmSVJwOx9C+11PO+Hbc="
        }, {
          "num_cand": "U2FsdGVkX1+hQ1C6g3RP5VGyJ/UlOvbX623wsWVQjag=",
          "cpf": "U2FsdGVkX192JSLvpxTlwRNvGa5iPmZwk4G9vgvZr9c="
        }, {
          "num_cand": "U2FsdGVkX19Tq1n9KHS7vBR3V70tJQyURg2CR/m/Vsg=",
          "cpf": "U2FsdGVkX19XBrjTNlS/+O57+vQwgt3tpLEPS/88AfY="
        }, {
          "num_cand": "U2FsdGVkX1+q+f1bXmdi9ziVZ8wWdu5YvMdwSCyfH4Y=",
          "cpf": "U2FsdGVkX1/OlcCTBDJfsRXj3Iu+ukeXkOPG01CKwmY="
        }, {
          "num_cand": "U2FsdGVkX18eGtib1dH9MAem1AnpwVhNqP8OiXzeN9U=",
          "cpf": "U2FsdGVkX1+RFX6pzyy8oc7DvABnJkbRzan8IiWtOxE="
        }, {
          "num_cand": "U2FsdGVkX1/5mJRQJyTeBOcdUP5xQlc7NYFUIlEinfw=",
          "cpf": "U2FsdGVkX191LasGkh+8n9tzaZPfoGbp+ktRow1VgsY="
        }, {
          "num_cand": "U2FsdGVkX1/c0WQKo3+E02orCuPkveAiBnuInCSVB20=",
          "cpf": "U2FsdGVkX1+fQIjMBNSX4qwAgQlO5kImkLNY2P76uBs="
        }, {
          "num_cand": "U2FsdGVkX18bcHdOqqw+VR+Bfnk8Q/DuFAuRdN6cHrE=",
          "cpf": "U2FsdGVkX1/cC9PjZaDGoqOckTic8SHcx6cYCsKeaZY="
        }, {
          "num_cand": "U2FsdGVkX18ipu8MjfAWKStABFnzOv6+9hYuxS6HxNM=",
          "cpf": "U2FsdGVkX1/VLoYteAmN6Ix4C3fRnuI3hOELKIHY+es="
        }, {
          "num_cand": "U2FsdGVkX1/b+4S4LxlHEltIKYEwwF8nWlpiEGAXJV8=",
          "cpf": "U2FsdGVkX182FrUCYofWTOJMG0RQZlvm5guvRZ02fa0="
        }, {
          "num_cand": "U2FsdGVkX18L74th9rsjdTa6XKz32pd8m3IY88kbsB4=",
          "cpf": "U2FsdGVkX1/zP3VZ7JEHHy4293qMPtA+zucFeq4utXY="
        }, {
          "num_cand": "U2FsdGVkX1/9o0uxxTfd7sD5lSjOda5TmdYqpU5H3ZM=",
          "cpf": "U2FsdGVkX199Wfb7Jm7opljGB5nrm49oa11UcODMXJQ="
        }, {
          "num_cand": "U2FsdGVkX1/K0Xqr+p7ADbNKkLPRaJJTxmF6HpaqhqU=",
          "cpf": "U2FsdGVkX1/CKR+c0EHNK4pW7P5I5qQP9PNTJmbwGpY="
        }, {
          "num_cand": "U2FsdGVkX1/A1u1m84Si+YuDKnpg5T0HQtp2TWF0tu8=",
          "cpf": "U2FsdGVkX1+9SCvnVrsow2Ahlx72+evik00HcAiRSRU="
        }, {
          "num_cand": "U2FsdGVkX1+nNiJTdZSakAb7CmewxLkvZ2MwEnHT+18=",
          "cpf": "U2FsdGVkX1/eSL+tbtnCnaZXtTt9MfJbC3UMEgwU/kU="
        }, {
          "num_cand": "U2FsdGVkX18SAqmysfkeO+9ON12fmwpclANxlXkNe0s=",
          "cpf": "U2FsdGVkX1+pUu2NQQA3RGZFPVIRP5fcRCsYPDnySBM="
        }, {
          "num_cand": "U2FsdGVkX191m8Qamqh+UvoRjONPvj/8hTvZmjTvrH4=",
          "cpf": "U2FsdGVkX19EZp7OMXWgUt6vre3SEH0WoYc6JMsvtGs="
        }, {
          "num_cand": "U2FsdGVkX18ijj1CLhF/fD+rbE5a73nF3QhlVBM1hkM=",
          "cpf": "U2FsdGVkX1/s2XWABMkMCki/CikQwP8IbfSrJWV3sLM="
        }, {
          "num_cand": "U2FsdGVkX198z02oi7cI5doDPQqyO5MKchai5BRtaso=",
          "cpf": "U2FsdGVkX1/ATLsW9UmQiLmtzHPRikNzy+Brge+LGYo="
        }, {
          "num_cand": "U2FsdGVkX1+Rcbok7atcvpMaP9XOFTDMKh4UsQYmDLg=",
          "cpf": "U2FsdGVkX19HTGZgGYxuE4W5PZI2S/NZs3qbbQAeVZY="
        }, {
          "num_cand": "U2FsdGVkX1/UiIUigCagk2B6K96JxJ9rhbP38oODuCs=",
          "cpf": "U2FsdGVkX1+grB6if5J6nZolRgbR9nvQEetj9U2/m1M="
        }, {
          "num_cand": "U2FsdGVkX1+e8coO7k0shl7eOiTJolEL5Z+qjMs0Vnc=",
          "cpf": "U2FsdGVkX19swNrLBuuJvo4kOz9BI02sBe9nmVDECWI="
        }, {
          "num_cand": "U2FsdGVkX1/SFwiqBKOW3MOgIIur1gR75zDWHZJUI4w=",
          "cpf": "U2FsdGVkX18uBHD+/mGc9TdshtOfZqhqVUilR0PDJgY="
        }, {
          "num_cand": "U2FsdGVkX19uui0iF9oFvIUh2s/r1XtxPNowk2CxloQ=",
          "cpf": "U2FsdGVkX1/yvW4ro2z0VRPrq61y3ZdPOha4jDspjCE="
        }, {
          "num_cand": "U2FsdGVkX18vVqktv69zYlk2eLHhAfu++2Ycy5c8+Es=",
          "cpf": "U2FsdGVkX18qJEKGmmbztpqMcx6Kzx/xTG2HpyRvP14="
        }, {
          "num_cand": "U2FsdGVkX18c3a0eTfeaNP77/iUEbA0MK9p0Pdh5dQY=",
          "cpf": "U2FsdGVkX1/L2jtenCx596+2oxlEgPrsqtK/XqEXBIU="
        }, {
          "num_cand": "U2FsdGVkX19cL0JY8WnlWuKF1MF68YYQ6vmL5hvXkzo=",
          "cpf": "U2FsdGVkX19Yuf2+S4tpCKXEl0RXflPulIjZwA9d1Hc="
        }, {
          "num_cand": "U2FsdGVkX19CymzEduhnNDJAI0tkp8th6FYKRCX7Lqg=",
          "cpf": "U2FsdGVkX19rN55w7IhoiDHdFp/iI7iISsRR2zhASDw="
        }, {
          "num_cand": "U2FsdGVkX1+aGjzYxTiKJU83hPdzDYj2YdUvuBYlkdI=",
          "cpf": "U2FsdGVkX1+kpgELlkC5fMaaLSO4l9fn4iGsYkiFi+4="
        }, {
          "num_cand": "U2FsdGVkX1/VOGP2GnTlrYgQxhMEGFeRvFSXCmlpItE=",
          "cpf": "U2FsdGVkX1/JncbAceCntU5Ofzif5RI/K5LFw9ER6qc="
        }, {
          "num_cand": "U2FsdGVkX1+ZhPXqGrHMDzLrXDvp6tDYajt0OuyEEPU=",
          "cpf": "U2FsdGVkX1+nMYwUiFYyXNE3fG+vo4OdTJDBc64Rt/0="
        }, {
          "num_cand": "U2FsdGVkX1+5Hyj2S9dkM/2IU+fqKfugI2z+3UrngrQ=",
          "cpf": "U2FsdGVkX18Wlf+93OSto7NvQd0pakdJ69S+1zquauo="
        }, {
          "num_cand": "U2FsdGVkX1+VBm/A1YhJOIGMDsxdvQlWOq5sluTGFTg=",
          "cpf": "U2FsdGVkX1+yA9ZT5DrWwqMGJ9yAeYb7k3dONkKHc+0="
        }, {
          "num_cand": "U2FsdGVkX188El7D78eCYCSMaMNsr8TAP8eGrzJpA34=",
          "cpf": "U2FsdGVkX19dnAN1Z/PNrEpE9TKHE7lr/yN2hfad8Rs="
        }, {
          "num_cand": "U2FsdGVkX1/BYwwTP77wz9O1vBmrAJOr48dHtzNv35s=",
          "cpf": "U2FsdGVkX1+i3K1fjCVWgouEABU8uE6P6kke36F9w2U="
        }, {
          "num_cand": "U2FsdGVkX19RJaKYcueysJUIanwNJ64G4qiNQbERK18=",
          "cpf": "U2FsdGVkX18AJ+q7NvtlWlTQDKJZwzGSknEI29o2Lb4="
        }, {
          "num_cand": "U2FsdGVkX18g9MeRTnWtFdmycJpwDGhv1YRy2dqdhrg=",
          "cpf": "U2FsdGVkX19CYs+lkIy6E1r0PvswZBLIdcZPvy+t0sQ="
        }, {
          "num_cand": "U2FsdGVkX18geAWuvCZouCjqivUNhV2oa7EtQAcaTW0=",
          "cpf": "U2FsdGVkX1/pdAOXloeGNLTCgjofIoJ+DAE0NBrBPms="
        }, {
          "num_cand": "U2FsdGVkX1+24Yr8rHTSgYITu61Sgl0d+Uw7d/PrcHQ=",
          "cpf": "U2FsdGVkX18EfrMd5cTvAox2rUxTZBvty+7pcQoGycg="
        }, {
          "num_cand": "U2FsdGVkX1/+mX70ORyYhqNClSWpCj1mN0b3IkfHjic=",
          "cpf": "U2FsdGVkX1+c4+rfYQolK/Cfft47iUZI055wbQaqC70="
        }, {
          "num_cand": "U2FsdGVkX1+ymeHd3o3z12S2AzmikB5xhXAsfEAOV7s=",
          "cpf": "U2FsdGVkX1+CwegxR5X2+8r2ew7jzYe9iAE9LH2ygWY="
        }, {
          "num_cand": "U2FsdGVkX18cIVomZrtsybXQK05RCneSPa1+Ifg+po0=",
          "cpf": "U2FsdGVkX1+nkCBw9I7+bjvsYEpl+uU7CWRa5W43+Y8="
        }, {
          "num_cand": "U2FsdGVkX196VW8VYcReEg+8ZXXxOqwUqOc0SmI5ZOA=",
          "cpf": "U2FsdGVkX18sQYFWMdTd/MKSX/qMI67xiep1Mehb2Z0="
        }, {
          "num_cand": "U2FsdGVkX19Amx+bsjhS9fMhBt4oXlm3rTg4V7r4r/o=",
          "cpf": "U2FsdGVkX1+J/AZVx/J5/nxFIdhbG0d/DCYxi9S0tHc="
        }, {
          "num_cand": "U2FsdGVkX18uxYN4RMXqJrFzOCys2FJkietuBx95l0c=",
          "cpf": "U2FsdGVkX1/IllRC2RH6OtvElsPpRTXdFQ1YQx3zhsI="
        }, {
          "num_cand": "U2FsdGVkX1/bD42zF2IqVUy+vwcSDL4hFbYC4bd2WFA=",
          "cpf": "U2FsdGVkX1+aZdPGmpRmp7n89Kl2D7b75auALInN+xY="
        }, {
          "num_cand": "U2FsdGVkX1/IOTVQlYzJCNI2c6p1hN1yCJ0JZqxO3Ek=",
          "cpf": "U2FsdGVkX1+beQ8sgBAQ6QUcbjbgs4ag8SSRn9mcrA8="
        }, {
          "num_cand": "U2FsdGVkX19OoVZagW6sfSbS8ztOeWueoZJOY/pP3Ik=",
          "cpf": "U2FsdGVkX19QL9sfOx68IL17sUziBT6RVZExjEpOU3U="
        }, {
          "num_cand": "U2FsdGVkX1/+p/Kr4s4FRmQh1waM1wgAzUU6AxULT+Y=",
          "cpf": "U2FsdGVkX18R6M0eIFLNUgC5ShfAr4zhWJtg25J3F1c="
        }, {
          "num_cand": "U2FsdGVkX1+mNXop13n8fiTO8se+bKgmsAbMn4YWMSQ=",
          "cpf": "U2FsdGVkX19AVxGvLFlTbYkWPxaWZLBYifCMhFlJRWU="
        }, {
          "num_cand": "U2FsdGVkX18ePHI5zRYAbUxCV1Mde8iONtlHXJj1DTs=",
          "cpf": "U2FsdGVkX18yg2x/xHIA0duuNBkqiA/dWC6Kib67pis="
        }, {
          "num_cand": "U2FsdGVkX1/UFvuMLYbLAYHKIrVsESPXwQkMdZVyV3w=",
          "cpf": "U2FsdGVkX19j+BGE1euNpdjW9pU+cVTXeZllJ9/+rBU="
        }, {
          "num_cand": "U2FsdGVkX1952w8dIHjpUGjgYgsWfUkFWC+VT2OUVok=",
          "cpf": "U2FsdGVkX1+2YtYpdoThIUcBERdHsANyYrJ0oj4L70M="
        }, {
          "num_cand": "U2FsdGVkX18NPqNEyBdSiDT4kJF6XbBWYF82PqoWHHo=",
          "cpf": "U2FsdGVkX1+nqWphJaffhxr+LhuMhZ5YJgzdNp0iZZo="
        }, {
          "num_cand": "U2FsdGVkX19FscqTHCHV1rffuRNyXquK/PBrBUZWgp4=",
          "cpf": "U2FsdGVkX198i1UnnpwYcgnmhri1yVPuXA3SXlxQtD4="
        }, {
          "num_cand": "U2FsdGVkX18uBI+a/q37jkTnTZwscz7mR5GL6945Y00=",
          "cpf": "U2FsdGVkX19zdEe4idPU1IWxLuLmNmpRtAtPSgDuVhw="
        }, {
          "num_cand": "U2FsdGVkX1+UpwCg+8rLMjV9kv33LXiyYYeTJz2UtK4=",
          "cpf": "U2FsdGVkX19XCXUoHdtDJgjcq/dS5JvIayJxSrWIczM="
        }, {
          "num_cand": "U2FsdGVkX1+UC5GyTcJ1oBfbAHQpQjESmS/3YBbNie0=",
          "cpf": "U2FsdGVkX1888ps1GOf+mz20GLL1Gu7A2YEPfJSWjp0="
        }, {
          "num_cand": "U2FsdGVkX19V/OzepV9KcVW2BsN5OgW2z4Ehllr+U8k=",
          "cpf": "U2FsdGVkX18XuyYX8/B8auUFST73Okb3e4woVpt8bys="
        }, {
          "num_cand": "U2FsdGVkX1/2gFZ4+Q5d0FX0a0E9CMLwvkoLcTCyzck=",
          "cpf": "U2FsdGVkX1/PM3rdufMdLbwW+Y+B6OR1+IERx/SOWwI="
        }, {
          "num_cand": "U2FsdGVkX1/8OBvD+kDTgsQba15bQYJKsyWsYCyXZ2Y=",
          "cpf": "U2FsdGVkX1+ZvdyXbklOb9Yz9zlpksrWgfc1vZUM4So="
        }, {
          "num_cand": "U2FsdGVkX18jAiyi9Qq+YlN2fM/ytc1xS7zcMA1kozc=",
          "cpf": "U2FsdGVkX1841vdEr8q+n3GLpTuarTyNpeMdPxZAAeo="
        }, {
          "num_cand": "U2FsdGVkX19x9RGNDyF42+4tM8yHI9KZe9yr93oN6Q0=",
          "cpf": "U2FsdGVkX18fmB2F0R59gfR+4z2HEy7uArgW6CSEA1g="
        }, {
          "num_cand": "U2FsdGVkX19q56SpnH/HIKhF88mhqWLO1sqdKUEVPn8=",
          "cpf": "U2FsdGVkX1/tTDSJXo548eJG82pFRWB0hJyAI5U6e74="
        }, {
          "num_cand": "U2FsdGVkX197xtwMx40AhIVf8gzSn6abBYAiblydvc8=",
          "cpf": "U2FsdGVkX18SrOcXKYf/IJHV5ITL0UGiSMEVOBOvCg0="
        }, {
          "num_cand": "U2FsdGVkX19E0pi5VOnY3TNplsqT+JfWwctCOUbVBEk=",
          "cpf": "U2FsdGVkX1/KbJfQzWoRPGrT5c6zkMCS15A7uLzdDGc="
        }, {
          "num_cand": "U2FsdGVkX18Xx9I4/WlzByEspUanOOnkLy2rpYHOvwQ=",
          "cpf": "U2FsdGVkX19eWsfGwJ2m4cp4RfMPEkYY4+z/1KXRc8k="
        }, {
          "num_cand": "U2FsdGVkX1+8kIi8VbuYh47yKt67y22n8dHLYgfw3pA=",
          "cpf": "U2FsdGVkX18RfFPfdQsLCXvmZimZ2OqZns0uNxSJzuY="
        }, {
          "num_cand": "U2FsdGVkX1/QBlAbpl6ECeklUbsveQ7wutS3wAfCJis=",
          "cpf": "U2FsdGVkX19n9uq/sWA8DvmZzQ/cmdRhBRbEjVDRmHk="
        }, {
          "num_cand": "U2FsdGVkX18oZLwvku4zJqXOpgXwe8LuxdByR3fz/2o=",
          "cpf": "U2FsdGVkX1+vVHUCxLlEulL3JKDkkckOmER24aFIsOw="
        }, {
          "num_cand": "U2FsdGVkX18yd/HTRVNgodx9xmg+oG4/iaaS+taw414=",
          "cpf": "U2FsdGVkX1/YG/mQdW7G5zsTfWc9i+7l2ZbEEuWM/aU="
        }, {
          "num_cand": "U2FsdGVkX18DEW423boEKL81mFWPNQOiMopMdehuGf0=",
          "cpf": "U2FsdGVkX1/xTqsce79iZ+mfmrGMywxuQLitHEinMfc="
        }, {
          "num_cand": "U2FsdGVkX1+QW6Y23I5SH2sM79tbp6yaKEQ79ms1qS4=",
          "cpf": "U2FsdGVkX1+3tNgW7l6oTRABeyB0zvo98Z5rVdU/DGA="
        }, {
          "num_cand": "U2FsdGVkX1+D99ePJWefotZCB048IM3rUxhZLg8oD0U=",
          "cpf": "U2FsdGVkX189aMrID4NnaepGlNSVNcj26cGNKY+NP8Q="
        }, {
          "num_cand": "U2FsdGVkX19eInhqIpbGG5Mr4xQbgkQCUYltIjKGKqU=",
          "cpf": "U2FsdGVkX19wA5gDfUH021N8SCYynvYPdqhbzoxrv6w="
        }, {
          "num_cand": "U2FsdGVkX1/Ji6l8d+x3HBZJes4MEjXhP1rN39OmVe4=",
          "cpf": "U2FsdGVkX18ySrIu/vJo4HMjJhM5KPwLs3cX3Df60Xk="
        }, {
          "num_cand": "U2FsdGVkX1+4GovU9YY/OjzSA6KeyO6h/SLglxKcx+o=",
          "cpf": "U2FsdGVkX18p8cg5UHtJja8/hNmQ5CYw7n4GsYHDxNY="
        }, {
          "num_cand": "U2FsdGVkX184mtNT3A69mCHeMYMOyFw9nObD8+WHv/4=",
          "cpf": "U2FsdGVkX189W3Ii2qlIwlHtWTLyk2UvW2kx1qJBOQM="
        }, {
          "num_cand": "U2FsdGVkX19N46M3GouHD9s0AAOvl5+ODNWHpyxJyD4=",
          "cpf": "U2FsdGVkX1/vUpwA5Z6Cx5jX1F9mLvuZ+8Yi74QSdBs="
        }, {
          "num_cand": "U2FsdGVkX1/W7zBIxbgpTlR0GvjWuVAcQOwTNl5OtwA=",
          "cpf": "U2FsdGVkX18UOM0CbrTXJZTDDMVSKpPSeSCXjHMj5i8="
        }, {
          "num_cand": "U2FsdGVkX1/Gp+IALlGzyGBhAbpmyfPT+LwYpEPHxRg=",
          "cpf": "U2FsdGVkX19TBjpjpm271+NLFUnSQZihBN1O0Iq/Dng="
        }, {
          "num_cand": "U2FsdGVkX190aphdYq1jTZ8Pa1NwXfs9MJH+cqY2oX8=",
          "cpf": "U2FsdGVkX18fZmy8+v0NSa1RXcWbBHZ6Q0Td2g/ViNA="
        }, {
          "num_cand": "U2FsdGVkX18Z7iOeIWaJgzTmtPk/RQDUGpJ1yP1ufkM=",
          "cpf": "U2FsdGVkX1/+rF3OZSsA6qV3KQo8ypfFbk35q1d9mZ0="
        }, {
          "num_cand": "U2FsdGVkX19TB8/MDxsbncEln8oob2QO2Hxo+/I8t8s=",
          "cpf": "U2FsdGVkX18+4bqLO0UqbDiiHmD91WpZFfFgU/zhA+w="
        }, {
          "num_cand": "U2FsdGVkX18cU2CR0jZqHDExSXILh6ZI30szccpRaKM=",
          "cpf": "U2FsdGVkX19s2tvpttiDFxFu+ZowL5ZOi8RBhMvPON8="
        }, {
          "num_cand": "U2FsdGVkX1/CGdRphtQa1X/omu4UKgfTQldkQzSnpCY=",
          "cpf": "U2FsdGVkX1+FKVfRleCQwMC5lpPXKrAzeUycCQQ8OKk="
        }, {
          "num_cand": "U2FsdGVkX1+6JfgGpsBBZYmraC339+xMP+FUzM1M67M=",
          "cpf": "U2FsdGVkX198SZY6PNYEtCn7ukKxKqIqpwDwVkN8H7E="
        }, {
          "num_cand": "U2FsdGVkX19XB3UMiakA8v9zV3qdxQsUE1pO95b38Us=",
          "cpf": "U2FsdGVkX1+D+kcyIyIOf/gm3yxJ4poBeGbX6vwIbSU="
        }, {
          "num_cand": "U2FsdGVkX1+W/wh4Nj9Zfkd4WcMR4lduHx93K998Dcs=",
          "cpf": "U2FsdGVkX18F8lVCXw9HhRF0CQF2M2e7yzAhoTG27X4="
        }, {
          "num_cand": "U2FsdGVkX1+cr+Ywxr+a/VerOGjdhBEJspb/HsLTJ2s=",
          "cpf": "U2FsdGVkX19+0rfS4c6RwfJG/Jfxk517bwePK0Mgmto="
        }, {
          "num_cand": "U2FsdGVkX19jTmTui5S0pyfWno9daapPeaoc9l6R7xQ=",
          "cpf": "U2FsdGVkX18tvhV8DgMxd2dqcNXYCWJg5+e7PaG286Y="
        }, {
          "num_cand": "U2FsdGVkX1+SRWW4HIgzsvjy/FHG+1oY3g0PhKTuctY=",
          "cpf": "U2FsdGVkX1//RadChp93ldN19Ea4SFqMbkY5OFsGBLM="
        }, {
          "num_cand": "U2FsdGVkX187l1NpRdU7ZuX/7W24LBUsTFbUMzfEZNA=",
          "cpf": "U2FsdGVkX18MreM88hvhz1c1k5swRfkdQtFYO68rR0g="
        }, {
          "num_cand": "U2FsdGVkX1/QlYNk1GYlq0fPVOszPsoqocfZZJCtjYA=",
          "cpf": "U2FsdGVkX1+352k/ChNfZeQUZxAikH0RZiXZTKFhwqE="
        }, {
          "num_cand": "U2FsdGVkX1/JKbWSGmsnFSBBq0gGDqK1rUqPs2RdUKk=",
          "cpf": "U2FsdGVkX18prkdvRIX0On+EKW06hyj5ndhsEVPxK2Q="
        }, {
          "num_cand": "U2FsdGVkX1/DbtIqTLOCkjUGX+hoHDmC9rC28HuweSs=",
          "cpf": "U2FsdGVkX1+rIsBRl7LP8d6oIKDRyXXM8KRpZOx3hEs="
        }, {
          "num_cand": "U2FsdGVkX1/QXhJxL3ddC3OIT9DD9zEVzTafxoNrURg=",
          "cpf": "U2FsdGVkX1/H7NVzTaOCFxFPIaWTfIYKkqFB5MlEPCE="
        }, {
          "num_cand": "U2FsdGVkX1+0O6jIMJgmP/Oe+XCXiJCGiC9IaN5Mu7s=",
          "cpf": "U2FsdGVkX18eoWYo9sckkGfmHpu96Id2R1OfDFQMw9s="
        }, {
          "num_cand": "U2FsdGVkX19F6bFYCkLRmSTbcBdeD0i+LX27uvX2cwo=",
          "cpf": "U2FsdGVkX19LzCWHbs38aaQrVLvFvNO32o3ISD5OKL0="
        }, {
          "num_cand": "U2FsdGVkX18+AuYs188Lnrxd1YhFayZr6PWwsv98MeI=",
          "cpf": "U2FsdGVkX1+eAPpKu6qwaYzaTkZAYFSL+uro4PQGpoU="
        }, {
          "num_cand": "U2FsdGVkX19q+zIZAWfrthpsPlQ0uKlM8+IZTU/8U9A=",
          "cpf": "U2FsdGVkX191Jv3ify0SzTcsqBjPEX7o34MgYEbg+y8="
        }, {
          "num_cand": "U2FsdGVkX18XC4TYz/xjy0sb2/186v8jqFQt1vPOit8=",
          "cpf": "U2FsdGVkX192mbzSimPn1eMiz6ZRrSiW9MuzWxj0quI="
        }, {
          "num_cand": "U2FsdGVkX1+kfZlXaXMWrU8C5GRA4syYPjt0IWaGXcA=",
          "cpf": "U2FsdGVkX1/KQtyuZe0wVLY9noMjfll0A/e6OcxhXLo="
        }, {
          "num_cand": "U2FsdGVkX18LxjHN5CUUBBdiKzHRig7kB6HhP+4ri8s=",
          "cpf": "U2FsdGVkX18Z+zbiNe9bHj0aMyJAc3xFRn7oK4xhgwM="
        }, {
          "num_cand": "U2FsdGVkX1+9BwEYuI7KvvbIjtSzElPfEczxpKX1hFs=",
          "cpf": "U2FsdGVkX1+Plc5HB11aVL6DdpLU88dwXc0bQ7ak7Ok="
        }, {
          "num_cand": "U2FsdGVkX1/xDorDESW4eIUZ0JTPkRDG08NrfpXgM1c=",
          "cpf": "U2FsdGVkX18mPy3tSe0P6AAa+KHTo3fVMNLX93jDmJI="
        }, {
          "num_cand": "U2FsdGVkX19GDswmqdiC7lMRbWi6R9fHjNstOY63tdw=",
          "cpf": "U2FsdGVkX1+67OJKiIlDaJycSAFxqUUqhvdJoMvDgqU="
        }, {
          "num_cand": "U2FsdGVkX18hEj9Gp/8d8vMPQyHcH0pcLdMVVE6sGIQ=",
          "cpf": "U2FsdGVkX18brNvdACfm/3UrlUYnZP+QEPN/Rb8IS5c="
        }, {
          "num_cand": "U2FsdGVkX18K+Pn36SQO08kzbtx8OvasZr5FCkoxeZY=",
          "cpf": "U2FsdGVkX1/YgmsgSKCZFn3kEcqcKzCH5VnFJRgVEf0="
        }, {
          "num_cand": "U2FsdGVkX19jE1bhDWKAIPkXg+t5nt9VuauA8sM9D2g=",
          "cpf": "U2FsdGVkX18DTQkAheiAzD+S9LvKrZU2hF23qOL4QjQ="
        }, {
          "num_cand": "U2FsdGVkX19w9OANcAc4jzdSk6T+91w9VDsKuKqKj3Y=",
          "cpf": "U2FsdGVkX18d0isewzdEIKD17k/pHJv1U+aS0xZ1KQ4="
        }, {
          "num_cand": "U2FsdGVkX1+dxCbCoh8HbWOJeBM6BgyMDv/Kb/qYeW8=",
          "cpf": "U2FsdGVkX1/awirryzgG5ImW2L8m/0xv2xNzT96FwxM="
        }, {
          "num_cand": "U2FsdGVkX1/6Cq0vlYaFTu7piUTtrtm5k1VvQGPq7Tg=",
          "cpf": "U2FsdGVkX1++LjQmrNrBnFctGJxXqv1xjwdA/cRVTWI="
        }, {
          "num_cand": "U2FsdGVkX1/KozVUHcB/y2fb7laby9eNhPvKP6hQjhQ=",
          "cpf": "U2FsdGVkX1+LpXjkN5N9C+HurTGDUziCijrYIYxpXnY="
        }, {
          "num_cand": "U2FsdGVkX1/WW0Wb8p0tDsG1rD4fQJGVEEd9FyLnFss=",
          "cpf": "U2FsdGVkX18J+i/Lvgo/hGKE45B8HtUXOwrggzDVO4Y="
        }, {
          "num_cand": "U2FsdGVkX19EiSvEFF+hpPonBccBNv56KGueuXPBDuc=",
          "cpf": "U2FsdGVkX19lPZReFm+f4kmPhNVkWt05ohrd5bpFYnQ="
        }, {
          "num_cand": "U2FsdGVkX1/WcgIi4tBOzulrvaKrRE2jDnw43m8qC+A=",
          "cpf": "U2FsdGVkX193ElEaBzrRdkihq5xux+KEfiidNWms3sk="
        }, {
          "num_cand": "U2FsdGVkX1/YvCBBoo5PRve9oU1xmWFoZjjVofnDHzs=",
          "cpf": "U2FsdGVkX1/E6vJsELIgDeZ0nRh0nMQ6q3RWvBjBA1U="
        }, {
          "num_cand": "U2FsdGVkX18SF3+UZzntqaHUBUpyd5FOPoW4mhZn3Hs=",
          "cpf": "U2FsdGVkX1/B7Ex0JIdhLBZQHDv2qU8X1sjQAFxi6Xw="
        }, {
          "num_cand": "U2FsdGVkX18lKg33gdfLVZdKfc36bIGNRKWGv/aqkm8=",
          "cpf": "U2FsdGVkX18YhowVDBF+F474VApDScJqfE4D7yMmFYI="
        }, {
          "num_cand": "U2FsdGVkX1+ZghKu5GQZc5JLtKBmueuC98X/iDtF2To=",
          "cpf": "U2FsdGVkX1+RAPOJV3GA++t0r9HAP6JdWsAqT0opxW8="
        }, {
          "num_cand": "U2FsdGVkX18iRNw8bDK2feLrtzJtqwOpupfNzLzO+QY=",
          "cpf": "U2FsdGVkX19tVheMiK2Ejn24DuGDYdDmVvttp2dhdnw="
        }, {
          "num_cand": "U2FsdGVkX19Ub+6CPcHX2WrwuapTzaw+ROO4EP+tfZU=",
          "cpf": "U2FsdGVkX192s+dllJkoCVKbFA7L1xV7UiHls/Z0AOE="
        }, {
          "num_cand": "U2FsdGVkX1+egekv0yY8HFDMY1hVj5sg5wcfEuPtab0=",
          "cpf": "U2FsdGVkX1+lZbUXvquPYv0Ic3NcCHSed3OVAIQ8Cmg="
        }, {
          "num_cand": "U2FsdGVkX1+UeHtmd0iS7PJ1aH6QPYDvGs/drpsbi3Q=",
          "cpf": "U2FsdGVkX18OSWa6+hMfhVhoKndUNUn/AsnJkBa5X5s="
        }, {
          "num_cand": "U2FsdGVkX1/VCDW9CCjtlH4PoEl3S6SMzCvUep8nFQk=",
          "cpf": "U2FsdGVkX18q65V9F2d7w0FoH/410zjkjbuW2UUhyZk="
        }, {
          "num_cand": "U2FsdGVkX186mAecvT2XvVj0s1Fg3RQmUbUFTkyZ89Q=",
          "cpf": "U2FsdGVkX1+CNJadxA2tYn3j5SewM3AKvsU8FDJO2G8="
        }, {
          "num_cand": "U2FsdGVkX1+NH9edcKb17ywOEnBYBynBOvj7Pb6jR58=",
          "cpf": "U2FsdGVkX18pQOmIJqPz8885u2eq/ocf/thllhjWF0U="
        }, {
          "num_cand": "U2FsdGVkX1/bk6IqwgXU2sH0BD21wW20nymN7jkYgb4=",
          "cpf": "U2FsdGVkX1/N33+eG80TiIzbRHoq8wz+g4pX412Mv7M="
        }, {
          "num_cand": "U2FsdGVkX1+YQNWrwM/UH6CghfIOrcNZ6CkOaEc5HpQ=",
          "cpf": "U2FsdGVkX19ZwG2gk3uPCoBgMAT+a6sd20f76o5SA74="
        }, {
          "num_cand": "U2FsdGVkX19UGjO2EVP16n1IyOG+JNLySf1lIWKtN8Q=",
          "cpf": "U2FsdGVkX1+smy8KXEQu8fqtqY+AHzZP094QAQoqjKM="
        }, {
          "num_cand": "U2FsdGVkX1+W9b/thvWIRdPFqlr0myjjbsokp3w8nHQ=",
          "cpf": "U2FsdGVkX19LWF2gOmqx7U/lvaHkvEZPbDEOFBCHvtA="
        }, {
          "num_cand": "U2FsdGVkX1/m49HopeEgTTUHyXfu9tNYI/cFm9V4e0I=",
          "cpf": "U2FsdGVkX1+djuF/S7+PGvkE47V9tz1T7q25Wuj59/k="
        }, {
          "num_cand": "U2FsdGVkX18uMnXH9GNtP4eU1d2x05S1nn6bUJc7m2M=",
          "cpf": "U2FsdGVkX1/xZZvvmklvRl61CgWAokJ2Z3kcI0tfxsA="
        }, {
          "num_cand": "U2FsdGVkX19DQhYNl8uZ0OKLLh3TLBCR+GGtzuI1p9o=",
          "cpf": "U2FsdGVkX1+328JdaeK8/iWw+B2502Oano/RP702QxU="
        }, {
          "num_cand": "U2FsdGVkX19m3JQfGYoGFvw/4hLEZZNvVBcN00UztDQ=",
          "cpf": "U2FsdGVkX1911zY9GxXoi0Ns/iV7QbxijjTUCLkIdcA="
        }, {
          "num_cand": "U2FsdGVkX1+5kLIbavJqhymBJ0PjABvN1Eg0vH9+488=",
          "cpf": "U2FsdGVkX19puyegcQPQXH2BlxL+UGHJiFpkZ8cM+5o="
        }, {
          "num_cand": "U2FsdGVkX18JBmMo3dARtSCHvDtC6+B2wFJMMmPmK58=",
          "cpf": "U2FsdGVkX19H2PdUA0WGb+i7I0EI+CA13b8EwIIj0QY="
        }, {
          "num_cand": "U2FsdGVkX1+EtKHyttwh1pKNg0q1kgLCxF/fC9WiYNg=",
          "cpf": "U2FsdGVkX1+fTx7KIpm/b4nOn0GvTrxpAyNCFlviWaU="
        }, {
          "num_cand": "U2FsdGVkX18uslucyPQJ+hXyMuYD1fRMczumOvDwUY0=",
          "cpf": "U2FsdGVkX1/KjfxN1iBiWjCEOaNeB+JW8+NS6dqTzwo="
        }, {
          "num_cand": "U2FsdGVkX19IhvsYNVlcgp/6cbx1lbPiDpg57GQ9ZEQ=",
          "cpf": "U2FsdGVkX1+JdgGhDbLSExqsQiNCupWVl5DWQdlXUEI="
        }, {
          "num_cand": "U2FsdGVkX1+AxbM4DszIutrFOlbSpCGrHbiIGGaHzhQ=",
          "cpf": "U2FsdGVkX188BJmW1jc2Y4cCiteooH9vy0NegWkRl4s="
        }, {
          "num_cand": "U2FsdGVkX1+B/GHY33m/Bua874LWHLyTTWPYAlTxHes=",
          "cpf": "U2FsdGVkX198D0oEd9kwx0dMUzWKqAl6II+vpmu625M="
        }, {
          "num_cand": "U2FsdGVkX19rT5J8/L1fla/7D+PR6IbZOFqi06AOtyw=",
          "cpf": "U2FsdGVkX1/KpdU3bS5AWSduRpnBbMuOWjsnsE1Uhdc="
        }, {
          "num_cand": "U2FsdGVkX19BgLb/m2f7cLtf7jVX7rd8FnLlktzWGVE=",
          "cpf": "U2FsdGVkX18pHiwp6q781t0kgCJ14UnVQKEUTsZCJfw="
        }, {
          "num_cand": "U2FsdGVkX1/DjlG477eXd7B6EX3ghnyIhv+17lrwFYw=",
          "cpf": "U2FsdGVkX1+aOy8PnJq5OusJ39speOGwfNxJX9hCaVI="
        }, {
          "num_cand": "U2FsdGVkX18koRWVg57l7X0dmmijQ1r8/frgf+z58nE=",
          "cpf": "U2FsdGVkX18Qp9ujJmb5vBo6OIV8fIl7gapXDYaugh0="
        }, {
          "num_cand": "U2FsdGVkX18CRYiMuxv9HuVYRF8Zh2Hd0Dtdmi/kxA0=",
          "cpf": "U2FsdGVkX19p5O8RUwMxCQg82hpLmrWHC8vChB0yMh8="
        }, {
          "num_cand": "U2FsdGVkX18X8SMB9qDUh8PpL17OXaZUQfHtY9lV0Ak=",
          "cpf": "U2FsdGVkX1/aIIIGUZo1i7LBTv8LsOf63vVW9wPg+sg="
        }, {
          "num_cand": "U2FsdGVkX18EVsZLUDa7KMItE8iEQZGcqiDLUbG/QvU=",
          "cpf": "U2FsdGVkX18AW4odUD5TFrZcXo2KvfX3jbN27dUSemM="
        }, {
          "num_cand": "U2FsdGVkX1+fhp7f8yTZmv5S83t7LWMIlVHOhoOUiiM=",
          "cpf": "U2FsdGVkX18RZJRujicotV5ezd94GfOpDJtBvAB7whM="
        }, {
          "num_cand": "U2FsdGVkX1/SMQwFiXSFs1tZ/mZ5q5xiuKyUOZwYlOs=",
          "cpf": "U2FsdGVkX1+T9dypgMCLEGrz51Y0Sca4lfjuFf0mCbE="
        }, {
          "num_cand": "U2FsdGVkX180G02H/AO6IeLXViOImAAsFd4LCcDTNwo=",
          "cpf": "U2FsdGVkX18yL/9lxXiJ5ML6Z9hNQomGx5kVDe13Be8="
        }, {
          "num_cand": "U2FsdGVkX1/k+f2+Lmk7AHRVN0c2OruduoFnFEx0n0w=",
          "cpf": "U2FsdGVkX185JYOhSCkLk6t3hWTq9x3YLdDcUR6zLFU="
        }, {
          "num_cand": "U2FsdGVkX1+kCKZ+yFt08OUaVPlnaVs5+CEezzsyh6U=",
          "cpf": "U2FsdGVkX184GVmPWvqy4gGt2CT0okSs9Ra1LiQUdoQ="
        }, {
          "num_cand": "U2FsdGVkX1/LakkueyGHKwgVbXcxDHNSraVevl12Q2Q=",
          "cpf": "U2FsdGVkX1/wMYgK272WC/eLwNJKgSc2WECNekrHar4="
        }, {
          "num_cand": "U2FsdGVkX1/aBMWdKe9lUX6/PkTYlgeCDMwShxq+VOA=",
          "cpf": "U2FsdGVkX1/Isq0ug5/3PiKUcs2YvhDuMtaa385SR4M="
        }, {
          "num_cand": "U2FsdGVkX1/gbeJIV/Mni4c+OrVnQMMByUpUVoqK5dM=",
          "cpf": "U2FsdGVkX19659IYZqtFyciwhBNvTzZjsP3GPpMQMaA="
        }, {
          "num_cand": "U2FsdGVkX19+TRN19LA+kKE+6sl/R2Kb8lJ2HiE++P0=",
          "cpf": "U2FsdGVkX1/joI6tadjiiXtotwMr2x+VSjoYNIiORiU="
        }, {
          "num_cand": "U2FsdGVkX1+N+dSEn8uDsQPsSmE3Qy63gWUv2YoR2aE=",
          "cpf": "U2FsdGVkX1+toGMunOCgKjAGdPqAf2acb2IzmfMPXvw="
        }, {
          "num_cand": "U2FsdGVkX19/DrbExBJwkwWSFN9ck4pH3QGAyrTFArs=",
          "cpf": "U2FsdGVkX18ydLubUYRePAOEzS2IAoUmCCMtI2y22Ms="
        }, {
          "num_cand": "U2FsdGVkX18JIRBEAFo1vacbal+1/LjoJqTxBSztyxc=",
          "cpf": "U2FsdGVkX19o17gT5Oidf6Y2Zka1G9nzggx7FjB3SBA="
        }, {
          "num_cand": "U2FsdGVkX18e9rVAMTHQTgMxmf2t3JEeq6qbLjzemA8=",
          "cpf": "U2FsdGVkX1+oA29Mu7AgTojmDxIhRZZgFF+IiNLmtEk="
        }, {
          "num_cand": "U2FsdGVkX1/E9hRQLhfL0o7ydw/E4X/0WghixW7yQ7E=",
          "cpf": "U2FsdGVkX19f3oDQUjLQLFTap74ixNagKl5dK7vtNE4="
        }, {
          "num_cand": "U2FsdGVkX19OWjKRgLk4/+75j4G2tIi7xUwN7i4j9WI=",
          "cpf": "U2FsdGVkX18Tmu+dk4VYm9w7BD81M0FuknQHKSR7Zos="
        }, {
          "num_cand": "U2FsdGVkX1+8UTlR3iXd5JgXaKLOHS2JWHlvxodxJ9A=",
          "cpf": "U2FsdGVkX18XcItSehtd8fhXT4nfjJTQ94LigK+JwCg="
        }, {
          "num_cand": "U2FsdGVkX19Z70RZ1i1N+5NONj6Mz8gKnBlB8Q9/ETc=",
          "cpf": "U2FsdGVkX19swjy2YpwbJJU1ZTr5WBmGER/1Lt9EYZQ="
        }, {
          "num_cand": "U2FsdGVkX18TqYMMvtf+tNfOUCIXz7hz3XfxQpTn8UU=",
          "cpf": "U2FsdGVkX19DpUTmPvJ6HIgR9HLX+V47g2EkL8MLOS8="
        }, {
          "num_cand": "U2FsdGVkX1/sXiIRqnPhNN+GJaN4E405xGjI5bF4JiY=",
          "cpf": "U2FsdGVkX19VGVZ1tIO1uyEM5g0FD5E+sr+BqgX87PU="
        }, {
          "num_cand": "U2FsdGVkX18SkYVdgqhDefUO6hofBfbasx1sDRrz1co=",
          "cpf": "U2FsdGVkX19mZ8Cn9GXQAtgXbhujWvfExPIpjuXW47U="
        }, {
          "num_cand": "U2FsdGVkX1+Omu8MehIdlaEB85GTnp5pjLxKPgA2doI=",
          "cpf": "U2FsdGVkX1/1bG0gxHZ22Fw1k0xUJfMzHpzp5sgxHUk="
        }, {
          "num_cand": "U2FsdGVkX184DK+oN7TJb6hL1qzH9vbg7s1p3aHKdYY=",
          "cpf": "U2FsdGVkX1/ZHQaEelRMpeGDMklh4+1chwK9BS2WK9Y="
        }, {
          "num_cand": "U2FsdGVkX19kK/lqyo5Dqi+jY3wy3ahz/nUkYj2D38M=",
          "cpf": "U2FsdGVkX1/vyP2DzomAOZW+UlIgjU97v8aqvATonYg="
        }, {
          "num_cand": "U2FsdGVkX19pUjBmPRKuFx5P5A+kPKW0LiQdV2/Tn3I=",
          "cpf": "U2FsdGVkX19qOiJ0xueqLeC5mIsRxKH/8xUIzzKVL34="
        }, {
          "num_cand": "U2FsdGVkX19RpjkdKN+D/gdHN64Zaqo4ozM8PbeN6a4=",
          "cpf": "U2FsdGVkX19b5ui/ychvLw+ZcUy8obiwdVDlfgDmYrw="
        }, {
          "num_cand": "U2FsdGVkX18FLGS+CVJHa6ikrzuZXAuDoQ9pWf2xEo4=",
          "cpf": "U2FsdGVkX1+KjnB5M6kOny8crp5B08USXKvn6U/efOk="
        }, {
          "num_cand": "U2FsdGVkX1+I0oJTrYJoUZpCAACoi+AsyFpBQi5pKKA=",
          "cpf": "U2FsdGVkX19sRb5OlK2HPwoHmdtEfo3DxBCuhSZMFMo="
        }, {
          "num_cand": "U2FsdGVkX19XLlSDbMLGGpNNO97L2NMP+d1lK5vd8Qo=",
          "cpf": "U2FsdGVkX18i9pJCUiw1+d28evXx/7M2L2J0pTqUtOQ="
        }, {
          "num_cand": "U2FsdGVkX19WOrNPqyi0OMPNsyJFh6BygoCA2+U7pEc=",
          "cpf": "U2FsdGVkX19+o+yBNci7qVFcL74+DyWKbgvs/34Np9M="
        }, {
          "num_cand": "U2FsdGVkX1+S3O4AL6dtxrv5nJ3TdXEdpboGFcvJva8=",
          "cpf": "U2FsdGVkX19j7uC2vxO6BRxg6eJAY/H/dsvRjYImneU="
        }, {
          "num_cand": "U2FsdGVkX1+B1n+BDamSylHoSWpitrmaYdWEANaz1CQ=",
          "cpf": "U2FsdGVkX18zqAsrTAK+w/0cnc9mimBnP3qLkrpAp/g="
        }, {
          "num_cand": "U2FsdGVkX18vm3s82IC9ly4nqQfsYqoqqd3U10Ot454=",
          "cpf": "U2FsdGVkX18/0mqNZPsENamFhyg3BQK6K5X8dRS8lyg="
        }, {
          "num_cand": "U2FsdGVkX1+iTZE2R+BsaAULwNdEdjcyzWjkXPay+Mc=",
          "cpf": "U2FsdGVkX1/ZXPytwLxUhzTKJhjfWOo9fjJebx6sqPE="
        }, {
          "num_cand": "U2FsdGVkX1+3L6RR41PW11XB+KdqG6AT+d9slTQXcdQ=",
          "cpf": "U2FsdGVkX19pdKKYieT3/c3TMx2jDs9onQ59N6wXfRg="
        }, {
          "num_cand": "U2FsdGVkX1+HXWoYetXG2REdM9IvLE1jWKNQyp+MrgM=",
          "cpf": "U2FsdGVkX18HdsT92LXKr0e9cm5ruAAnPL0CPUmZuVg="
        }, {
          "num_cand": "U2FsdGVkX18BoPu+qRAhB8Z/wH5lh6bmWignSCcwRuY=",
          "cpf": "U2FsdGVkX1/mhhAXB/OrftvvHr0/VCQo7TaYyJKMJTw="
        }, {
          "num_cand": "U2FsdGVkX1/EGorbNnKVRx0Oq5I3JEVQDCMiBIe9MMs=",
          "cpf": "U2FsdGVkX184CQJm0f+xKl1eFVICjqPz7rquM7fjKZA="
        }, {
          "num_cand": "U2FsdGVkX19A/KZPll0XFZSHx6NkAACwvUe0n0zbMwk=",
          "cpf": "U2FsdGVkX1+COxjJ2x9ubU9RlpR+TrxtBbdt45vUCEY="
        }, {
          "num_cand": "U2FsdGVkX19VrQwLvpusbn7XD3xPXMB8pLsGZgOpO5s=",
          "cpf": "U2FsdGVkX1+O+rng383jR372duI4BidC9D3u5U/I6DQ="
        }, {
          "num_cand": "U2FsdGVkX19sSWjHmw8pNNzJ5nZIbkUaj4mnJu7xaeM=",
          "cpf": "U2FsdGVkX19Ec9uO13gFGps49XaESGjSAc3ql/1D0E8="
        }, {
          "num_cand": "U2FsdGVkX1+JpgDQ8QsNG/Tn2UU5kqMnFeF0yy8wIAA=",
          "cpf": "U2FsdGVkX1/r3+3LbzjJYLRC6P/Pa8YK/7kErdsdtwU="
        }, {
          "num_cand": "U2FsdGVkX1+IFxXEu97OEoFJCRwDQC7niPiDk0iofxc=",
          "cpf": "U2FsdGVkX18uH3cX+21rKKwRmzk/Rncz0lzfeFt3720="
        }, {
          "num_cand": "U2FsdGVkX19kzrS5nnISevn6c74oE+JddDn9pOoFnxQ=",
          "cpf": "U2FsdGVkX1/F31Cci4I9DHHJrzwsM9Ohm8FQasovHBg="
        }, {
          "num_cand": "U2FsdGVkX1+RwQ6TXPOXO7jk72WLKKqOZS5UyWlywpY=",
          "cpf": "U2FsdGVkX1/6166kbLOgyX1qcpRtt2GUAUVIJzojR6s="
        }, {
          "num_cand": "U2FsdGVkX196rBhJyoFIY2khtBU+6zRTdORzTCiJhkQ=",
          "cpf": "U2FsdGVkX19I2X2tDqORvJ0WfVcK3BLYWDGVU+hFgto="
        }, {
          "num_cand": "U2FsdGVkX19q1dBlNjjHfS4Q4CFbL3pukSAl2KJ/pCg=",
          "cpf": "U2FsdGVkX1/S0bqeiCtbIF+HoN+4fFPk0R08Sr/SkQQ="
        }, {
          "num_cand": "U2FsdGVkX185Bgep7ceDHOkqPDDQqQ8dloIabz3Zmx0=",
          "cpf": "U2FsdGVkX1/bI6Kq/JMY+JsMqqt63hMMTOwoHK49Bcc="
        }, {
          "num_cand": "U2FsdGVkX1/w3X7/PodFfsZN0JD//MeKaWHi0LGpXjw=",
          "cpf": "U2FsdGVkX1+i+JgTRM68Hq0VvXZD5w8nOC10IZDl0Uc="
        }, {
          "num_cand": "U2FsdGVkX1+GDCF+KWa070tFePfX4pR8UnmmIDP3fLM=",
          "cpf": "U2FsdGVkX1/ug0Pn0r1lQzIK+eZamjG9ZAU+GEqKNv0="
        }, {
          "num_cand": "U2FsdGVkX18aWEwq6AYvEJx2/SmGml+X6CxU/4sB+xM=",
          "cpf": "U2FsdGVkX1/2+Nm7ycqwDmVVfsryVFtQfZoSAL1LOjw="
        }, {
          "num_cand": "U2FsdGVkX18SpQvEPJ2x7uir8N78CSajjGBlidW/Xkw=",
          "cpf": "U2FsdGVkX19Y36gV4D2/u5ayw6PmOL9XmdaWHDlPjso="
        }, {
          "num_cand": "U2FsdGVkX1/9EmhO+giupJl2/e66z5qw1j0nNH530cw=",
          "cpf": "U2FsdGVkX1/SthVAHbw4tVBb1mfaZLKJEr0/oL+e5/k="
        }, {
          "num_cand": "U2FsdGVkX19NdPn0myW0yjHXvlwiCdB2kWvcd2t2J04=",
          "cpf": "U2FsdGVkX1/z6Dcy/sMBjFBHawnTn8z3TJKw8Te86K8="
        }, {
          "num_cand": "U2FsdGVkX1+wZbQi1paAjVSMEeXEVH1cmhS7mOD91uM=",
          "cpf": "U2FsdGVkX1+r8UweQbLfj0LWLqOd6wA15NGTlZnl2Cc="
        }, {
          "num_cand": "U2FsdGVkX19k33HsG6X0k6PAXNg25SdKhpDqDNm7sAI=",
          "cpf": "U2FsdGVkX18MF7K2ACgbk3wxdoeeZttwFTXQ7NDZwKo="
        }, {
          "num_cand": "U2FsdGVkX18kpx5iEXZpa0MZ/fa7TRSEzGWDaL3q64E=",
          "cpf": "U2FsdGVkX18cvoyPUYGSxmlS1MRiIUW7bQ90xao6yYQ="
        }, {
          "num_cand": "U2FsdGVkX18PsC9yZQuAOJPzzy3eArzD5cOTsnZbJXY=",
          "cpf": "U2FsdGVkX1/7PT7b+fXvLiETYsytoNmsPV0ulqFdlFs="
        }, {
          "num_cand": "U2FsdGVkX1+oV8r83YBP+lfciImjpnE4PFUCnb1vJhw=",
          "cpf": "U2FsdGVkX1+nEYdQenpFNllVqiOou3pJQU4oYydzKT0="
        }, {
          "num_cand": "U2FsdGVkX1+eK/KxdmpKnPWyk4KZmcMvjl3lm4ehuZA=",
          "cpf": "U2FsdGVkX1+OZKDRADvB+IWC8Q8rnAUdbb69I6Q1zH4="
        }, {
          "num_cand": "U2FsdGVkX18wGqy7F20tmWSrRMiw9zB88q8e6oT5Wfc=",
          "cpf": "U2FsdGVkX1+4I2hOGnkqwXT4wGUyivkfE5n5FpcUVMA="
        }, {
          "num_cand": "U2FsdGVkX18SNAC9tVKCu73I7olwBgYtXS4JADy8pv8=",
          "cpf": "U2FsdGVkX19z5Ok11LrhT4GpLpimaD7I669K5UevQ1Y="
        }, {
          "num_cand": "U2FsdGVkX1+N7hbWgCknDokc9xItQ4i/1ZMHGIXwD7o=",
          "cpf": "U2FsdGVkX19D98Ozi2f8Dryyj+GihV0s4hIWEd21Uos="
        }, {
          "num_cand": "U2FsdGVkX186PdH6HMZPMJ5ayWBNfgJ4Ol/gxsK2JIk=",
          "cpf": "U2FsdGVkX18LbtRxm56hGuE2gSZXjpRCK7GwXWS/p9w="
        }, {
          "num_cand": "U2FsdGVkX1/43pvpIJQML9C17uFqYSdRti4qY4JD1fQ=",
          "cpf": "U2FsdGVkX18Fx8/V6u+bbyEC6ja574dpM3ammxl0JZU="
        }, {
          "num_cand": "U2FsdGVkX1/aqtC8cpOBaibvKbkadCvkBx2l9FlQ6cQ=",
          "cpf": "U2FsdGVkX1827/lJWr+PG4k5LF1ZGLdqnjeEbCYsFHQ="
        }, {
          "num_cand": "U2FsdGVkX1/EeITyFEpHlMNTAjHpdM2ybEstTW92iLI=",
          "cpf": "U2FsdGVkX1+SBkhYC8aIh15sxZyjPbOoFFjFZSBEX08="
        }, {
          "num_cand": "U2FsdGVkX19Lba/eACX4e4JSwJse2QhQiKKAIuxezVI=",
          "cpf": "U2FsdGVkX19ZDe88ssMiwVgdcME0jJ6IbX33VgpQJUw="
        }, {
          "num_cand": "U2FsdGVkX1/46swsGUy0LQEVTZ7xERlfp+8UMKNZv9w=",
          "cpf": "U2FsdGVkX1+vdSbcCVyo+NNIClWkW9bV4zoQpU3P86U="
        }, {
          "num_cand": "U2FsdGVkX18lmiDZjHQBh4Xv2tLGwVo7Hw5HnKaPjmY=",
          "cpf": "U2FsdGVkX1+Ux6czXadXu8XI0AhbQRlShOjVV2z2cXA="
        }, {
          "num_cand": "U2FsdGVkX1+s6XqnVuO+0S2uVxo448uEpMQKJB+mSjs=",
          "cpf": "U2FsdGVkX19U+WJJPnBvJW1OwV5QS2FhTY9CsFFl3U4="
        }, {
          "num_cand": "U2FsdGVkX188GC/PNRERDwzH9AXBTl30qRdAOLZAy38=",
          "cpf": "U2FsdGVkX188d9aAVCsBwxMP0eMigCSgE9ha+AV0Wu8="
        }, {
          "num_cand": "U2FsdGVkX18drypa4WBLodFluTKXw4bZevbpyrRynKc=",
          "cpf": "U2FsdGVkX1+tJTZoPLvd6+jHrD8Mx5ADp7cyjECxnUw="
        }, {
          "num_cand": "U2FsdGVkX18MUytAMey90PNxfppws+v+PkZTGAjvP2Q=",
          "cpf": "U2FsdGVkX1+KfEFvcErTnWl1hoeo6BcsahG8p1ULca8="
        }, {
          "num_cand": "U2FsdGVkX19kg0JK3MfqWP6/SWNrmNTOhUAMXgYY0lg=",
          "cpf": "U2FsdGVkX19njz0awxd8yBKoE4OMDZbsNWfU6vrc4UY="
        }, {
          "num_cand": "U2FsdGVkX19q/xhKJpFl27b3woPfhZBL0Qvky7jJWOo=",
          "cpf": "U2FsdGVkX18BcKbhUIGjCcN2ujct2iwbz6S9rYLKtpQ="
        }, {
          "num_cand": "U2FsdGVkX18FwmD3jIPY+5Da7aQFQBjrELwnGaGUvkM=",
          "cpf": "U2FsdGVkX1/5Ttnp5iwDCsot5kMalgqxXwDLWhQFWpo="
        }, {
          "num_cand": "U2FsdGVkX18TvAqcfzjA6lCgOABXm8v8EkKd+ucOhuI=",
          "cpf": "U2FsdGVkX19x65Jc7AgMCVsV3Tl3gsrBIAlnwbSOae4="
        }, {
          "num_cand": "U2FsdGVkX1/yAh7m27vkKyZRs+PNk4vmBAa2hZdXUzs=",
          "cpf": "U2FsdGVkX1+I3zMZE36RQ2z7Y30ymFed1184wAcyCJw="
        }, {
          "num_cand": "U2FsdGVkX1/Ho3gtnMvS537pb4rKXrAXnmN1v76vPwA=",
          "cpf": "U2FsdGVkX19enF34G6V3lR1cu1pQ3NXjetXGWan0vcE="
        }, {
          "num_cand": "U2FsdGVkX1+Ka55BqBSu043NdeTyYdSnKz73oUTRw6o=",
          "cpf": "U2FsdGVkX19S2OOn2E6pjw++K3uWIgumzG32soXkdlE="
        }, {
          "num_cand": "U2FsdGVkX18O5p2VlbXHvC5eD77v5h7ao2k6tpMIdcM=",
          "cpf": "U2FsdGVkX19VkezcLPw42umgOMBVFj8Qjr1HFsygZ8o="
        }, {
          "num_cand": "U2FsdGVkX1+h15NMObUX3l9ZTbNN5V6c7C0Jt0qINq8=",
          "cpf": "U2FsdGVkX1+nTGH2qAaa51A+soCP/ceEGNIhnt6zCAY="
        }, {
          "num_cand": "U2FsdGVkX1/gF7qrcVTtgtJpDk6xfbp1wkaYDZKTcd4=",
          "cpf": "U2FsdGVkX188ndQcO71w2/FgTWafRzWecUBirb5+2cc="
        }, {
          "num_cand": "U2FsdGVkX1/5JcXVqsBzCajlWt5dynnfHGUYYgyQ3F0=",
          "cpf": "U2FsdGVkX1/fJohaKb/ZlPf3pX0FfPSEMKtMAOzaxQI="
        }, {
          "num_cand": "U2FsdGVkX19W5WIw2qjdySiLdudZrQme/zF2QnkTcPE=",
          "cpf": "U2FsdGVkX18KQVN+/06zsK1ukmmZ8pGCQqZ8pwXv58c="
        }, {
          "num_cand": "U2FsdGVkX1/Dm//dtuboZwP3mbEsbe/AmuQK8h7G5fU=",
          "cpf": "U2FsdGVkX1/XPa6/hkxGw35EdfP6lZV8EtqFSHGEoF8="
        }, {
          "num_cand": "U2FsdGVkX1+YMCGC2J7/P68DTlSzMtMCEZl8PieSvQk=",
          "cpf": "U2FsdGVkX19/eJMrRutjfeVndRdYOEz8jkzuJFXQnMY="
        }, {
          "num_cand": "U2FsdGVkX19tPeWRGHBYp/cSaqYI67OahOpJzRFbxX4=",
          "cpf": "U2FsdGVkX18mhJMqzNDDQR7RJFZ6TmW1yVQyAY0rDE8="
        }, {
          "num_cand": "U2FsdGVkX18/WXlgRoOchC48G+NTbtNv7SYZJnl1riM=",
          "cpf": "U2FsdGVkX19+BAgBUUBa/1P8p0x1f/uLRiAnwZixM7s="
        }, {
          "num_cand": "U2FsdGVkX1/5iu34SiKpUKGRu4VHndkWjKUM9V9GLK0=",
          "cpf": "U2FsdGVkX1+iV2ABEmMBudKcXteoH9EbhJmDSFKg2w8="
        }, {
          "num_cand": "U2FsdGVkX18ujSYV/wnQw0Gb7gmIir3e5TKCaL5xF3I=",
          "cpf": "U2FsdGVkX18KFB9SQ6YuS9ZNxIJONGXC4ndSa+N/Dnk="
        }, {
          "num_cand": "U2FsdGVkX1/8Y+N29MQdbe1hXILjnfflUCPCr7F13Sw=",
          "cpf": "U2FsdGVkX18WU4DthZZheQY3OL05KFXCsB5aeY6fIiU="
        }, {
          "num_cand": "U2FsdGVkX1/3kx+OkAt6IhUhbF8bCz8sTkrwG8nymCM=",
          "cpf": "U2FsdGVkX18mq80AD0qGtV+uSw8vYqDHP9bWTaXINLQ="
        }, {
          "num_cand": "U2FsdGVkX194qwM2tm8xxWvEhFeiME/lXRNTosFmXYo=",
          "cpf": "U2FsdGVkX1+DWo2DleA7OO2BgG4+FEcYm0tkJGoStB0="
        }, {
          "num_cand": "U2FsdGVkX18FwT5uAUSUsw8WKmUALjkcaIAP32YysR0=",
          "cpf": "U2FsdGVkX1+oeJhfzBiXzQPSLawBXW50zVvQNzeu74Q="
        }, {
          "num_cand": "U2FsdGVkX1/j80kJtTpre+2WPoo17669iDCOf1XtImQ=",
          "cpf": "U2FsdGVkX18w5M68CGCe+xHq/DcvrccBfacn0SnILPw="
        }, {
          "num_cand": "U2FsdGVkX18ckSou1VuQxdw8qm/EQ1MgcqMgIklYems=",
          "cpf": "U2FsdGVkX19QpQH2d1L3HLUs1K4JlYmEdwLr3AKZU3k="
        }, {
          "num_cand": "U2FsdGVkX19gpVe0PzaeVQBs/zC7JpB6EyB8l6XF3/c=",
          "cpf": "U2FsdGVkX18s0uCW13UjOCvw7z/0qj82PDaBQGkCVYg="
        }, {
          "num_cand": "U2FsdGVkX19IHoFw/PivquRQDavzBC8GHpby3613wlQ=",
          "cpf": "U2FsdGVkX1/t/dqwOkGL148o0UmcD0P4q/gAkxYvKyw="
        }, {
          "num_cand": "U2FsdGVkX194diYOcY1xAX03+jH2SWdWMyHvK76Ehqg=",
          "cpf": "U2FsdGVkX18pdIPA/wtM03PT8HNWzO7zTO0Eq3kGhpE="
        }, {
          "num_cand": "U2FsdGVkX1/+H/3beoKgNI8vo2rHFe68wG42ZNM1DxM=",
          "cpf": "U2FsdGVkX1+bOmaN3WnfMFMsiZlRFpPjysALIBuuUqs="
        }, {
          "num_cand": "U2FsdGVkX1+AZRSf6XrNKdxL+1NJQhZA+txTAWsIG8Y=",
          "cpf": "U2FsdGVkX18oJ+KMI/cMF2jEEfaDEfeC19wSAGfNrEs="
        }, {
          "num_cand": "U2FsdGVkX1/QjAVoyyigj9S7MPWHLoBVsL30dU2Y+sw=",
          "cpf": "U2FsdGVkX19jVnO6LY5fGQGPZ2pRsIzdDItU0mz9vyY="
        }, {
          "num_cand": "U2FsdGVkX1+rSXk1oai1p320sz4jtiBcTAJN2ugPkIg=",
          "cpf": "U2FsdGVkX1/O5q0VGUzESQZ4m1m01PQcLd6I4owmtoA="
        }, {
          "num_cand": "U2FsdGVkX1/BdsRafMUnr9V07b1s+qVlnGlFNWSoQYE=",
          "cpf": "U2FsdGVkX1+8r6sM1uSvAWwJIXNKOvLFzENOqhBcTIA="
        }, {
          "num_cand": "U2FsdGVkX18uk4V2fvyNvjSC+2GOuOENlBVe8HslUG0=",
          "cpf": "U2FsdGVkX1/PJFdlg8Dulax64I7TDm9eF4FMJwWRWU8="
        }, {
          "num_cand": "U2FsdGVkX18QEq2XM2hDuBibOirTY9RvON24Hpp7t7s=",
          "cpf": "U2FsdGVkX1/7lun5uiH5BG+FwTjP58vCcr/fxzroHl4="
        }, {
          "num_cand": "U2FsdGVkX1/VFJGkXZ58OpfioqnqH/HZTBx8DkVrSEM=",
          "cpf": "U2FsdGVkX18mY3wYkoatUd1RvdzEu67ak1gnIOH9Q/4="
        }, {
          "num_cand": "U2FsdGVkX1/Xdogc84JA/SzdkE7VadgjslWnQOa/png=",
          "cpf": "U2FsdGVkX19t4fibxiWHWGubPlD0QMIN0r/6ukSBlqI="
        }, {
          "num_cand": "U2FsdGVkX1/uu/jIoNzea6ss7VSGwVPEVAqAaBKPJm4=",
          "cpf": "U2FsdGVkX1/oLWRWiHOT08kuBKA9ebolpmG37Zv4efo="
        }, {
          "num_cand": "U2FsdGVkX1+tiAkj8E3zAgQVjlCm0BtnoRD8lNdW2ZQ=",
          "cpf": "U2FsdGVkX1/tG6qSOai8QRgCvOrMxmHdqO9ehVhLe9o="
        }, {
          "num_cand": "U2FsdGVkX18xkmvcYO7hhfaU7Q1+6vU0G0snPbyoeuk=",
          "cpf": "U2FsdGVkX1/dt0Z9+TWBhoj4WIjvvRb6d7LGvSQqaIk="
        }, {
          "num_cand": "U2FsdGVkX19RYLx/MTpBlqDjn+p0QDt9VwGziTmOYdk=",
          "cpf": "U2FsdGVkX18M7mhPedO4M61JmYH147w3iUkXIyyy8vk="
        }, {
          "num_cand": "U2FsdGVkX19lNGJe/QvHLillwhZ09U/EsPHqzrm79KU=",
          "cpf": "U2FsdGVkX18bdvKPHB8rrTQ5CU50nuca40fgiFS5WYE="
        }, {
          "num_cand": "U2FsdGVkX1/+doncWjYelWdFS7hmzDvBqnmckzMhehc=",
          "cpf": "U2FsdGVkX19S9Iwik0Sztgr7Z4h22C0mgAZwxq1D/Sg="
        }, {
          "num_cand": "U2FsdGVkX1+z9t5q1QTqha5fwDsibFA+vlprtq7OXA8=",
          "cpf": "U2FsdGVkX19QeNSBcakDusM7iBSIu64AqVuMw5OWfY0="
        }, {
          "num_cand": "U2FsdGVkX1/+AqlZzS44Zv5TmH6192rxPqOPxzdXSZs=",
          "cpf": "U2FsdGVkX1/mC57ZQX+U/3Ocwug8zgVniRwlIv2HCss="
        }, {
          "num_cand": "U2FsdGVkX19ePoQEmDJ3CIPew2DxD8xrooA9ch6Y42c=",
          "cpf": "U2FsdGVkX1+BFPRJu0633rtS93zgaEzOP7RCwegHYf0="
        }, {
          "num_cand": "U2FsdGVkX1/4QqgphJSTmKgo+rdclMrrXQ8JbqbB7Ew=",
          "cpf": "U2FsdGVkX1+iZ0nIEafWQ2GLyymxhbbrtx9m3oTNZRQ="
        }, {
          "num_cand": "U2FsdGVkX19FTotCj/SCnLARwv6VZb7UFRKHzk0Bf8U=",
          "cpf": "U2FsdGVkX1+Yo1RZx0VCcXkcRp/B8GGi2JHHcKEmtp8="
        }, {
          "num_cand": "U2FsdGVkX19CE34SYHeupZmB+bRpG1CPXOyNTfrTM+8=",
          "cpf": "U2FsdGVkX1+5z0zR5//CksNe+dQODcOCNEr8GPJGsOM="
        }, {
          "num_cand": "U2FsdGVkX19dCX6QRP7Wi7kHuzqHQse5p1YR9NkTWOk=",
          "cpf": "U2FsdGVkX19N7RzJ4s3op3x1gH/ZEagJ8eIIUjTXVC8="
        }, {
          "num_cand": "U2FsdGVkX1/tdkh/JlOZbH36vRdImV3RhTdEe8lctdg=",
          "cpf": "U2FsdGVkX19BKxNWIevLY/D+qlI2RPHt1+TaQhpgdDc="
        }, {
          "num_cand": "U2FsdGVkX1/f3j4pLFPX3isTTriyv3hEme7lSVbu/NE=",
          "cpf": "U2FsdGVkX19DBBBj0In63q4Y9Pa8AQUkBffS8vQBMzk="
        }, {
          "num_cand": "U2FsdGVkX1/2b1wbETniOCAQUexupF9GhQZIAMe6cNU=",
          "cpf": "U2FsdGVkX1+YL0niFOmZhQzVeWVshpaDEsJJmqVLB8M="
        }, {
          "num_cand": "U2FsdGVkX1/vI3rQHcJqxFXMeDj8naHtdhjE76M+JgE=",
          "cpf": "U2FsdGVkX1/7s1bvRMk1xKBpqgwoYlEQRWSnh9DRAt0="
        }, {
          "num_cand": "U2FsdGVkX18KmVvSaYf8oqOnkDA82c7q8ReGW+gkPlk=",
          "cpf": "U2FsdGVkX1+Og51DEH3nT5KMzu4mgw0yi4/O+sts7hY="
        }, {
          "num_cand": "U2FsdGVkX190e4Gs7GTlfK4s5cZ8Uh91IvoXhBKXQfw=",
          "cpf": "U2FsdGVkX194QooSKYFfbOiU93NQUKPC4t//rSFv0VA="
        }, {
          "num_cand": "U2FsdGVkX18nfozDgw9OhnmpIbSj6tOD3pt6XRHHDuE=",
          "cpf": "U2FsdGVkX1/mQnkMeUJz93vxMromQeyEmMgZoFMsBNs="
        }, {
          "num_cand": "U2FsdGVkX1/gKlEcrhYXVUJSSLeJx6Pz7iM9KDHEMvI=",
          "cpf": "U2FsdGVkX183T2OxkyBDh9TAIGKCtis8h6DvVsQ8zv0="
        }, {
          "num_cand": "U2FsdGVkX1/tKDnAHqZca/hmpCQH8gktZpJ+Fy2rHUg=",
          "cpf": "U2FsdGVkX18ftTmprXcHnwmOJkE+8qEChiGo91lfBeo="
        }, {
          "num_cand": "U2FsdGVkX1/KDrHE2PmeVPDzsHGyUK99pDyngGc1Wwk=",
          "cpf": "U2FsdGVkX18Rq6e+8amPKWld2ka7m9ppJ7gjlZv3P0Q="
        }, {
          "num_cand": "U2FsdGVkX1/6Q1yDTPjcbVt4o++d2vewI0C7swUt6TM=",
          "cpf": "U2FsdGVkX1+LiKU8cygWN7mzMVfGTcqhD/NhlX7cZ0Q="
        }, {
          "num_cand": "U2FsdGVkX1/F1MQ7sRlIyWdjL6HH8+9C7vrQdd1QW40=",
          "cpf": "U2FsdGVkX1/Xr6YZW78uIJB9IGRXelWx+EGAG3cKvjE="
        }, {
          "num_cand": "U2FsdGVkX1/aggT5i7PRBiz3Fn5xlM6bPi85vICaBSc=",
          "cpf": "U2FsdGVkX19JhpQ8LoAGH3sCPX6NW7gLGKNxaM8oRoc="
        }, {
          "num_cand": "U2FsdGVkX1+q1MXBuVEjPP1REsZDCC0Rud9enCs2ODw=",
          "cpf": "U2FsdGVkX1+JdkOB8SMLgK/wwqvnpYFm1BfMVnK1jwE="
        }, {
          "num_cand": "U2FsdGVkX18LM0fYx/ncwlBlLzSabJilB6a6N57UJUo=",
          "cpf": "U2FsdGVkX19Eatkb46F939m4Ea4Vfs2R4RMn0XmSoVU="
        }, {
          "num_cand": "U2FsdGVkX1+EwfkE21PHqhNpJgVccUceWHTU/5h64ao=",
          "cpf": "U2FsdGVkX1/wD89Ug1IgDlr4zkY47Fvkf1o5ZgeFW2k="
        }, {
          "num_cand": "U2FsdGVkX1+wlL7ujXBJOvqQEFFzmkwJ5p6ziosuvGU=",
          "cpf": "U2FsdGVkX18YrKMGb5vese+I00I5aJxE5Fcf7RTBX0c="
        }, {
          "num_cand": "U2FsdGVkX18yLw0to/2Z7D2NvA0sIKEZRiKXp2yB15Q=",
          "cpf": "U2FsdGVkX18z6/LS8HoCHpms3DunjWw7fGmmjWOkxJs="
        }, {
          "num_cand": "U2FsdGVkX18t3694aPfoy13KV3rCHfnLYx2fQcra6Uw=",
          "cpf": "U2FsdGVkX19AuX8uxDIkRg48pBUqcpf2PZ9hefzkh3w="
        }, {
          "num_cand": "U2FsdGVkX18kkTXdSHhzQgU4DYEnI6fd/h2bAsyWj0w=",
          "cpf": "U2FsdGVkX1+Gig2c1ezt1nLCIOdUcz0Csn4lpxx0/9Q="
        }, {
          "num_cand": "U2FsdGVkX1+zv0W828gHqlDGGIPdVaKhpj7bIcUd4dc=",
          "cpf": "U2FsdGVkX192Z/IUvjzrpKa9lLaKf9Bj7B4aSHkIR+I="
        }, {
          "num_cand": "U2FsdGVkX19wqy4AfRMoyW4vlWHSXS5aUAT3r1nXGdU=",
          "cpf": "U2FsdGVkX19k3V+QZzCjlEWt7Y1rbokswltL7KE4szI="
        }, {
          "num_cand": "U2FsdGVkX1+/eA28QvZprG6YyLE9sdIGSB3SqRo6UJY=",
          "cpf": "U2FsdGVkX1/VNETktAEhvlJOBN82TZ/WFHM6GNzPlSs="
        }, {
          "num_cand": "U2FsdGVkX18GQXOc1kI5TWDNkPTY8/P52/x1/50uRnc=",
          "cpf": "U2FsdGVkX19UoNeW63e2sCS2IuibXraPz9a/5doCNes="
        }, {
          "num_cand": "U2FsdGVkX18x7Xc718hNqhX2SYlGGhrdHbMR9hC7Rko=",
          "cpf": "U2FsdGVkX19GfYTy/malIvA96USeFTUqw3JZATnMG8I="
        }, {
          "num_cand": "U2FsdGVkX1+mr/4gBjNSapbIjg5c185fCv3PdYaYbGI=",
          "cpf": "U2FsdGVkX19FoadTUwlnuTfs2MztffMol4rt6WTSt0k="
        }, {
          "num_cand": "U2FsdGVkX19BDt/ja2pzGn3NDa2aqjGlJMFhu4lV31I=",
          "cpf": "U2FsdGVkX190S0lxyrMFa0wSRcEJIHnly0fXzdBoF6c="
        }, {
          "num_cand": "U2FsdGVkX1/oUgQI0izKhoAVjuj5LJg8IOrV1HAG1Ew=",
          "cpf": "U2FsdGVkX1/QPehEOBO3skcvkYuudZfYZwISqYe6ZGo="
        }, {
          "num_cand": "U2FsdGVkX1+U2O7in0OQ0sjr1pmouCXfOTL1WSfs6Gk=",
          "cpf": "U2FsdGVkX1+m39S4uAiWwnJ4szOeVhaiC08ZXnefh60="
        }, {
          "num_cand": "U2FsdGVkX1+p9Nha1tYPNgUNbfsm/jZhKp9V4k2d1ss=",
          "cpf": "U2FsdGVkX18jZFZvNjWoGff32auUpnOeehekEWjbSjQ="
        }, {
          "num_cand": "U2FsdGVkX1+nHlwGO2VfQ/UGAnVZ1vNbbQqaE5D32hI=",
          "cpf": "U2FsdGVkX1+clfnxUGPbVVVV3Lg7hw0hl5Dfl6dF5UA="
        }, {
          "num_cand": "U2FsdGVkX1/yD2PgyOfAT3mbXH6TyTXaGzbh0vauMhI=",
          "cpf": "U2FsdGVkX19lUMkHW1l7DjijanL2sJhxSA3WNbpTNKQ="
        }, {
          "num_cand": "U2FsdGVkX18xGSIHSkeMvEkVkFwBspjxBwZEcCZjJbM=",
          "cpf": "U2FsdGVkX18nnbkMOZqhcLER1RfJ/HDvhM493JYtH/c="
        }, {
          "num_cand": "U2FsdGVkX19hCSWuao7lOwruz5wLgkjmuC+h1ZxAiqU=",
          "cpf": "U2FsdGVkX18NhlR2qMT0FcI4Y6RfNW/sPzg6eOOFO6Y="
        }, {
          "num_cand": "U2FsdGVkX18alKbxS+W6oaGyqYVWwz9WDK8pjU5r9jU=",
          "cpf": "U2FsdGVkX1/kbmiDu0t6EBChomYfcPMkCJMRQ4YoJpg="
        }, {
          "num_cand": "U2FsdGVkX18zpcONhAXRuyGuPKF9VhiSkZp6y8Ah2c4=",
          "cpf": "U2FsdGVkX19Mv0JHNwAOUGQ0jto+6e3aSSygAnKH9Vo="
        }, {
          "num_cand": "U2FsdGVkX1+5lKhx9B5h0qPZNARArrv2YlG72awaiBs=",
          "cpf": "U2FsdGVkX18KDqWjO87D7W8jCL3HOCNJgKnXQDCEbsQ="
        }, {
          "num_cand": "U2FsdGVkX1+c3s1d9d/XfJd39GgODZzIy5dM8aRSUu4=",
          "cpf": "U2FsdGVkX191gTquLaEh4jmipqfnMSRmiNMrti8N1GQ="
        }, {
          "num_cand": "U2FsdGVkX1+wL7I63EihEGT4JZ5eGrs2zHIc3tt3QIw=",
          "cpf": "U2FsdGVkX1/xSv8QlyGDcliY0fbl2rCGB6mWlV2VoxU="
        }, {
          "num_cand": "U2FsdGVkX18LXBJRe5bPbf7ao0MwldH5Cfnh2CLlNc8=",
          "cpf": "U2FsdGVkX1+UeJpfQkfub2aUv1B3u97L1bmGJVpNAy0="
        }, {
          "num_cand": "U2FsdGVkX19n1h5LMD+t0I7NIlbLjsQj4OLC6Ap7LBk=",
          "cpf": "U2FsdGVkX1+Za1IA1bTwSAJ5NTsiKJv5Flj6uHneRZA="
        }, {
          "num_cand": "U2FsdGVkX1+hnUO03TuhF419hdeLtqoonHdgNHPJ+UI=",
          "cpf": "U2FsdGVkX19gvqKrwwOAOhieTsRcrkgYsNaU//PIUMQ="
        }, {
          "num_cand": "U2FsdGVkX19kYVy9x1teJ7TRy5e3GLGWWAm4LvDlN7U=",
          "cpf": "U2FsdGVkX1+CjC+Ujb8g1wX3ldx2vflv551COF00f7Q="
        }, {
          "num_cand": "U2FsdGVkX1+7a/HnGudHGL2MBzzvi3vxUKP41/kkPyA=",
          "cpf": "U2FsdGVkX1+xiwibY4Uew7iJrVA7+4VhzFWRC5FoqO0="
        }, {
          "num_cand": "U2FsdGVkX18vw5qdrkd4Q1JqFwf4UXHduGUQhw+BUho=",
          "cpf": "U2FsdGVkX18IuC/1ywnEz+WLRStR9FD4+815ewGpoFw="
        }, {
          "num_cand": "U2FsdGVkX1+rMEJqSeLRfUkGZq2NeMDWsZ/YYJxgjkI=",
          "cpf": "U2FsdGVkX19OGW2stfS8CWlI100iIrEc1MSfLesD9/c="
        }, {
          "num_cand": "U2FsdGVkX1+E6SGapqXBEU2KpSnN4oSbcrZz+4KBQZ8=",
          "cpf": "U2FsdGVkX1/Qf4zvzdDQ5dj/FkITdL+1EfO7+OFJwJ0="
        }, {
          "num_cand": "U2FsdGVkX18OchY6tbNkpIJpjFbm9jdFlgBvG7uk1L0=",
          "cpf": "U2FsdGVkX1+8iilMNs8cAi4TThfU89HNLNDxdVZnSkg="
        }, {
          "num_cand": "U2FsdGVkX18SCfHdmnM7n7U3iWN8TbkBbJ+2MbD5/nY=",
          "cpf": "U2FsdGVkX18ua9Sq8kco2+wb/Bh7gwLYBHoaPp9P47k="
        }, {
          "num_cand": "U2FsdGVkX19N/CSq3sExpAGhfdxPqcNQhM07D8X5bTk=",
          "cpf": "U2FsdGVkX18f2dNPA+NNbarefoKsjGoC/8UrBhGOXlw="
        }, {
          "num_cand": "U2FsdGVkX1/hmoG0JKff8kG4cMaR6oZb9jZ7WX2tTaI=",
          "cpf": "U2FsdGVkX1/qJS981NwZsf+IJj5BIaZIwZExGJy1Bj4="
        }, {
          "num_cand": "U2FsdGVkX198xZnA8lsMp4Za+zlC/5qKCJT1b+lFUu8=",
          "cpf": "U2FsdGVkX183Qj9PR77Z4TUL+WSQCpa/wolvUB8oh3o="
        }, {
          "num_cand": "U2FsdGVkX19T+sCac1xeljRyLynor20zj6O6hsFQhEc=",
          "cpf": "U2FsdGVkX1+vP1kKA2K6K4/QFzoTiFUeQMpR+FYUrYE="
        }, {
          "num_cand": "U2FsdGVkX18NBO3t5zWpVwqjHk5VayCsUImq9gwdKM0=",
          "cpf": "U2FsdGVkX199hPdkJRc/RCdGQxhHs2QJ3dH5iaVpEf0="
        }, {
          "num_cand": "U2FsdGVkX19vQUY2C6TX+LT9iu/bTsJgSauNETBSnLE=",
          "cpf": "U2FsdGVkX180F0v872PVQwykI/2EJQkEWf/QSzhX8R8="
        }, {
          "num_cand": "U2FsdGVkX1/mE1YxYrbZPXdKvcVQjwoKUEDVmqb+kIE=",
          "cpf": "U2FsdGVkX1/KieD4NXRhLsWfpaxqbaJEN4sBDW81K3c="
        }, {
          "num_cand": "U2FsdGVkX1+OLrnq22t1H84FHh++w1nm88qRpkmpnGM=",
          "cpf": "U2FsdGVkX1/RAVPmc8gp3VcqUT14BXHucU2s0+8dm9c="
        }, {
          "num_cand": "U2FsdGVkX19ropvDF5xNw3ltczxsg1AKMMByqLNNs1w=",
          "cpf": "U2FsdGVkX19X6s/c5BSD2CY4ByvlmoHMFmg1p0/O1z8="
        }, {
          "num_cand": "U2FsdGVkX1/rd9yJd/7oziTMU/Gh4z0SdSBFRjF8u3k=",
          "cpf": "U2FsdGVkX1+eGqHCu7GXlmV0yCW+0XAUN3IPnS7Sa7E="
        }, {
          "num_cand": "U2FsdGVkX19LcZGIKOXfuw+MBHeVpy0JVx0eeeSD2U8=",
          "cpf": "U2FsdGVkX1+kwhxQPN4+FnJjutbUawOWR6ywpMN6HGk="
        }, {
          "num_cand": "U2FsdGVkX18TAC5/26e0BIHw/du2fHOI1Sw8SSQKM9E=",
          "cpf": "U2FsdGVkX1/NpaZSx57UR9ggNgkEkTYpzSWf6YACCiQ="
        }, {
          "num_cand": "U2FsdGVkX1/+Jrhh5VW7hMA3fmLnFGZglIOiETyPQfI=",
          "cpf": "U2FsdGVkX194zDXW4w3Yj0pp6b0RbErMKkhaebZoY80="
        }, {
          "num_cand": "U2FsdGVkX1/mZyJNGU6hevd44HCxwoPLeVXMW1Wpp2s=",
          "cpf": "U2FsdGVkX1/O9RKaiyWZujydEAWBwxgoIcFgiwfOZkE="
        }, {
          "num_cand": "U2FsdGVkX1/AKJ3mIPeRAx2+sZUdJDZDKYNX5XkP/3I=",
          "cpf": "U2FsdGVkX1+ahJkUwOzXXCrv7GGRlijd7bQ0JaHi9ik="
        }, {
          "num_cand": "U2FsdGVkX18Fb09aj3L4XGb7kZr+/1KhepiT9UK9hwU=",
          "cpf": "U2FsdGVkX1+sa+6fi7tTU0NbOT0Zoe1zvzT0dp2jMas="
        }, {
          "num_cand": "U2FsdGVkX1//jwAGmA/04ymU9g1BgcUMhbSn8IzJta4=",
          "cpf": "U2FsdGVkX19OqihCW4k56XojC6OUyQtqWyGD6ZVp54k="
        }, {
          "num_cand": "U2FsdGVkX188zlLr0INy30XYC93F6/VD+WMmMXy2dBM=",
          "cpf": "U2FsdGVkX19/Ix8rV9JXNJepfVXfvBv2kCgMICVn4XQ="
        }, {
          "num_cand": "U2FsdGVkX19yA91PNHmQJwPc6ZuP74kdMsCxX2VN3u8=",
          "cpf": "U2FsdGVkX1+W9sYnke1KIWhMwCD1W3q0kLhA9vS20S8="
        }, {
          "num_cand": "U2FsdGVkX1+UZF/OgfmSxlkMDyk6IwMA7XefndH+dTM=",
          "cpf": "U2FsdGVkX1/gpbI5uHrdM0WI0IEUzCTVtVCGJAvDzb8="
        }, {
          "num_cand": "U2FsdGVkX1+f1U1p7PzQZKxJTM9uRZZbA3uYCgkEDSc=",
          "cpf": "U2FsdGVkX18Wqg2d0ZM4IueKeaR/OPFbTnHTVqTirKY="
        }, {
          "num_cand": "U2FsdGVkX188GAebPx1qwR8F0P50pjXDhAuKu2YlsBY=",
          "cpf": "U2FsdGVkX19pLHD95K7QVVP882Mmm7JB+M1ZrG9S4rk="
        }, {
          "num_cand": "U2FsdGVkX1/N5tOfLPQ+rGAA+TjFbq8hc/GIXWqMJpE=",
          "cpf": "U2FsdGVkX1+HXPKxZ9aWfZUxhz7SQaEKKSa7HOfJ1LI="
        }, {
          "num_cand": "U2FsdGVkX18Or+0Vkl2Ejsxega7h6mii2UvFW4vhjo4=",
          "cpf": "U2FsdGVkX19oEr7MGV7WBf9CRDNkS5w5Q3EDN//kDVI="
        }, {
          "num_cand": "U2FsdGVkX19i0RcNy7IYcnkKbHVgPkyQTOcP2inbWtU=",
          "cpf": "U2FsdGVkX18SLONsPN39EnTXSouTxM3tQ7LrF7vx6+U="
        }, {
          "num_cand": "U2FsdGVkX18T/DB2UproTruFMjnClpjkIalEIqPWVmo=",
          "cpf": "U2FsdGVkX1+s+e0+ShEagXEh4o9mrcf5jcsgdtPi/Hw="
        }, {
          "num_cand": "U2FsdGVkX1+WxsHQajUquBP/72Lqm9SX8DS5eQTftLI=",
          "cpf": "U2FsdGVkX18L3a1uK6fKMvNYcAvQEYgUMW511bxigeY="
        }, {
          "num_cand": "U2FsdGVkX193/s7AyrM+itNK3blGzW2pTdxp/a5icQ4=",
          "cpf": "U2FsdGVkX1/GR6Xip0mJ09MR7ki9P1jvp/8ckJU6GUA="
        }, {
          "num_cand": "U2FsdGVkX1/IPj3IdstFAeaIjIKMlsJsROlpOAZBWMI=",
          "cpf": "U2FsdGVkX1+iGn+voPXkuDJSl7sxIJqALEH/7RcqMso="
        }, {
          "num_cand": "U2FsdGVkX18+YE9pIhAyVyFArCrOl9ynB27nNBuVgjw=",
          "cpf": "U2FsdGVkX1+CJpSwJ4eFHInMaaQEVtNctiGNVJdaZ0g="
        }, {
          "num_cand": "U2FsdGVkX1+eOrDHI98Yk/1V6FsbqE+/W7oeh6+Mm2I=",
          "cpf": "U2FsdGVkX18Rvzv1maOdDU9i5kilohiZlBeDpdqD+iA="
        }, {
          "num_cand": "U2FsdGVkX18sWIJowcOEt2VurDU98oht82FGFPEmbno=",
          "cpf": "U2FsdGVkX1+xbs2dOa8F/XqA5avMCWT1oX3J9kloJSA="
        }, {
          "num_cand": "U2FsdGVkX1/7FXJ2m8VHqbHVHvbHiVI924I0giXLl+U=",
          "cpf": "U2FsdGVkX18h73a+cmue5nyUIsnhq1CMixzc01bYSl0="
        }, {
          "num_cand": "U2FsdGVkX1/wSM+SsZ2rHbLIPq9zL2TLKiUy9NZHv+0=",
          "cpf": "U2FsdGVkX1+jXacNekwhUmbfVpJFT+eKq5Q3z0vDchk="
        }, {
          "num_cand": "U2FsdGVkX18E6oTMSJ+nsqAlesHG3zgcip8A972tz+M=",
          "cpf": "U2FsdGVkX1+5gRbDrSycC9rRdobWP0gJ96N8SnWS6Mg="
        }, {
          "num_cand": "U2FsdGVkX1+jshbrd9N13VJ8z5VvMr15Dxc+S4aoucI=",
          "cpf": "U2FsdGVkX19meoiMsWZ8hz3JXVaFNKqR+xymFLkzhlI="
        }, {
          "num_cand": "U2FsdGVkX1/JAix7RqPTm/Ckj1p2/NrC7LaKlo1k2x0=",
          "cpf": "U2FsdGVkX19dj1aP92Hjs4VkYIrJePgUR8C0E5iwEf0="
        }, {
          "num_cand": "U2FsdGVkX1+Kq+OXzaJx96DPA84uIBe7XgVRYIkLQS8=",
          "cpf": "U2FsdGVkX19/0j7UZJXFrcnolRWBjpI8XInQ3bnv/Ew="
        }, {
          "num_cand": "U2FsdGVkX1/cEWx4Fnkz3kbVipgsQ/YKBHxwLEJIBEk=",
          "cpf": "U2FsdGVkX18XxZZoTlbACJ3Q06g7nUKI/qkaZ/K4VOo="
        }, {
          "num_cand": "U2FsdGVkX19IeIm6247AN1m8SWYDdTBmZwOjTTyflXg=",
          "cpf": "U2FsdGVkX18FULk8b7/Htb2LPk0Hpx45aIVh51QX7BY="
        }, {
          "num_cand": "U2FsdGVkX18WQBYArk5X4vS4+KBVSLVEaoNGsxsWTfU=",
          "cpf": "U2FsdGVkX1+E53I0gZLYiNUrp+t+aLRVmJXkAlxMau8="
        }, {
          "num_cand": "U2FsdGVkX1//OkNqZPRm9bbMxl5lIugnDhJV4pa70R0=",
          "cpf": "U2FsdGVkX18yahEM94rpa6FP9iGmiewL3S8yOBcKWfk="
        }, {
          "num_cand": "U2FsdGVkX19UI8okeiFxt4xACVetkdwIW9ZgQq7PU9c=",
          "cpf": "U2FsdGVkX1+sylE7DKY956LIDwEjkowSLuZDz3s6aAY="
        }, {
          "num_cand": "U2FsdGVkX1+yA+uePE/DdZNdyaUYUqXNEoJJ7Smq+1A=",
          "cpf": "U2FsdGVkX18BjaT+hN3DprFVVXO1XTilMZ4K9KHJrts="
        }, {
          "num_cand": "U2FsdGVkX19nOZ2w9aWBI/E8SE+VvYTSyijyGQhCbII=",
          "cpf": "U2FsdGVkX19AXsL36pIetGhpT7ZcAG2gCZXX1RTdWCw="
        }, {
          "num_cand": "U2FsdGVkX18tqNMUTzA8xW717+jHU1HRqQchUPM2Sqk=",
          "cpf": "U2FsdGVkX18M/xOdru06Qf3qxws5mGx96hsNBoxc/+Q="
        }, {
          "num_cand": "U2FsdGVkX19WIKQzXjdIgZSTeL2c6tcs9dfncS2qQNw=",
          "cpf": "U2FsdGVkX1/bjKGHUN3CNXo5eB8UwYVUnjp+F9V72E4="
        }, {
          "num_cand": "U2FsdGVkX19uzmYabvPc0mT9KdnktVLzNzDE8BFuPCI=",
          "cpf": "U2FsdGVkX18esj4WDVSTt6+B1a6olbjHCt+AUIcqxzU="
        }, {
          "num_cand": "U2FsdGVkX18iWNxQRb9LKDkzFuANfE+fpRVNNJzjl5g=",
          "cpf": "U2FsdGVkX1+MM/hvwZpgnQb33d8jkftNNOP5d3783RA="
        }, {
          "num_cand": "U2FsdGVkX1+Nj3EZ77g9jGzCGoTCsi+nKKxM/8K2wJc=",
          "cpf": "U2FsdGVkX19EtdZUaqrfalRAFIFkrL+ir5P/FGPMJco="
        }, {
          "num_cand": "U2FsdGVkX189bDke1etGFh0Ze3fbJwvyofP5trDSzGQ=",
          "cpf": "U2FsdGVkX1+SQCqFbd4uxiBu1ZWbJMLQ7GbPiA2EOec="
        }, {
          "num_cand": "U2FsdGVkX1/JSgCJq1FIqk397pKNJoeMnfsQpnIKz8E=",
          "cpf": "U2FsdGVkX1/F3Han0aCbptJWPeyHplRLepoES5FeIbw="
        }, {
          "num_cand": "U2FsdGVkX18KmcwzU0zBnTcqcrmdzdffwBTOb83KY38=",
          "cpf": "U2FsdGVkX19cFU9IKsYZQVays2H3G16R9glDenIG8m4="
        }, {
          "num_cand": "U2FsdGVkX18jEilJQ/t8yBPM+j35E9ERk5gSORYZKjc=",
          "cpf": "U2FsdGVkX18Tb7cxTGHRGzO9LWbCtw80NxKTV+hi5F4="
        }, {
          "num_cand": "U2FsdGVkX1/KXgS/013W95p1dj5/ku/+H6OXKRg2i5A=",
          "cpf": "U2FsdGVkX19YbhcsDabCD+DDUF9nJScW47LUnPvBoUw="
        }, {
          "num_cand": "U2FsdGVkX1+cqCcGHtdC0UeVxJvuZf/5rXIJY3P3HZ8=",
          "cpf": "U2FsdGVkX1/e081X0shKaUrOWsmby3xCRiMaCTJ8stE="
        }, {
          "num_cand": "U2FsdGVkX1+nlIQ7+sHv0KrukZgZbv4pKbLipTqI0Q0=",
          "cpf": "U2FsdGVkX19q1ebiaUc2/CHS+Euk6YWrEhU/B4Hk/Ek="
        }, {
          "num_cand": "U2FsdGVkX1/fuIdrfqGHvguWB/Hdp+lyPX1NrCMggIA=",
          "cpf": "U2FsdGVkX1/fsxG1F5jrt30wC/tkGcL111rxls1ub2I="
        }, {
          "num_cand": "U2FsdGVkX1+K691Yn54IQx8fmXUvAENQbv9qUwG0ePA=",
          "cpf": "U2FsdGVkX19wL8LGf53ax1LefcFR7rPWXP5lZlsXMsg="
        }, {
          "num_cand": "U2FsdGVkX1+g0scUrdKa9D57iuyoujXISThWPQ7aTto=",
          "cpf": "U2FsdGVkX19PRWPhckZYGIEKh5UTHkuiaxUgGhBmpD8="
        }, {
          "num_cand": "U2FsdGVkX18fLY5bS/+da1v+D1XTUr4AeKCM7IgdwAU=",
          "cpf": "U2FsdGVkX19E0IvAlIXPa3e4B8lFdyHnanVKhax3b4k="
        }, {
          "num_cand": "U2FsdGVkX19cEkcr5Z4kSYfKJexPX0dn2YN9ikU2KSU=",
          "cpf": "U2FsdGVkX1993dAkPtGGRtZIo6EkXNw7Y9zDSRYdKFw="
        }, {
          "num_cand": "U2FsdGVkX1/ukiEOhb7JZGJuytxOvRVBFlRQPyjFiAg=",
          "cpf": "U2FsdGVkX190tQvM1pFTjpWBrYsLakkqAQEy7HtDFFo="
        }, {
          "num_cand": "U2FsdGVkX19ULPaA++KzoD1c5Go5mzzXiu6P/cUg+c8=",
          "cpf": "U2FsdGVkX1+UuiUhdKVM9MjYpqqMTvXeyEn8S0l6EHA="
        }, {
          "num_cand": "U2FsdGVkX18rgjEi4TpCqdFvKuxxSfDHeTOnDN+27n0=",
          "cpf": "U2FsdGVkX1/SJTDpArvVwqA5X+XoMn5zaPtSCdFLTjM="
        }, {
          "num_cand": "U2FsdGVkX1/Pinojq0HZSYEJ9J4t8VXngFYtL0sAzqg=",
          "cpf": "U2FsdGVkX18sQEMk1ZbwM0LCRVhjnoyIt/b5rQu1KDo="
        }, {
          "num_cand": "U2FsdGVkX19V65CHrR6cojs24YBfkCF0Yejl4uPAciw=",
          "cpf": "U2FsdGVkX1/pQF0AHiQeQx0axAukPxNm+3lnHaQPLjI="
        }, {
          "num_cand": "U2FsdGVkX18C/kuq1afsv6RYskCDXd+JcqlLb3LNAfw=",
          "cpf": "U2FsdGVkX1+ZmDLkrLmycqoGbMUqgv89UsdrW6fmaxE="
        }, {
          "num_cand": "U2FsdGVkX1+PeQ8giy47HRPaOWZmZhLlsPSjYtN5cjY=",
          "cpf": "U2FsdGVkX19qhwj9337F2R+CvfdNO22rwsEwGysHI28="
        }, {
          "num_cand": "U2FsdGVkX19XcVm1GH3RFD6WtNg0PNyG0RqpjyJx8/U=",
          "cpf": "U2FsdGVkX181pAAM5D1s7WraZLrwawC+r5eedLDuvKA="
        }, {
          "num_cand": "U2FsdGVkX1+cGU5lxZh/HASn+mZxGqQmoCSNnl1fYdQ=",
          "cpf": "U2FsdGVkX193hhdF19kCXdnfKJUTEHOt7zsqfL+O+EQ="
        }, {
          "num_cand": "U2FsdGVkX1/ScI3K9ssVSGQVV76XubF9z9920pthnhI=",
          "cpf": "U2FsdGVkX1/fVoiQfHMEEz/Htc4bTuimn60l+7cOHg8="
        }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2203/2203_rec_gabs/${nome_arquivo}`)
            return window.location = (url);
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
